import AcknowledgmentModal from '@/components/AcknowledgmentModal';
import IncidentTimeline from '@/components/IncidentTimeline';
import ExerciseDiscussionGroup from '@/components/ExerciseDiscussionGroup';
import ExerciseTimelinePreview, { calculatePlanExecutionCompliance } from '@/components/ExerciseTimelinePreview';
import SimulationObjective from '@/components/SimulationObjective';
import ManualNotificationModal from '@/components/ManualNotificationModal';
import MyMap from '@/components/MyMap';
import IncidentResourcesPanel from '@/components/IncidentResourcesPanel';
import IncidentReadinessPanel from '@/components/IncidentReadinessModal';
import AuditLogWidget from '@/components/AuditLogWidget';
import AssignedRolesWidget from '@/components/AssignedRolesWidget';
import CollapsibleWidget from '@/components/CollapsibleWidget';
import ResolutionModal from '@/components/ResolutionModal';
import ExtensiveAnalysisModal from '@/components/ExtensiveAnalysisModal';
import IncidentCopilotPanel, { IncidentCopilotButton, isIncidentCopilotEligible } from '@/components/IncidentCopilotPanel';
import ResponseActionModal from '@/components/ResponseActionModal';
import StatusUpdateModal from '@/components/StatusUpdateModal';
import TimelineEntryModal from '@/components/TimelineEntryModal';
import ConditionalInjectPicker from '@/components/ConditionalInjectPicker';
import { db } from '@/firebase/firebase';
import { CommanServices, normalizeIncidentRecipientDirectory } from '@/services/commanServices';
import { JwtService } from '@/services/jwtapi';
import { formatTimestampWithSeconds, parseTimestamp } from '@/uitilites/utility';
import axios from "axios";
import { collection, onSnapshot, orderBy, query } from 'firebase/firestore';
import {
  AlertCircle,
  Bell,
  Calendar,
  CheckCircle,
  CheckCircle2,
  ClipboardList,
  Clock,
  Infinity,
  Archive,
  Download,
  FileText,
  Link2,
  MapPin,
  MessageCircle,
  Minus,
  Navigation,
  Paperclip,
  Phone,
  Plus,
  RefreshCw,
  Save,
  Rocket,
  FlaskConical,
  Sparkles,
  Timer,
  Users,
  X,
  Zap,
  Brain,
  ChevronDown,
  UserCircle2,
  Pencil,
  Target,
  Video,
  MessageSquare,
  Check,
  UserMinus,
  ClipboardCheck,
  Eye
} from 'lucide-react';
import { useCallback, useEffect, useLayoutEffect, useMemo, useRef, useState } from 'react';
import { Link, useLocation, useNavigate, useParams, useSearchParams } from 'react-router-dom';
import Logo from "../assets/Img/logo.png";
import { Badge } from "../components/ui/badge";
import { Button } from "../components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "../components/ui/card";
import { Input } from "../components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../components/ui/select";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "../components/ui/alert-dialog";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "../components/ui/dialog";
import { ApiEndPoint } from "../services/apiUttiLities";

import PrivateChatModal from '@/chat/PrivateChatModal';
import { buildChatWorkspaceUrl } from '@/chat/chatWorkspaceContext';
import LocationSelector from '@/components/LocationSelector';
import IncidentLocationMappingModal from '@/components/IncidentLocationMappingModal';
import socketService from "../services/socketService";
import MultiSelectDropdown from '@/components/MultiSelectDropdown';
import EmployeesPanel from '@/components/EmployeesPanel';
import ExerciseControlPanel from '@/components/ExerciseControlPanel';
import ExerciseHeaderControls from '@/components/ExerciseHeaderControls';
import CorrectiveActionsPanel from '@/components/CorrectiveActionsPanel';
import { cardHasRoles, cardIsFullyAssigned } from '@/components/RoleAssignmentPanel';
import { cleanRoles as cleanScenarioRoles } from '@/components/ScenarioRoleField';
import { toast } from 'sonner';
import ScenarioMapOfferPrompt from '@/components/ScenarioMapOfferPrompt';
import QuickAssignModal from '@/components/QuickAssignModal';
import AssignPersonnelModal, { PERSONNEL_ASSIGNMENTS_OPTIMISTIC_EVENT } from '@/components/AssignPersonnelModal';
import CrewStaffModal from '@/components/CrewStaffModal';
import TeamStaffModal from '@/components/TeamStaffModal';
import CreateTeamCrewDialog from '@/components/CreateTeamCrewDialog';
import CreateDepartmentDialog from '@/components/CreateDepartmentDialog';
import IncidentWeatherChip from '@/components/IncidentWeatherChip';
import GeoFenceModal from '@/components/GeoFenceModal';
import {
  announceIncidentTimelineChange,
  buildGeoFenceTargeting,
  isGeoFenceOperationalIncident,
  manualNotificationOutcome,
} from '@/components/geoFenceActions';
import { isInstitutionIncidentAdministrator } from '@/auth/incidentPermissions';
import AuthenticatedMedia, { AuthenticatedMediaLink } from '@/components/AuthenticatedMedia';
import { incidentMutationResult } from '@/utils/incidentMutationResult';
import {
  buildIncidentDefinitionChanges,
  canCorrectRealIncidentReport,
  realIncidentCorrectionLockReason,
} from '@/utils/incidentCorrectionPolicy';
import { incidentLocationLabel, relatedOrSameLocationIncidents } from '@/utils/relatedIncidents';
import { dispatchTimelineFocus } from '@/components/timelineFocusController';
import LiveActivityTimelineModal, { sortLiveActivityItems } from '@/components/LiveActivityTimelineModal';
import { buildIncidentDetailWidgetCatalog } from './incidentDetailWidgetCatalog';

/** Stable key for deduping the same file across incident payload, timeline, and chat */
function attachmentDedupeKey(att) {
  if (!att || typeof att !== 'object') return '';
  if (att.key) return `key:${String(att.key)}`;
  if (att.id) return `id:${String(att.id)}`;
  const u = att.url || att.s3_url || att.file_url || att.audio || '';
  return `url:${String(u).split('?')[0]}`;
}

const PAST_PLANNED_TIME_ERROR = 'Scheduled time cannot be in the past.';
const PLANNED_WINDOW_INCOMPLETE_ERROR = 'Please provide complete Start and End times for all planned windows.';
const PLANNED_END_BEFORE_START_ERROR = 'End time must be after start time.';
const AUTO_ACTIVATE_READINESS_WINDOWS = [2, 5, 10];
const readStoredWebUser = () => {
  if (typeof window === 'undefined') return null;
  try {
    const stored = window.localStorage.getItem('user');
    return stored ? JSON.parse(stored) : null;
  } catch (_) {
    return null;
  }
};
const normalizeAutoActivateReadinessWindow = (value) => {
  const minutes = Number(value);
  return AUTO_ACTIVATE_READINESS_WINDOWS.includes(minutes) ? minutes : 5;
};

const getLocalDateTimeInputValue = (date = new Date()) => {
  const pad = (n) => String(n).padStart(2, '0');
  const d = date instanceof Date ? date : new Date(date);
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
};

const isNaiveDateTimeLocal = (value) =>
  typeof value === 'string' && /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(:\d{2})?$/.test(value);

const parsePlannedDateTime = (value) => {
  if (!value) return null;
  if (value instanceof Date) return value;
  if (typeof value === 'string' && isNaiveDateTimeLocal(value)) {
    const date = new Date(value);
    return Number.isNaN(date.getTime()) ? null : date;
  }
  return parseTimestamp(value);
};

const formatPlannedDateTime = (value) => {
  const date = parsePlannedDateTime(value);
  if (!date || Number.isNaN(date.getTime())) return '—';
  return date.toLocaleString(undefined, {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: true,
  });
};

const formatWindowDuration = (start, end) => {
  const s = parsePlannedDateTime(start);
  const e = parsePlannedDateTime(end);
  if (!s || Number.isNaN(s.getTime()) || !e || Number.isNaN(e.getTime())) return '';
  let mins = Math.round((e.getTime() - s.getTime()) / 60000);
  if (mins <= 0) return '';
  const days = Math.floor(mins / 1440); mins -= days * 1440;
  const hours = Math.floor(mins / 60); mins -= hours * 60;
  const parts = [];
  if (days) parts.push(`${days}d`);
  if (hours) parts.push(`${hours}h`);
  if (mins) parts.push(`${mins}m`);
  return parts.join(' ') || '0m';
};

const liveActivityRowKey = (entry = {}) => {
  if (entry.type === 'related_incident') {
    return `related_incident:${entry.event_id || entry.incident?.id || entry.id || ''}`;
  }
  // A recovered legacy row can gain its missing item_id after the backend
  // safely matches it to a card. Its audit/message id is the stable identity,
  // so the corrected row must replace the stale generic row instead of being
  // rendered beside it as a duplicate.
  if (entry.id) return `${entry.type || ''}:${entry.id}`;
  return `${entry.type || ''}:${entry.item_id || ''}:${entry.created_at || ''}:${entry.message || ''}`;
};

const mergeLiveActivityRows = (...collections) => {
  const seen = new Set();
  const rows = [];
  collections.flat().forEach((entry) => {
    if (!entry) return;
    const key = liveActivityRowKey(entry);
    if (seen.has(key)) return;
    seen.add(key);
    rows.push(entry);
  });
  return sortLiveActivityItems(rows);
};

const RelatedIncidentsBanner = ({ incidents = [], incident, navigate, inRow = false }) => {
  const bannerClass = `bg-red-600 rounded-lg shadow-lg overflow-hidden ${inRow ? 'h-full' : 'mb-4'}`;
  const allRelated = relatedOrSameLocationIncidents(incidents, incident);
  const status = String(incident?.status || '').toLowerCase();
  const isExercise = !!incident?.is_exercise;
  const isDrill = isExercise && !incident?.is_scenario;
  const isRealIncident = !incident?.is_exercise && !incident?.is_scenario && !incident?.is_planned_event;
  const terminalStatuses = ['resolved', 'closed', 'completed', 'cancelled', 'canceled', 'false_alarm', 'false alarm'];
  const showPlanningActivity = isExercise && (
    status === 'requested' || incident?.is_scenario
  );
  const showResponderActivity = (isRealIncident && !terminalStatuses.includes(status))
    || (isDrill && status === 'active');
  const showActivityLine = showPlanningActivity || showResponderActivity;

  const [feed, setFeed] = useState([]);
  const feedIncidentIdRef = useRef('');
  const feedRefreshTimerRef = useRef(null);

  const loadFeed = useCallback(async (latestOnly = false) => {
    if (!showActivityLine || !incident?.id) {
      setFeed([]);
      return;
    }
    const requestedIncidentId = String(incident.id);
    try {
      const requests = [];
      const scope = latestOnly ? 'latest' : '';
      if (showPlanningActivity) requests.push(CommanServices.getIncidentActivityFeed(incident.id, '', scope));
      if (showResponderActivity) requests.push(CommanServices.getIncidentActivityFeed(incident.id, 'responder', scope));
      const results = await Promise.allSettled(requests);
      const fulfilledFeeds = results
        .filter((result) => result.status === 'fulfilled')
        .map((result) => result.value?.data ?? result.value)
        .filter((payload) => Array.isArray(payload?.feed));
      if (requests.length > 0 && fulfilledFeeds.length === 0) return;
      const seen = new Set();
      const merged = [];
      fulfilledFeeds.forEach((payload) => {
        (payload?.feed || []).forEach((entry) => {
          const key = liveActivityRowKey(entry);
          if (seen.has(key)) return;
          seen.add(key);
          merged.push(entry);
        });
      });
      if (feedIncidentIdRef.current === requestedIncidentId) {
        // Both full recovery and bounded realtime pages merge into what is
        // already visible. This prevents a fast socket event from superseding
        // the initial full-history request and losing older LIVE entries.
        setFeed((current) => mergeLiveActivityRows(merged, current));
      }
    } catch (e) {
      console.error('activity feed load failed', e);
    }
  }, [showActivityLine, showPlanningActivity, showResponderActivity, incident?.id]);

  useEffect(() => {
    const activeIncidentId = String(incident?.id || '');
    feedIncidentIdRef.current = activeIncidentId;
    setFeed([]);
    loadFeed(false);
    return () => {
      if (feedIncidentIdRef.current === activeIncidentId) {
        feedIncidentIdRef.current = '';
      }
    };
  }, [incident?.id, loadFeed]);
  useEffect(() => {
    const h = (event) => {
      const eventIncidentId = event?.detail?.incident_id || event?.detail?.incidentId;
      const changeType = String(event?.detail?.change_type || '');
      const canChangeRelatedActivity = [
        'incident_created',
        'incident_updated',
        'incident_deleted',
        'incident_archived',
      ].includes(changeType);
      if (
        eventIncidentId
        && String(eventIncidentId) !== String(incident?.id)
        && !canChangeRelatedActivity
      ) return;
      const latestOnly = event?.detail?.reason !== 'socket-reconnect';
      if (feedRefreshTimerRef.current) clearTimeout(feedRefreshTimerRef.current);
      feedRefreshTimerRef.current = setTimeout(() => {
        feedRefreshTimerRef.current = null;
        loadFeed(latestOnly);
      }, 150);
    };
    window.addEventListener('refresh-activity-feed', h);
    return () => {
      window.removeEventListener('refresh-activity-feed', h);
      if (feedRefreshTimerRef.current) clearTimeout(feedRefreshTimerRef.current);
      feedRefreshTimerRef.current = null;
    };
  }, [incident?.id, loadFeed]);

  const openFeedItem = (entry) => {
    if (entry.type === 'related_incident') {
      navigate(`/incident-details/${entry.incident.id}`);
    } else if (entry.type === 'responder_activity') {
      if (!entry.item_id) return;
      dispatchTimelineFocus({
        incidentId: incident?.id,
        itemId: entry.item_id,
        groupKey: entry.group,
        activity: { actor: entry.actor },
        reason: 'live-line-selection',
        pauseAfterFocus: true,
      });
    } else if (entry.type === 'comment') {
      dispatchTimelineFocus({
        incidentId: incident?.id,
        itemId: entry.item_id,
        groupKey: entry.group,
        reason: 'discussion-selection',
        pauseAfterFocus: true,
        openDiscussion: true,
      });
    } else if (entry.type === 'corrective_action' || entry.type === 'observation') {
      document.querySelector('[data-testid="widget-corrective-actions"]')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    } else if (entry.type === 'message' && entry.conversation_kind === 'dm' && entry.other_user_id) {
      navigate(buildChatWorkspaceUrl({
        incidentId: incident.id,
        isScenario: incident?.is_scenario === true,
        scenarioId: incident?.scenario_id,
      }), {
        state: {
          groupChatUsers: [{
            id: entry.other_user_id,
            name: entry.other_user_name || entry.author || 'App user',
          }],
        },
      });
    } else {
      navigate(buildChatWorkspaceUrl({
        incidentId: incident.id,
        isScenario: incident?.is_scenario === true,
        scenarioId: incident?.scenario_id,
        messageId: entry.id,
      }));
    }
  };

  if (!showActivityLine && allRelated.length === 0) return null;

  const currentIncidentId = String(incident?.id || '');
  const currentParentId = String(incident?.parent_incident_id || '');
  const relatedEntries = allRelated.map((relatedIncident) => {
    const relatedIncidentId = String(relatedIncident?.id || '');
    const reportedFromCurrent = String(relatedIncident?.parent_incident_id || '') === currentIncidentId;
    const isCurrentParent = !!currentParentId && relatedIncidentId === currentParentId;
    const relationship = reportedFromCurrent
      ? 'reported_from'
      : isCurrentParent
        ? 'parent_incident'
        : 'same_location';
    return {
      type: 'related_incident',
      id: relatedIncident.id,
      incident: relatedIncident,
      relationship,
      relationship_label: relationship === 'same_location'
        ? 'Same location'
        : relationship === 'reported_from'
          ? 'Reported from this incident'
          : 'Parent incident',
      location: incidentLocationLabel(relatedIncident),
      created_at: relatedIncident.created_at
        || relatedIncident.reported_at
        || relatedIncident.detected_at
        || relatedIncident.incident_time
        || relatedIncident.updated_at,
    };
  });
  const bannerItems = mergeLiveActivityRows(showActivityLine ? feed : [], relatedEntries);
  // The moving line is deliberately concise. The modal keeps the complete,
  // unduplicated activity list behind the LIVE chip.
  const marqueeSource = bannerItems.slice(0, 20);
  const marqueeItems = marqueeSource.length > 0 ? [...marqueeSource, ...marqueeSource] : [];

  return (
    <div className={bannerClass} data-testid="related-incidents-banner">
      <div className="flex items-center py-3 px-4 h-full">
        {showActivityLine ? (
          <LiveActivityTimelineModal items={bannerItems} onSelect={openFeedItem} />
        ) : (
          <div className="bg-white text-red-600 px-3 py-1 rounded-full text-xs font-bold mr-4 flex-shrink-0">
            {allRelated.length}
          </div>
        )}
        <div className="overflow-hidden flex-1">
          {bannerItems.length === 0 ? (
            <div className="flex items-center space-x-3 text-sm font-medium px-3 py-1" data-testid="activity-feed-empty">
              <Bell className="h-4 w-4 text-white animate-pulse" />
              <span className="whitespace-nowrap text-white">
                {showResponderActivity
                  ? 'Live activity — waiting for app-user responses'
                  : 'No comments or messages yet — discuss the scenario on the cards or in chat'}
              </span>
            </div>
          ) : (
            <div className="animate-marquee hover:pause-marquee flex space-x-8 whitespace-nowrap">
              {marqueeItems.map((entry, idx) => {
                const related = entry.type === 'related_incident' ? entry.incident : null;
                const location = entry.location || (related ? incidentLocationLabel(related) : '');
                return (
                <div
                  key={`${entry.type}-${entry.id}-${idx}`}
                  onClick={() => openFeedItem(entry)}
                  className="flex items-center space-x-2 text-sm font-medium cursor-pointer hover:bg-red-700 hover:bg-opacity-80 hover:rounded px-3 py-1 transition-all duration-200"
                  title={entry.type === 'responder_activity'
                    ? 'Focus this app-user activity in the timeline'
                    : entry.type === 'comment'
                      ? `Open discussion on ${entry.card_name}`
                      : related
                        ? `Open incident ${related.id}`
                        : 'Open activity'}
                  data-testid={`activity-feed-item-${entry.type}`}
                >
                  {entry.type === 'comment' ? (
                    <MessageCircle className="h-4 w-4 text-white flex-shrink-0" />
                  ) : entry.type === 'corrective_action' ? (
                    <ClipboardCheck className="h-4 w-4 text-white flex-shrink-0" />
                  ) : entry.type === 'observation' ? (
                    <Eye className="h-4 w-4 text-white flex-shrink-0" />
                  ) : entry.type === 'responder_activity' ? (
                    <Bell className="h-4 w-4 text-white animate-pulse flex-shrink-0" />
                  ) : related ? (
                    <Zap className="h-4 w-4 text-white animate-pulse flex-shrink-0" />
                  ) : (
                    <MessageSquare className="h-4 w-4 text-white flex-shrink-0" />
                  )}
                  <span className="whitespace-nowrap text-white">
                    {entry.type === 'comment' ? (
                      <><span className="font-bold">{entry.card_name}</span> · {entry.author}: {entry.message}</>
                    ) : entry.type === 'corrective_action' ? (
                      <><span className="font-bold">Corrective action</span> · {entry.author}: {entry.message}</>
                    ) : entry.type === 'observation' ? (
                      <><span className="font-bold">Observation</span> · {entry.author}: {entry.message}</>
                    ) : entry.type === 'responder_activity' ? (
                      <><span className="font-bold">{entry.author}</span> · {entry.message}</>
                    ) : related ? (
                      showActivityLine ? (
                        <><span className="font-bold">{entry.relationship_label || 'Related incident'}</span> · INC-{related.id?.slice(-8).toUpperCase()} - {related.incident_type || 'Unknown'}{location ? ` · ${location}` : ''}</>
                      ) : (
                        <>Incident: INC-{related.id?.slice(-8).toUpperCase()} - {related.incident_type || 'Unknown'}{location ? ` · ${location}` : ''}</>
                      )
                    ) : (
                      <><span className="font-bold">{entry.author}</span>: {entry.message}</>
                    )}
                  </span>
                </div>
                );
              })}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

const toLocalDateTimeInput = (value) => {
  const d = parsePlannedDateTime(value);
  if (!d || Number.isNaN(d.getTime())) return '';
  return getLocalDateTimeInputValue(d);
};

// Scenario env: every widget starts collapsed — wraps plain cards (e.g. the map)
// in a closed CollapsibleWidget only there; other contexts render unchanged.
const MaybeCollapsed = ({ when, title, testId, icon, children }) => (when ? (
  <CollapsibleWidget
    title={title}
    testId={testId}
    defaultOpen={false}
    variant="scenario"
    icon={icon}
  >
    {children}
  </CollapsibleWidget>
) : children);

const localDateTimeToISO = (localValue) => {
  if (!localValue) return '';
  if (typeof localValue === 'string' && (localValue.includes('Z') || /[+-]\d{2}:\d{2}$/.test(localValue))) {
    const date = new Date(localValue);
    return Number.isNaN(date.getTime()) ? localValue : date.toISOString();
  }
  const date = new Date(localValue);
  return Number.isNaN(date.getTime()) ? localValue : date.toISOString();
};

const isPlannedStartInPast = (startValue) => {
  if (!startValue) return false;
  const startDate = parsePlannedDateTime(startValue);
  return startDate && !Number.isNaN(startDate.getTime()) && startDate < new Date();
};

const isPlannedEndBeforeOrEqualStart = (startValue, endValue) => {
  if (!startValue || !endValue) return false;
  const start = parsePlannedDateTime(startValue);
  const end = parsePlannedDateTime(endValue);
  if (!start || !end || Number.isNaN(start.getTime()) || Number.isNaN(end.getTime())) return false;
  return end <= start;
};

const validatePlannedWindows = (windows) => {
  if (!windows?.length || windows.some((w) => !w?.start || (!w?.end && !w?.end_open))) {
    return PLANNED_WINDOW_INCOMPLETE_ERROR;
  }
  for (let i = 0; i < windows.length; i++) {
    const w = windows[i];
    if (isPlannedStartInPast(w.start)) return PAST_PLANNED_TIME_ERROR;
    if (!w.end_open && isPlannedEndBeforeOrEqualStart(w.start, w.end)) {
      return windows.length > 1
        ? `Window ${i + 1}: End must be after Start`
        : PLANNED_END_BEFORE_START_ERROR;
    }
  }
  return null;
};

const isUnknownIncidentLocation = (incident) =>
  incident?.is_unknown_location ||
  (Array.isArray(incident?.location) && incident.location.includes('unknown'));

const getIncidentGpsCoordinates = (incident) => {
  const gps = incident?.gps_coordinates || {};
  const lat = gps.latitude ?? gps.lat ?? incident?.gps_latitude;
  const lng = gps.longitude ?? gps.lng ?? incident?.gps_longitude;
  if (lat == null || lng == null) return null;
  const parsedLat = Number(lat);
  const parsedLng = Number(lng);
  if (Number.isNaN(parsedLat) || Number.isNaN(parsedLng)) return null;
  return { lat: parsedLat, lng: parsedLng };
};

const buildRequestTitle = (incidentTypeName, incident) => {
  const existingTitle = String(incident?.title || '');
  const titleMatch = existingTitle.match(/^(.+?) - Reported by (.+)$/i);
  const reporterName =
    titleMatch?.[2]?.trim() ||
    incident?.created_by_name ||
    incident?.reporter_name ||
    'System';
  const typeName = String(incidentTypeName || incident?.incident_type || 'Untitled Operation').trim();
  return `${typeName} - Reported by ${reporterName}`;
};

const normalizePlannedLocationIds = (location) => {
  const ids = Array.isArray(location) ? location : (location ? [location] : []);
  return ids.filter((id) => id && id !== 'unknown');
};

const extractDepartmentId = (entry) => {
  if (!entry) return null;
  if (typeof entry === 'string') return entry;
  if (typeof entry === 'object') return entry.department_id || entry.id || entry._id || null;
  return null;
};

const getDepartmentIdsForLocation = (locationId, locations = [], departments = []) => {
  const ids = new Set();
  const location = locations.find((loc) => String(loc.id || loc._id) === String(locationId));

  (location?.departments || []).forEach((dept) => {
    const deptId = extractDepartmentId(dept);
    if (deptId) ids.add(String(deptId));
  });

  departments.forEach((dept) => {
    const deptId = String(dept.id || dept._id || '');
    if (!deptId) return;
    const associated = dept.associated_locations || [];
    if (associated.some((loc) => String(loc) === String(locationId))) {
      ids.add(deptId);
    }
  });

  return Array.from(ids);
};

const isDepartmentLinkedToIncidentLocations = (deptId, locationValue, locations = [], departments = []) => {
  const id = String(deptId);
  return normalizePlannedLocationIds(locationValue).some((locId) =>
    getDepartmentIdsForLocation(locId, locations, departments).includes(id)
  );
};

const syncImpactedDepartments = (locationValue, manualDepartmentIds, locations = [], departments = []) => {
  const manual = new Set(
    (manualDepartmentIds instanceof Set ? Array.from(manualDepartmentIds) : manualDepartmentIds || [])
      .filter((id) => id && id !== 'undefined')
      .map(String)
  );
  normalizePlannedLocationIds(locationValue).forEach((locId) => {
    getDepartmentIdsForLocation(locId, locations, departments).forEach((deptId) => manual.add(deptId));
  });
  return Array.from(manual);
};

const normalizeDepartmentIds = (deptIds = []) =>
  (Array.isArray(deptIds) ? deptIds : [])
    .map((d) => (typeof d === 'object' ? (d.id || d._id) : d))
    .filter((id) => id && id !== 'undefined')
    .map(String);

const syncDistributionListWithDepartments = (deptIds, currentList = [], allDepartments = []) => {
  const deptIdSet = new Set(normalizeDepartmentIds(deptIds));
  const nonDepartmentRecipients = (currentList || []).filter((r) => r?.type !== 'department');
  const keptDepartments = (currentList || []).filter(
    (r) => r?.type === 'department' && deptIdSet.has(String(r.id))
  );
  const keptIds = new Set(keptDepartments.map((r) => String(r.id)));
  const addedDepartments = [...deptIdSet]
    .filter((id) => !keptIds.has(id))
    .map((id) => {
      const dept = (allDepartments || []).find((d) => String(d.id) === id);
      return {
        id,
        name: dept?.department_name || id,
        type: 'department',
        acknowledged: false,
        acknowledged_at: null,
        actor: null,
      };
    });
  return [...nonDepartmentRecipients, ...keptDepartments, ...addedDepartments];
};

const persistDepartmentSync = async (incidentId, { impactedDepartments, distributionList }) => {
  if (impactedDepartments !== undefined) {
    const patchRes = await CommanServices.updatePatchIncidents(incidentId, {
      impacted_departments: impactedDepartments,
    });
    if (patchRes?.status === false) {
      throw new Error(patchRes?.message || 'Failed to update impacted departments');
    }
  }
  if (distributionList !== undefined) {
    const recipients = distributionList.map((r) => ({
      id: r.id,
      type: r.type,
      name: r.name,
    }));
    const distRes = await JwtService.commanApi(
      { recipients },
      `${ApiEndPoint}/api/incidents/${incidentId}/distribution`,
      'PUT'
    );
    if (distRes?.status === false) {
      throw new Error(distRes?.message || 'Failed to update distribution list');
    }
  }
};

function collectAttachmentsFromFirestore(messages) {
  const seen = new Set();
  const out = [];
  const pushAtt = (raw, defaultFilename, defaultContentType) => {
    if (raw == null) return;
    if (typeof raw === 'string') {
      const att = {
        url: raw,
        filename: defaultFilename || 'Chat media',
        content_type: defaultContentType || '',
      };
      const dk = attachmentDedupeKey(att);
      if (dk && !seen.has(dk)) {
        seen.add(dk);
        out.push(att);
      }
      return;
    }
    if (typeof raw === 'object') {
      const url = raw.url || raw.file_url || raw.s3_url;
      if (!url) return;
      const att = {
        ...raw,
        url,
        filename: raw.filename || raw.name || defaultFilename || 'Chat attachment',
        content_type: raw.content_type || raw.type || defaultContentType || '',
      };
      const dk = attachmentDedupeKey(att);
      if (dk && !seen.has(dk)) {
        seen.add(dk);
        out.push(att);
      }
    }
  };

  messages.forEach((msg) => {
    if (msg.audio) pushAtt(msg.audio, 'Voice message', 'audio/*');
    if (msg.image) pushAtt(msg.image, 'Image', 'image/*');
    if (Array.isArray(msg.images)) {
      msg.images.forEach((u, i) => pushAtt(u, `Image ${i + 1}`, 'image/*'));
    }
    if (Array.isArray(msg.attachments)) {
      msg.attachments.forEach((a) => pushAtt(a, 'Attachment'));
    }
    const fileUrl = msg.fileUrl || msg.file_url;
    if (fileUrl) {
      pushAtt(
        { url: fileUrl, filename: msg.fileName || msg.filename || 'File' },
        msg.fileName || 'File'
      );
    }
  });
  return out;
}

function collectAttachmentsFromTimelineItems(items) {
  const out = [];
  if (!Array.isArray(items)) return out;
  for (const item of items) {
    const fromMeta = item?.meta?.attachments;
    const fromReplies = Array.isArray(item?.meta?.replies)
      ? item.meta.replies.flatMap((reply) =>
        Array.isArray(reply?.attachments) ? reply.attachments : []
      )
      : [];
    const top = item?.attachments;
    const merged = [
      ...(Array.isArray(fromMeta) ? fromMeta : []),
      ...(Array.isArray(fromReplies) ? fromReplies : []),
      ...(Array.isArray(top) ? top : []),
    ];
    for (const att of merged) {
      if (att && typeof att === 'object') out.push(att);
    }
  }
  return out;
}

const DEFAULT_VISIBLE_WIDGETS = {
  metrics1: true,
  metrics3: true,
  metrics4: true,
  locationMap: true,
  teamsCrews: false,
  departments: false,
  attachments: true,
  weather: false,
  chat: true,
  map2: false,
  simulationObjective: true,
  discussionGroup: true,
  exerciseTimeline: false,
  correctiveActions: false,
  availableResources: false,
  // Visible by default so plan activations and card changes are always traceable.
  auditLog: true,
  assignedRoles: false,
};

// At the Requested stage of an exercise, show this default widget set (and order) unless the
// planner has already customised it (saved in localStorage).
const EXERCISE_REQUESTED_DEFAULT_WIDGETS = {
  metrics1: false, metrics3: false, metrics4: false,
  teamsCrews: false, departments: false, weather: false, map2: false, correctiveActions: false,
  simulationObjective: true,
  discussionGroup: true,
  assignedRoles: true,
  exerciseTimeline: true,
  availableResources: true,
  auditLog: true,
  locationMap: true,
  attachments: true,
  chat: true,
};

// At the Completed stage of an exercise: a lean debrief layout — metrics +
// Resolve/Extensive actions, Corrective Actions & AAR, and the chat. Everything
// operational (roles, resources, audit, timeline, map) is off by default and
// can be brought back through Add Widget.
const EXERCISE_COMPLETED_DEFAULT_WIDGETS = {
  metrics1: true, metrics3: true, metrics4: true,
  teamsCrews: false, departments: false, weather: false, map2: false,
  locationMap: false, attachments: false,
  chat: true,
  simulationObjective: false,
  discussionGroup: false,
  // The completed stage renders its own Corrective Actions & AAR panel
  // unconditionally — keeping the widget toggle off avoids a duplicate.
  correctiveActions: false,
  assignedRoles: false,
  exerciseTimeline: false,
  availableResources: false,
  auditLog: false,
};

// Scenario environment (template design): a focused set — Attachments stays OFF
// by default, and every widget starts collapsed (handled at render time).
const SCENARIO_DEFAULT_WIDGETS = {
  metrics1: false, metrics3: false, metrics4: false,
  teamsCrews: false, departments: false, weather: false, map2: false,
  correctiveActions: false,
  simulationObjective: true,
  discussionGroup: true,
  assignedRoles: true,
  exerciseTimeline: true,
  availableResources: true,
  auditLog: true,
  locationMap: true,
  attachments: false,
  chat: false,
};

// At the Active stage of an exercise, show this default widget set unless the planner customised it.
const EXERCISE_ACTIVE_DEFAULT_WIDGETS = {
  metrics1: true, metrics3: true, metrics4: true,
  teamsCrews: true, departments: true, weather: false, map2: false,
  locationMap: true, attachments: false, chat: true,
  simulationObjective: false,
  discussionGroup: false,
  correctiveActions: true,
  assignedRoles: true,
  exerciseTimeline: true,
  availableResources: true,
  auditLog: true,
};

function loadVisibleWidgetsForIncident(incidentId) {
  if (!incidentId) {
    return { ...DEFAULT_VISIBLE_WIDGETS };
  }
  try {
    const saved = localStorage.getItem(`incident-detail-widgets-v3-${incidentId}`);
    if (saved) {
      const parsed = JSON.parse(saved);
      return { ...DEFAULT_VISIBLE_WIDGETS, ...parsed };
    }
  } catch (e) {
    console.error('Error loading incident detail widget preferences:', e);
  }
  return { ...DEFAULT_VISIBLE_WIDGETS };
}

const findUserTeamAndCrew = (userId, userEmail, allTeamsList) => {
  if (!allTeamsList || !Array.isArray(allTeamsList)) return null;
  // Traverse all teams to see if this user belongs to any crew
  for (const team of allTeamsList) {
    for (const crew of team.crews || []) {
      for (const rule of crew.escalation_rules || []) {
        const escTo = rule.escalated_to;
        const accounts = Array.isArray(escTo) ? escTo : [escTo];
        for (const acc of accounts) {
          if (acc) {
            const accStr = String(acc).toLowerCase();
            const idMatch = userId && accStr === String(userId).toLowerCase();
            const emailMatch = userEmail && accStr === String(userEmail).toLowerCase();
            if (idMatch || emailMatch) {
              return {
                teamName: team.team_name,
                crewName: crew.crew_name,
                teamId: team.id,
                crewId: crew.id
              };
            }
          }
        }
      }
    }
  }
  return null;
};

const IncidentDetail = () => {
  const { id } = useParams();
  const routeLocation = useLocation();
  const [searchParams] = useSearchParams();
  const scenarioModeRequested = searchParams.get('scenario') === '1' || searchParams.has('sid');
  const scenarioMode = scenarioModeRequested;

  const scenarioId = scenarioMode ? (searchParams.get('sid') || '') : '';
  const [scenarioStatus, setScenarioStatus] = useState('Draft');
  const [scenarioLevel, setScenarioLevel] = useState('');
  const [scenarioName, setScenarioName] = useState('');
  const [scenarioAutoActivateOnMatch, setScenarioAutoActivateOnMatch] = useState(false);
  const [scenarioAutoActivateReadinessWindowMinutes, setScenarioAutoActivateReadinessWindowMinutes] = useState(5);
  // Every policy edit advances this revision. A slower GET that started before
  // the edit is then prevented from restoring an older switch value.
  const scenarioActivationPolicyRevisionRef = useRef(0);
  const scenarioActivationPolicySavingRef = useRef(false);
  const [scenarioStaffingDefaults, setScenarioStaffingDefaults] = useState({ roles: {} });
  const scenarioStaffingDefaultsRef = useRef({ roles: {} });
  const scenarioStaffingSaveQueueRef = useRef(Promise.resolve());
  const refreshScenarioStaffingDefaults = useCallback(async () => {
    if (!scenarioMode || !scenarioId) return;
    const policyRevisionAtRequest = scenarioActivationPolicyRevisionRef.current;
    try {
      const res = await CommanServices.getScenario(scenarioId);
      if (res?.status === false) throw new Error(res?.message || 'Failed to load scenario');
      const st = (res?.data?.status) || (res?.status ? res.data?.status : null);
      if (st) setScenarioStatus(st);
      const lvl = res?.data?.level;
      if (lvl) setScenarioLevel(lvl);
      const nm = res?.data?.name;
      if (nm) setScenarioName(nm);
      if (
        policyRevisionAtRequest === scenarioActivationPolicyRevisionRef.current
        && !scenarioActivationPolicySavingRef.current
      ) {
        setScenarioAutoActivateOnMatch(Boolean(res?.data?.auto_activate_on_match));
        setScenarioAutoActivateReadinessWindowMinutes(
          normalizeAutoActivateReadinessWindow(res?.data?.auto_activate_readiness_window_minutes)
        );
      }
      const staffing = res?.data?.staffing_defaults || { roles: {} };
      scenarioStaffingDefaultsRef.current = staffing;
      setScenarioStaffingDefaults(staffing);
    } catch (e) {
      console.error('Failed to refresh scenario settings:', e);
    }
  }, [scenarioMode, scenarioId]);

  const persistScenarioActivationPolicy = useCallback(async ({
    enabled,
    readinessWindowMinutes,
    status,
  }) => {
    if (!scenarioMode || !scenarioId) throw new Error('Scenario activation settings are unavailable.');
    const nextEnabled = Boolean(enabled);
    const nextWindow = normalizeAutoActivateReadinessWindow(readinessWindowMinutes);
    const previousEnabled = scenarioAutoActivateOnMatch;
    const previousWindow = scenarioAutoActivateReadinessWindowMinutes;
    scenarioActivationPolicyRevisionRef.current += 1;
    scenarioActivationPolicySavingRef.current = true;
    setScenarioAutoActivateOnMatch(nextEnabled);
    setScenarioAutoActivateReadinessWindowMinutes(nextWindow);
    try {
      const response = await CommanServices.updateScenario(scenarioId, {
        ...(status ? { status } : {}),
        auto_activate_on_match: nextEnabled,
        auto_activate_readiness_window_minutes: nextWindow,
      });
      if (response?.status === false) throw new Error(response?.message || 'Failed to save auto-activation settings');
      const saved = response?.data || {};
      const savedEnabled = Boolean(saved.auto_activate_on_match);
      const savedWindow = normalizeAutoActivateReadinessWindow(saved.auto_activate_readiness_window_minutes);
      if (savedEnabled !== nextEnabled || savedWindow !== nextWindow) {
        throw new Error('The server did not confirm the auto-activation settings.');
      }
      setScenarioAutoActivateOnMatch(savedEnabled);
      setScenarioAutoActivateReadinessWindowMinutes(savedWindow);
      return saved;
    } catch (error) {
      scenarioActivationPolicyRevisionRef.current += 1;
      setScenarioAutoActivateOnMatch(previousEnabled);
      setScenarioAutoActivateReadinessWindowMinutes(previousWindow);
      throw error;
    } finally {
      scenarioActivationPolicySavingRef.current = false;
    }
  }, [
    scenarioMode,
    scenarioId,
    scenarioAutoActivateOnMatch,
    scenarioAutoActivateReadinessWindowMinutes,
  ]);
  useEffect(() => {
    refreshScenarioStaffingDefaults();
  }, [refreshScenarioStaffingDefaults]);
  useEffect(() => {
    if (!scenarioMode) return undefined;
    const updateStaffingDefaults = (event) => {
      const staffing = event?.detail || { roles: {} };
      scenarioStaffingDefaultsRef.current = staffing;
      setScenarioStaffingDefaults(staffing);
    };
    window.addEventListener('scenarioStaffingDefaultsUpdated', updateStaffingDefaults);
    return () => window.removeEventListener('scenarioStaffingDefaultsUpdated', updateStaffingDefaults);
  }, [scenarioMode]);
  useEffect(() => {
    if (!scenarioMode) return undefined;
    const refreshAfterCardChange = (event) => {
      const changedIncidentId = event?.detail?.incident_id;
      if (changedIncidentId && String(changedIncidentId) !== String(id)) return;
      refreshScenarioStaffingDefaults();
    };
    window.addEventListener('timelineRefresh', refreshAfterCardChange);
    window.addEventListener('incidentRealtimeSync', refreshAfterCardChange);
    return () => {
      window.removeEventListener('timelineRefresh', refreshAfterCardChange);
      window.removeEventListener('incidentRealtimeSync', refreshAfterCardChange);
    };
  }, [scenarioMode, id, refreshScenarioStaffingDefaults]);
  const upsertScenarioRequiredRole = useCallback(({ role }) => {
    if (!scenarioMode || !scenarioId) return Promise.reject(new Error('Scenario staffing is unavailable.'));
    const name = String(role || '').trim();
    if (!name) return Promise.reject(new Error('Enter a role name.'));
    scenarioStaffingSaveQueueRef.current = scenarioStaffingSaveQueueRef.current.catch(() => {}).then(async () => {
      const current = scenarioStaffingDefaultsRef.current || { roles: {} };
      const existing = current.roles?.[name] || {};
      const seenCandidates = new Set();
      const defaultCandidates = [
        ...(Array.isArray(existing.preferred) ? existing.preferred : []),
        ...(Array.isArray(existing.fallbacks) ? existing.fallbacks : []),
      ].filter((candidate) => {
        const key = `${candidate?.type || ''}:${candidate?.id || ''}`;
        if (!candidate?.type || !candidate?.id || seenCandidates.has(key)) return false;
        seenCandidates.add(key);
        return true;
      });
      const next = {
        roles: {
          ...(current.roles || {}),
          [name]: {
            mode: existing.mode === 'whole_group' ? 'whole_group' : 'fill_slots',
            // keep the count the planner (or the Scenario Builder agent) already set
            required_count: Math.max(1, Number(existing.required_count) || 1),
            preferred: defaultCandidates,
            fallbacks: [],
          },
        },
      };
      const res = await CommanServices.saveScenarioStaffingDefaults(scenarioId, next);
      if (res?.status === false) throw new Error(res.message || 'Unable to update Required Roles.');
      const saved = res?.data || next;
      scenarioStaffingDefaultsRef.current = saved;
      setScenarioStaffingDefaults(saved);
      window.dispatchEvent(new CustomEvent('scenarioStaffingDefaultsUpdated', { detail: saved }));
      return saved;
    });
    return scenarioStaffingSaveQueueRef.current;
  }, [scenarioMode, scenarioId]);
  const navigate = useNavigate();
  const [incident, setIncident] = useState(null);
  // The scenario ENVIRONMENT is either the scenario route (?sid=) or the
  // scenario's backing incident viewed directly — widget behavior keys off this.
  const scenarioEnv = scenarioMode || !!incident?.is_scenario;
  const chatWorkspaceUrl = buildChatWorkspaceUrl({
    incidentId: id,
    isScenario: scenarioEnv,
    scenarioId: scenarioId || incident?.scenario_id,
  });
  const incidentCopilotEligible = isIncidentCopilotEligible(incident, scenarioEnv);
  const [incidents, setIncidents] = useState([]); // All incidents for counting related ones
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [allTeams, setAllTeams] = useState([]); // All system teams
  const [showDetailsModal, setShowDetailsModal] = useState(false);
  const [showReportsModal, setShowReportsModal] = useState(false);
  const [showFullTimeline, setShowFullTimeline] = useState(false);
  const [showChatModal, setShowChatModal] = useState(false);
  const [showTimelineModal, setShowTimelineModal] = useState(false);
  const [showAcknowledgmentModal, setShowAcknowledgmentModal] = useState(false);
  const [showResponseActionModal, setShowResponseActionModal] = useState(false);
  const [responseActionPrefills, setResponseActionPrefills] = useState({
    prefilledName: '',
    prefilledUserIds: [],
    isImmediateTask: false,
  });
  const [showHistoryModal, setShowHistoryModal] = useState(false);
  const [historyResponder, setHistoryResponder] = useState(null);
  const [showStatusUpdateModal, setShowStatusUpdateModal] = useState(false);
  const [showResolutionModal, setShowResolutionModal] = useState(false);
  const [showExtensiveModal, setShowExtensiveModal] = useState(false);
  const [showIncidentCopilot, setShowIncidentCopilot] = useState(false);
  const [extensiveReport, setExtensiveReport] = useState('');
  const [showNotificationModal, setShowNotificationModal] = useState(false); // Notification edit modal
  const [showManualNotificationModal, setShowManualNotificationModal] = useState(false); // Manual notification modal
  const [statusUpdateGroup, setStatusUpdateGroup] = useState('status_update'); // Track which status update group
  const [activeGroup, setActiveGroup] = useState(null);
  const [editingItem, setEditingItem] = useState(null);
  const [editingAcknowledgment, setEditingAcknowledgment] = useState(null); // Track which ack is being edited
  const [editingResponseAction, setEditingResponseAction] = useState(null); // Track which response action is being edited
  const [editingStatusUpdate, setEditingStatusUpdate] = useState(null); // Track which status update is being edited
  const [editingResolution, setEditingResolution] = useState(null); // Track which resolution is being edited
  const [editingNotification, setEditingNotification] = useState(null); // Track which notification is being edited
  const [acknowledgmentMode, setAcknowledgmentMode] = useState('config'); // 'config' (pen edit) | 'takeover'
  const [editingManualNotification, setEditingManualNotification] = useState(null); // notification card being re-targeted
  // Conditional follow-up injects: picker = {sourceItem, sourceTaskIndex}; context passed into the target modal.
  const [conditionalPicker, setConditionalPicker] = useState(null);
  const [conditionalContext, setConditionalContext] = useState(null);

  // From inside an inject modal (edit mode): close it and open the conditional picker for that source.
  const handleAddConditionalFromModal = (sourceItem) => {
    setShowAcknowledgmentModal(false);
    setShowResponseActionModal(false);
    setShowStatusUpdateModal(false);
    setShowManualNotificationModal(false);
    setEditingAcknowledgment(null);
    setEditingResponseAction(null);
    setEditingStatusUpdate(null);
    setEditingManualNotification(null);
    setConditionalContext(null);
    setConditionalPicker({ sourceItem, sourceTaskIndex: null });
  };

  // After the picker chooses trigger + card type, open the matching authoring modal with context.
  const openConditionalTarget = (ctx) => {
    setConditionalContext(ctx);
    setConditionalPicker(null);
    const t = ctx.targetType;
    if (t === 'notification') {
      setEditingManualNotification(null);
      setShowManualNotificationModal(true);
    } else if (t === 'acknowledgment') {
      setEditingAcknowledgment(null);
      setAcknowledgmentMode('config');
      setShowAcknowledgmentModal(true);
    } else if (t === 'response_action') {
      setEditingResponseAction(null);
      setShowResponseActionModal(true);
    } else if (t === 'status_update') {
      setEditingStatusUpdate(null);
      setStatusUpdateGroup('status_update');
      setShowStatusUpdateModal(true);
    }
  };
  const [timelineItems, setTimelineItems] = useState([]); // Add timeline items state for metrics
  const [planAdherenceSnapshot, setPlanAdherenceSnapshot] = useState(null);
  const [appUsers, setAppUsers] = useState([]); // List of all app users (declared early — used by the participants memo below)
  const scopedDirectoryRequestRef = useRef({ incidentId: null, promise: null });
  const [mobilePresenceByUser, setMobilePresenceByUser] = useState({});
  const onlineParticipantIds = useMemo(() => new Set(
    Object.entries(mobilePresenceByUser)
      .filter(([, presence]) => presence?.online === true)
      .map(([userId]) => String(userId))
  ), [mobilePresenceByUser]);
  // Map of userId/name -> the role they were assigned during the Requested stage. Used so live
  // (active-stage) cards show each user's real exercise role instead of their HR position.
  const userRoleMap = useMemo(() => {
    const map = {};
    (timelineItems || []).forEach((it) => {
      const ra = it?.meta?.roleAssignments;
      if (ra && typeof ra === 'object') {
        Object.entries(ra).forEach(([role, list]) => {
          (Array.isArray(list) ? list : []).forEach((a) => {
            const idKey = a?.id || a?.userId;
            if (idKey && !map[String(idKey)]) map[String(idKey)] = role;
            if (a?.name && !map[String(a.name)]) map[String(a.name)] = role;
          });
        });
      }
    });
    return map;
  }, [timelineItems]);

  // Participants assigned to incident cards, with live state sourced from the
  // backend's active realtime connections.
  const drillParticipants = useMemo(() => {
    const map = new Map();
    const revokedUserIds = new Set((incident?.access_revoked_user_ids || []).map(String));
    const addUser = (a, role, viaLabel = null) => {
      const key = String(a?.userId || a?.id || a?.name || '');
      if (!key) return;
      if (!map.has(key)) {
        map.set(key, { userId: a?.userId || a?.id || key, userName: a?.name || a?.userName || a?.email || 'Unknown User', email: a?.email || '', roles: new Set(), viaGroups: new Set() });
      }
      if (role) map.get(key).roles.add(role);
      if (viaLabel) map.get(key).viaGroups.add(viaLabel);
    };
    (timelineItems || []).forEach((item) => {
      const ra = item?.meta?.roleAssignments;
      if (ra && typeof ra === 'object') {
        Object.entries(ra).forEach(([role, list]) => {
          (Array.isArray(list) ? list : []).forEach((a) => {
            // Assigned via a crew/department? Show that origin under their name.
            const via = a?.via?.name
              ? `${a.via.type === 'department' ? 'Dept' : 'Crew'}: ${a.via.name}`
              : null;
            addUser(a, role, via);
          });
        });
      }
      // Manual cards: flat assignees + the verification assignee
      (item?.meta?.assignees || []).forEach((a) => addUser({ userId: a?.userId, name: a?.userName || a?.name, email: a?.email }, item?.meta?.role || null));
      const ab = item?.meta?.acknowledgedBy;
      if (ab?.userId) addUser({ userId: ab.userId, name: ab.userName }, item?.meta?.role || null);
      // Manual notification recipients (targeted directly or via dept/crew) —
      // they only carry ids on the card, so resolve names from the user list.
      (item?.meta?.recipientIds || []).forEach((rid) => {
        const u = (appUsers || []).find((x) => String(x.id) === String(rid));
        addUser({ userId: rid, name: u?.name || u?.full_name || u?.email || 'User', email: u?.email || '' }, null);
      });
    });
    return Array.from(map.values())
      .filter((participant) => !revokedUserIds.has(String(participant.userId)))
      .map((p) => ({ ...p, roles: Array.from(p.roles), viaGroups: Array.from(p.viaGroups || []), live: onlineParticipantIds.has(String(p.userId)) }))
      .sort((a, b) => String(a.userName).localeCompare(String(b.userName)));
  }, [timelineItems, appUsers, onlineParticipantIds, incident?.access_revoked_user_ids]);
  const drillParticipantsLiveCount = drillParticipants.filter((p) => p.live).length;
  // Crews / departments added to this incident (via + pickers) with their members.
  const incidentCrews = useMemo(() => {
    const map = new Map();
    (timelineItems || []).forEach((item) => {
      const groups = item?.meta?.sourceGroups || (item?.meta?.sourceGroup ? [item.meta.sourceGroup] : []);
      groups.filter((g) => g && (g.type === 'crew' || g.type === 'department')).forEach((g) => {
        if (!map.has(g.name)) map.set(g.name, { name: g.name, type: g.type, memberKeys: new Set() });
        const entry = map.get(g.name);
        (item?.meta?.assignees || []).forEach((a) => a?.userId && entry.memberKeys.add(String(a.userId)));
        const ab = item?.meta?.acknowledgedBy;
        if (ab?.userId) entry.memberKeys.add(String(ab.userId));
        Object.values(item?.meta?.roleAssignments || {}).forEach((list) => (Array.isArray(list) ? list : []).forEach((a) => a?.id && entry.memberKeys.add(String(a.id))));
      });
    });
    return [...map.values()].map((c) => ({ ...c, memberIds: [...c.memberKeys] }));
  }, [timelineItems]);
  const [expandedCrews, setExpandedCrews] = useState({});

  /** Media URLs from Firestore incident chat (audio, images, future file uploads) */
  const [chatMediaAttachments, setChatMediaAttachments] = useState([]);
  // Injects that still have unstaffed roles — activation is blocked until this is 0.
  // Uses the SAME helpers as the staffing banner (cleanScenarioRoles drops empty/zero-count
  // roles) so the banner and the activation guard never disagree.
  const unstaffedInjectCount = useMemo(() => {
    return (timelineItems || []).filter((it) => {
      if (it?.is_active === false) return false;
      if (it?.group === 'report') return false;
      if (!cardHasRoles(it)) return false;
      return !cardIsFullyAssigned(it);
    }).length;
  }, [timelineItems]);
  // Real-incident plan review: planned cards that still need personnel.
  // Activate Response Plan stays disabled until this is 0 (same rule as drills).
  const unstaffedPlannedCount = useMemo(() => {
    return (timelineItems || []).filter((it) => {
      if (it?.is_active === false) return false;
      if (it?.plan_state !== 'planned') return false;
      if (!cardHasRoles(it)) return false;
      return !cardIsFullyAssigned(it);
    }).length;
  }, [timelineItems]);
  const plannedStaffingSummary = useMemo(() => {
    const plannedCards = (timelineItems || []).filter((item) => (
      item?.is_active !== false
      && item?.group !== 'report'
      && item?.plan_state === 'planned'
    ));
    let required = 0;
    let staffed = 0;
    plannedCards.forEach((item) => {
      const assignments = item?.meta?.roleAssignments || {};
      cleanScenarioRoles(item?.meta?.scenarioRoles).forEach((role) => {
        const slots = Math.max(1, Number(role.count || 1));
        const assigned = Array.isArray(assignments[role.role]) ? assignments[role.role].length : 0;
        required += slots;
        staffed += Math.min(slots, assigned);
      });
    });
    return {
      cardCount: plannedCards.length,
      required,
      staffed,
      gaps: Math.max(0, required - staffed),
    };
  }, [timelineItems]);
  const [locationDepartments, setLocationDepartments] = useState([]); // Departments associated with incident location
  const [loadingDepartments, setLoadingDepartments] = useState(false); // Loading state for departments
  const [matchedResponders, setMatchedResponders] = useState([]); // Teams & crews matched for this incident
  const [loadingResponders, setLoadingResponders] = useState(false); // Loading state for responders
  const [showStaffModal, setShowStaffModal] = useState(false); // Staff modal state
  const [selectedDepartment, setSelectedDepartment] = useState(null); // Selected department for viewing staff
  const [selectedStaff, setSelectedStaff] = useState(new Set()); // Multi-select staff IDs
  const [staffDmTarget, setStaffDmTarget] = useState(null); // { id, name } for PrivateChatModal from staff modal
  const [staffModalTab, setStaffModalTab] = useState('contact'); // 'contact' | 'manage'
  const [isDepartmentLeader, setIsDepartmentLeader] = useState(false);
  const [managedDepartmentIds, setManagedDepartmentIds] = useState([]);
  const [isAdmin, setIsAdmin] = useState(() => isInstitutionIncidentAdministrator(readStoredWebUser()));
  const canActivateResponsePlan = isAdmin;
  const canResolveIncident = isAdmin;
  const canRemoveIncidentUser = isAdmin;
  const canManageOperationalRoles = isAdmin;
  const canChangeDrillStatus = isAdmin;
  const canControlDrillRuntime = isAdmin;
  const canManageDrillInjectors = isAdmin;
  const canRecordDrillEvaluations = isAdmin;
  const canManageScenarioLibrary = isAdmin;
  const isContextAdmin = isAdmin || (scenarioMode && canManageScenarioLibrary);
  const [removingIncidentUserId, setRemovingIncidentUserId] = useState('');
  const [activeTab, setActiveTab] = useState('planning'); // 'planning' or 'during'
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const [showQuickAssign, setShowQuickAssign] = useState(false);
  // Response-plan timeline section inside the plan banner (collapsible, open by default)
  const [planTimelineOpen, setPlanTimelineOpen] = useState(true);
  // Crew "View Staff" modal target ({ id, crew_name, team_id, team_name })
  const [crewStaffTarget, setCrewStaffTarget] = useState(null);
  const [teamStaffTarget, setTeamStaffTarget] = useState(null);
  const [showCreateTeamCrew, setShowCreateTeamCrew] = useState(false); // "New Team / Crew" from the Participants widget
  const [showCreateDepartment, setShowCreateDepartment] = useState(false); // "New Department" from the Organization & Departments widget
  // Geo-Fencing: circle-selected users become the recipients of the chosen action.
  const [showGeoFence, setShowGeoFence] = useState(false);
  const [generalInfoOpenRequest, setGeneralInfoOpenRequest] = useState(0);
  const [ackPrefilledSelections, setAckPrefilledSelections] = useState(null);
  const [responsePrefilledSelections, setResponsePrefilledSelections] = useState(null);
  const [ackGeoFenceTargeting, setAckGeoFenceTargeting] = useState(null);
  const [responseGeoFenceTargeting, setResponseGeoFenceTargeting] = useState(null);
  const [statusGeoFenceTargeting, setStatusGeoFenceTargeting] = useState(null);

  const handleGeoFenceAction = async (type, userIds, userNames, fence) => {
    if (!canUseGeoFence) {
      setShowGeoFence(false);
      toast.error('Geo-fence actions are available only on writable real incidents or active drills');
      return false;
    }
    const geoFenceTargeting = buildGeoFenceTargeting(userIds, fence);
    const selections = userIds.map((id, i) => ({ type: 'user', id, name: userNames[i] }));
    const fenceNote = `geo-fence (${Number(fence?.radiusKm || 0).toFixed(1)} km circle, ${userIds.length} user${userIds.length === 1 ? '' : 's'})`;
    if (type === 'notification') {
      try {
        const response = await CommanServices.notificationMaunal(incident.id, {
          user_ids: geoFenceTargeting.userIds,
          department_ids: [],
          crew_ids: [],
          force: true,
          is_attention_only: false,
          source: 'geo_fence',
          geoFenceTargeting,
        });
        const outcome = manualNotificationOutcome(response, geoFenceTargeting.userIds.length);
        if (!outcome.ok) {
          if (outcome.partial) {
            toast.warning(`${outcome.deliveredCount ?? 0} notification${outcome.deliveredCount === 1 ? '' : 's'} delivered; ${outcome.failedCount} failed`);
          } else {
            toast.error(outcome.message || 'Failed to create and deliver the geo-fence notification');
          }
          return false;
        }
        if (!outcome.timelineItemId) {
          toast.warning('Delivery was accepted, but the notification timeline card could not be confirmed. Retry to finish safely.');
          return false;
        }
        fetchTimelineData();
        announceIncidentTimelineChange(incident.id, 'geo_fence_notification_created');
        toast.success(`Notification created for ${outcome.deliveredCount ?? userIds.length} user${userIds.length === 1 ? '' : 's'} inside the circle`);
        try { await CommanServices.addIncidentAuditLog(incident.id, { action: 'Notified', detail: `Sent a manual notification via ${fenceNote}` }); } catch (e) { /* audit best-effort */ }
        setShowGeoFence(false);
        return true;
      } catch (error) {
        toast.error(error?.message || 'Failed to create and deliver the geo-fence notification');
        return false;
      }
    }
    if (type === 'verification') {
      setAckPrefilledSelections(selections);
      setAckGeoFenceTargeting(geoFenceTargeting);
      setShowGeoFence(false);
      setEditingAcknowledgment(null);
      setAcknowledgmentMode('config');
      setShowAcknowledgmentModal(true);
      return true;
    }
    if (type === 'status') {
      setStatusGeoFenceTargeting(geoFenceTargeting);
      setShowGeoFence(false);
      setEditingStatusUpdate(null);
      setStatusUpdateGroup('status_update');
      setShowStatusUpdateModal(true);
      return true;
    }
    if (type === 'action_card') {
      setResponsePrefilledSelections(selections);
      setResponseGeoFenceTargeting(geoFenceTargeting);
      setResponseActionPrefills({ prefilledName: '', prefilledUserIds: [], isImmediateTask: false });
      setShowGeoFence(false);
      setEditingResponseAction(null);
      setShowResponseActionModal(true);
      return true;
    }
    toast.error('Unsupported geo-fence action');
    return false;
  };
  const [hidePlanned, setHidePlanned] = useState(false);
  const revealTimelineItem = useCallback(() => setHidePlanned(false), []);

  const [allDepartments, setAllDepartments] = useState([]);
  const [serverRecipientScope, setServerRecipientScope] = useState(null);
  const [deptLeaderMap, setDeptLeaderMap] = useState({}); // cache deptId -> boolean (has leader)

  // Widget management states (persisted per incident in localStorage)
  const [showAddWidgetModal, setShowAddWidgetModal] = useState(false);
  const [visibleWidgets, setVisibleWidgets] = useState(() => loadVisibleWidgetsForIncident(id));
  const skipWidgetSaveRef = useRef(false);
  const [attachmentPreview, setAttachmentPreview] = useState(null); // { url, filename, contentType, isImage, isVideo, isAudio, isPDF }
  const [showLocationMappingModal, setShowLocationMappingModal] = useState(false);
  const [locations, setLocations] = useState([]);
  const timelineScrollRef = useRef(null);
  const [chatMessages, setChatMessages] = useState([]);
  const [trackedUser, setTrackedUser] = useState(null);

  // 12.2 — Private DM state
  const [dmOpen, setDmOpen] = useState(false);
  const [dmTargetUser, setDmTargetUser] = useState(null);
  const [currentUser, setCurrentUser] = useState(null);
  const isIncidentScopedLeader = useMemo(() => Boolean(
    !isAdmin
    && currentUser?.id
    && (incident?.scoped_leader_grants || []).some(
      (grant) => String(grant?.leader_id || '') === String(currentUser.id)
    )
  ), [isAdmin, currentUser?.id, incident?.scoped_leader_grants]);
  const scopedLeaderMemberIds = useMemo(() => {
    if (!currentUser?.id || isAdmin) return [];
    const grants = (incident?.scoped_leader_grants || []).filter((grant) => String(grant?.leader_id || '') === String(currentUser.id));
    const ids = new Set();
    const resolveRef = (ref) => {
      const value = String(ref || '').toLowerCase();
      return (appUsers || []).find((user) => [user.id, user.email, user.user_account, user.name].some((key) => String(key || '').toLowerCase() === value));
    };
    grants.forEach((grant) => {
      if (grant.scope_type === 'department') {
        const department = (allDepartments || []).find((row) => (
          String(row.id || '') === String(grant.scope_id)
          || String(row.department_name || '') === String(grant.scope_id)
        ));
        (department?.members || []).forEach((member) => ids.add(String(typeof member === 'object' ? (member.id || member.user_id) : member)));
        const departmentRefs = new Set([
          grant.scope_id,
          department?.id,
          department?.department_name,
        ].filter(Boolean).map(String));
        (appUsers || []).forEach((user) => {
          const userDepartments = [
            ...(Array.isArray(user.departments_units) ? user.departments_units : []),
            user.department_unit,
            user.department,
          ].filter(Boolean).map(String);
          if (userDepartments.some((ref) => departmentRefs.has(ref))) ids.add(String(user.id));
        });
      }
      const teams = grant.scope_type === 'team'
        ? (allTeams || []).filter((team) => String(team.id) === String(grant.scope_id))
        : (allTeams || []).filter((team) => (team.crews || []).some((crew) => String(crew.id) === String(grant.scope_id)));
      teams.forEach((team) => (team.crews || []).forEach((crew) => {
        if (grant.scope_type === 'crew' && String(crew.id) !== String(grant.scope_id)) return;
        (appUsers || []).filter((user) => String(user.crew_id || '') === String(crew.id)).forEach((user) => ids.add(String(user.id)));
        (crew.escalation_rules || []).forEach((rule) => {
          if (rule?.is_active === false) return;
          const refs = Array.isArray(rule.escalated_to) ? rule.escalated_to : [rule.escalated_to];
          refs.forEach((ref) => { const user = resolveRef(ref); if (user?.id) ids.add(String(user.id)); });
        });
      }));
    });
    ids.delete('undefined'); ids.delete('');
    return [...ids];
  }, [currentUser?.id, isAdmin, incident?.scoped_leader_grants, appUsers, allDepartments, allTeams]);
  const scopedRecipientScope = useMemo(() => {
    if (isAdmin) return null;
    const userIds = new Set([
      ...(serverRecipientScope?.userIds || []),
      ...scopedLeaderMemberIds,
    ].map(String));
    if (currentUser?.id) userIds.add(String(currentUser.id));
    const departmentIds = new Set((serverRecipientScope?.departmentIds || []).map(String));
    const teamIds = new Set((serverRecipientScope?.teamIds || []).map(String));
    const crewIds = new Set((serverRecipientScope?.crewIds || []).map(String));
    const grants = (incident?.scoped_leader_grants || []).filter(
      (grant) => String(grant?.leader_id || '') === String(currentUser?.id || '')
    );

    grants.forEach((grant) => {
      const scopeId = String(grant?.scope_id || '');
      if (!scopeId) return;
      if (grant.scope_type === 'department') {
        departmentIds.add(scopeId);
        const department = (allDepartments || []).find((row) => (
          String(row.id || '') === scopeId || String(row.department_name || '') === scopeId
        ));
        if (department?.id) departmentIds.add(String(department.id));
        if (department?.department_name) departmentIds.add(String(department.department_name));
        return;
      }
      if (grant.scope_type === 'team') {
        teamIds.add(scopeId);
        const team = (allTeams || []).find((row) => String(row.id || '') === scopeId);
        (team?.crews || []).forEach((crew) => {
          if (crew?.id) crewIds.add(String(crew.id));
        });
        return;
      }
      if (grant.scope_type === 'crew') crewIds.add(scopeId);
    });

    return {
      userIds: [...userIds],
      departmentIds: [...departmentIds],
      teamIds: [...teamIds],
      crewIds: [...crewIds],
    };
  }, [isAdmin, currentUser?.id, scopedLeaderMemberIds, incident?.scoped_leader_grants, allDepartments, allTeams, serverRecipientScope]);
  const [dmNotification, setDmNotification] = useState(null); // { senderId, senderName, text, timestamp }
  const [activeConversations, setActiveConversations] = useState([]);
  const [isDmSidebarOpen, setIsDmSidebarOpen] = useState(true);

  // Resolve currentUser from localStorage once on mount
  useEffect(() => {
    try {
      const stored = localStorage.getItem('user');
      if (stored) setCurrentUser(JSON.parse(stored));
    } catch (_) { }
  }, []);

  const isIncidentClosedOrResolved = (statusValue) => {
    const v = String(statusValue || "").trim().toLowerCase();
    return v === "closed" || v === "resolved";
  };

  const isReporter = useMemo(() => {
    const myId = currentUser?.id || currentUser?._id;
    const reporterId = incident?.reportedById || incident?.created_by;
    return myId && reporterId && String(myId) === String(reporterId);
  }, [currentUser, incident]);

  const isResolvedIncidentReadOnly = useMemo(
    () => isIncidentClosedOrResolved(incident?.status)
      || ['completed', 'cancelled', 'canceled', 'false_alarm', 'false alarm'].includes(
        String(incident?.status || '').trim().toLowerCase()
      )
      || (timelineItems || []).some(
        (item) => item?.group === 'resolution' && item?.is_active !== false
      ),
    [incident?.status, timelineItems]
  );
  const isIncidentReadOnly = isResolvedIncidentReadOnly;
  const canUseGeoFence = (isAdmin || isIncidentScopedLeader) && isGeoFenceOperationalIncident(
    incident,
    { readOnly: isIncidentReadOnly, scenarioMode }
  );
  const isReadinessClosed = isIncidentReadOnly || (
    incident?.is_exercise && ['completed', 'resolved', 'closed', 'cancelled'].includes(String(incident?.status || '').toLowerCase())
  );

  const guardIncidentMutation = useCallback(() => isIncidentReadOnly, [isIncidentReadOnly]);

  useEffect(() => {
    if (!routeLocation.state?.openGeoFence || !incident?.id) return;
    if (!isAdmin && !currentUser) return;
    if (canUseGeoFence) setShowGeoFence(true);
    const remainingState = { ...(routeLocation.state || {}) };
    delete remainingState.openGeoFence;
    navigate(`${routeLocation.pathname}${routeLocation.search}`, {
      replace: true,
      state: remainingState,
    });
  }, [canUseGeoFence, currentUser, incident?.id, isAdmin, navigate, routeLocation.pathname, routeLocation.search, routeLocation.state]);

  useEffect(() => {
    if (canUseGeoFence) return;
    setShowGeoFence(false);
    if (ackGeoFenceTargeting) {
      setShowAcknowledgmentModal(false);
      setAckPrefilledSelections(null);
      setAckGeoFenceTargeting(null);
    }
    if (responseGeoFenceTargeting) {
      setShowResponseActionModal(false);
      setResponsePrefilledSelections(null);
      setResponseGeoFenceTargeting(null);
    }
    if (statusGeoFenceTargeting) {
      setShowStatusUpdateModal(false);
      setStatusGeoFenceTargeting(null);
    }
  }, [ackGeoFenceTargeting, canUseGeoFence, responseGeoFenceTargeting, statusGeoFenceTargeting]);

  useEffect(() => {
    const timelineFocusRequest = routeLocation.state?.timelineFocusRequest;
    if (!timelineFocusRequest || !incident?.id) return undefined;

    const clearFocusRouteState = () => {
      const remainingState = { ...(routeLocation.state || {}) };
      delete remainingState.timelineFocusRequest;
      navigate(`${routeLocation.pathname}${routeLocation.search}`, {
        replace: true,
        state: remainingState,
      });
    };

    if (
      timelineFocusRequest.incidentId
      && String(timelineFocusRequest.incidentId) !== String(incident.id)
    ) {
      clearFocusRouteState();
      return undefined;
    }

    const frame = window.requestAnimationFrame(() => {
      dispatchTimelineFocus({
        ...timelineFocusRequest,
        incidentId: String(incident.id),
        itemId: String(timelineFocusRequest.itemId || ''),
        reason: timelineFocusRequest.reason || 'created',
        pauseAfterFocus: timelineFocusRequest.pauseAfterFocus !== false,
      });
      clearFocusRouteState();
    });
    return () => window.cancelAnimationFrame(frame);
  }, [incident?.id, navigate, routeLocation.pathname, routeLocation.search, routeLocation.state]);

  const guardModalOpen = useCallback((setter) => (value) => {
    if (isIncidentReadOnly && value) return;
    setter(value);
  }, [isIncidentReadOnly]);

  useEffect(() => {
    if (!incidentCopilotEligible) setShowIncidentCopilot(false);
  }, [incidentCopilotEligible]);

  // Safari Fix: Track if any modal is open to lock background scrolling and prevent bleed-through
  const isAnyModalOpen = useMemo(() => (
    showDetailsModal || showReportsModal || showChatModal ||
    showTimelineModal || showAcknowledgmentModal || showResponseActionModal ||
    showStatusUpdateModal || showResolutionModal || showNotificationModal ||
    showManualNotificationModal || showQuickAssign || showStaffModal ||
    showAddWidgetModal || showExtensiveModal || showIncidentCopilot || showGeoFence ||
    !!attachmentPreview || dmOpen
  ), [
    showDetailsModal, showReportsModal, showChatModal,
    showTimelineModal, showAcknowledgmentModal, showResponseActionModal,
    showStatusUpdateModal, showResolutionModal, showNotificationModal,
    showManualNotificationModal, showQuickAssign, showStaffModal,
    showAddWidgetModal, showExtensiveModal, showIncidentCopilot, showGeoFence,
    attachmentPreview, dmOpen
  ]);

  // Widget visibility is scoped per incident AND per stage ('active' vs 'planning') so that
  // choices made while planning never bleed into the live (active) layout — that bleed was
  // hiding Corrective Actions and keeping Attachments on after activation.
  const widgetStorageKey = (incId, status) => {
    const s = String(status || '').toLowerCase();
    // Completed gets its OWN stage key — it used to share 'planning', so the
    // planning layout (audit log, roles, resources…) bled into the debrief view.
    const stage = s === 'active' ? 'active' : s === 'completed' ? 'completed' : 'planning';
    return `incident-detail-widgets-v3-${incId}-${stage}`;
  };
  const widgetInitKeyRef = useRef(null);

  useEffect(() => {
    if (!id || !incident?.id) return;
    const key = widgetStorageKey(id, incident.status);
    if (widgetInitKeyRef.current === key) return; // already initialised for this incident + stage
    widgetInitKeyRef.current = key;
    let saved = null;
    try { const raw = localStorage.getItem(key); if (raw) saved = JSON.parse(raw); } catch (_) {}
    skipWidgetSaveRef.current = true; // this state update is initialisation — don't persist it
    const status = String(incident.status || '').toLowerCase();
    if (saved) {
      setVisibleWidgets({ ...DEFAULT_VISIBLE_WIDGETS, ...saved });
    } else if (incident.is_scenario) {
      setVisibleWidgets({ ...DEFAULT_VISIBLE_WIDGETS, ...SCENARIO_DEFAULT_WIDGETS });
    } else if (incident.is_exercise && status === 'active') {
      setVisibleWidgets({ ...DEFAULT_VISIBLE_WIDGETS, ...EXERCISE_ACTIVE_DEFAULT_WIDGETS });
    } else if (incident.is_exercise && status === 'completed') {
      setVisibleWidgets({ ...DEFAULT_VISIBLE_WIDGETS, ...EXERCISE_COMPLETED_DEFAULT_WIDGETS });
    } else if (incident.is_exercise && status === 'requested') {
      setVisibleWidgets({ ...DEFAULT_VISIBLE_WIDGETS, ...EXERCISE_REQUESTED_DEFAULT_WIDGETS });
    } else {
      setVisibleWidgets({
        ...DEFAULT_VISIBLE_WIDGETS,
        // Real incidents: the approved default layout — metrics, map,
        // participants, departments, corrective actions, resources,
        // attachments, chat, audit log (audit stays last on screen).
        ...(incident.is_exercise ? {} : {
          correctiveActions: true,
          teamsCrews: true,
          departments: true,
          availableResources: true,
        }),
      });
    }
  }, [id, incident?.id, incident?.status, incident?.is_exercise]);

  useEffect(() => {
    if (!id || !incident?.id || !widgetInitKeyRef.current) return;
    if (skipWidgetSaveRef.current) {
      skipWidgetSaveRef.current = false;
      return;
    }
    try { localStorage.setItem(widgetInitKeyRef.current, JSON.stringify(visibleWidgets)); } catch (_) {}
  }, [visibleWidgets, id, incident?.id]);

  // Fetch initial chat messages history to calculate unread counts
  useEffect(() => {
    if (!id || !currentUser) return;

    const fetchChatHistory = async () => {
      try {
        const res = await axios.get(`${ApiEndPoint}/api/incidents/${id}/messages`, {
          headers: { Authorization: `Bearer ${localStorage.getItem('access_token')}` }
        });
        if (res.data.status) {
          setChatMessages(res.data.data || []);
        }
      } catch (err) {
        console.error("Failed to fetch chat history in IncidentDetail:", err);
      }
    };

    fetchChatHistory();
  }, [id, currentUser]);

  // Listen to live socket events for new chat messages and read receipts
  useEffect(() => {
    if (!id || !currentUser) return;

    // Join room to receive new chat message events in real-time
    socketService.emit("join_incident", { incidentId: id });

    const handleNewMessage = (msg) => {
      if (String(msg.incidentId ?? "") !== String(id ?? "")) return;
      setChatMessages((prev) => {
        if (prev.some(m => String(m._id || m.id) === String(msg._id || msg.id))) return prev;
        return [...prev, msg];
      });
    };

    const handleReadReceipt = (data) => {
      if (String(data.incidentId ?? "") !== String(id ?? "")) return;
      setChatMessages(prev => prev.map(m => {
        if (m.incidentId === data.incidentId && !m.readBy?.includes(data.userId)) {
          return { ...m, readBy: [...(m.readBy || []), data.userId] };
        }
        return m;
      }));
    };

    socketService.on("new_chat_message", handleNewMessage);
    socketService.on("chat_read_receipt", handleReadReceipt);

    return () => {
      socketService.off("new_chat_message", handleNewMessage);
      socketService.off("chat_read_receipt", handleReadReceipt);
      socketService.emit("leave_incident", { incidentId: id });
    };
  }, [id, currentUser]);

  // Replace the old mock participant badge with actual socket presence. The
  // snapshot covers users already online; events keep it current afterward.
  useEffect(() => {
    let mounted = true;
    const permittedPresenceIds = new Set(
      (isAdmin ? [] : (scopedRecipientScope?.userIds || [])).map(String)
    );

    const refreshPresence = async () => {
      try {
        const response = await CommanServices.getOnlineUsers(id);
        if (!mounted || !response?.status) return;
        const userIds = Array.isArray(response?.data?.user_ids) ? response.data.user_ids : [];
        const rows = Array.isArray(response?.data?.users) ? response.data.users : userIds.map((userId) => ({
          user_id: userId,
          online: true,
          client_type: 'mobile',
          last_seen_at: null,
          state_changed_at: null,
          offline_reason: null,
        }));
        setMobilePresenceByUser((previous) => {
          const next = { ...previous };
          rows.forEach((row) => {
            const userId = String(row?.user_id || '').trim();
            if (!userId) return;
            const incomingVersion = Date.parse(row?.state_changed_at || row?.last_seen_at || '') || 0;
            const currentVersion = Date.parse(next[userId]?.state_changed_at || next[userId]?.last_seen_at || '') || 0;
            if (incomingVersion && currentVersion && incomingVersion < currentVersion) return;
            next[userId] = {
              user_id: userId,
              online: row?.online === true,
              client_type: 'mobile',
              last_seen_at: row?.last_seen_at || null,
              valid_until: row?.valid_until || null,
              state_changed_at: row?.state_changed_at || row?.last_seen_at || null,
              offline_reason: row?.offline_reason || null,
            };
          });
          return next;
        });
      } catch (error) {
        console.error('Error fetching online users:', error);
      }
    };

    const handlePresenceUpdate = ({ user_id: userId, online, last_seen_at: lastSeenAt, valid_until: validUntil, state_changed_at: stateChangedAt, offline_reason: offlineReason } = {}) => {
      if (!userId) return;
      const key = String(userId);
      if (!isAdmin && !permittedPresenceIds.has(key)) return;
      setMobilePresenceByUser((previous) => {
        const existing = previous[key] || {};
        const incomingVersion = Date.parse(stateChangedAt || lastSeenAt || '') || Date.now();
        const currentVersion = Date.parse(existing.state_changed_at || existing.last_seen_at || '') || 0;
        if (incomingVersion < currentVersion) return previous;
        return {
          ...previous,
          [key]: {
            ...existing,
            user_id: key,
            online: online === true,
            client_type: 'mobile',
            last_seen_at: lastSeenAt || existing.last_seen_at || null,
            valid_until: validUntil || null,
            state_changed_at: stateChangedAt || lastSeenAt || new Date().toISOString(),
            offline_reason: offlineReason || null,
          },
        };
      });
    };

    const unsubscribePresence = socketService.on('user_presence_updated', handlePresenceUpdate);
    const unsubscribeReconnect = socketService.on('connect', refreshPresence);
    refreshPresence();
    const presenceRefreshTimer = setInterval(refreshPresence, 15000);

    return () => {
      mounted = false;
      clearInterval(presenceRefreshTimer);
      unsubscribePresence();
      unsubscribeReconnect();
    };
  }, [id, isAdmin, scopedRecipientScope]);

  // Compute unread message count dynamically
  const unreadCount = useMemo(() => {
    if (!currentUser) return 0;
    const currentUserId = currentUser.id || currentUser._id;
    return chatMessages.filter(msg => {
      if (msg.userId === 'system' || msg.type === 'system') return false;
      if (String(msg.userId) === String(currentUserId)) return false;
      return !msg.readBy?.includes(currentUserId);
    }).length;
  }, [chatMessages, currentUser]);
  // Listen for Private DM notifications
  useEffect(() => {
    const handleDmNotification = (msg) => {
      // If modal is open for this sender, don't show toast (user is already chatting)
      if (dmOpen && dmTargetUser?.id === msg.senderId) return;

      const ts = Date.now();
      setDmNotification({
        senderId: msg.senderId,
        senderName: msg.senderName || "Responder",
        text: msg.text,
        timestamp: ts
      });

      // Auto-hide toast after 6 seconds
      setTimeout(() => {
        setDmNotification(prev => (prev?.timestamp === ts ? null : prev));
      }, 6000);
    };

    socketService.on("new_dm_notification", handleDmNotification);
    return () => socketService.off("new_dm_notification", handleDmNotification);
  }, [dmOpen, dmTargetUser]);

  const fetchActiveConversations = useCallback(async () => {
    if (!incident?.id) return;
    try {
      const res = await axios.get(`${ApiEndPoint}/api/dm/conversations`, {
        params: { incidentId: incident.id },
        headers: { Authorization: `Bearer ${localStorage.getItem("access_token")}` },
      });
      if (res.data.status) {
        setActiveConversations(res.data.data || []);
      }
    } catch (err) {
      console.error("Failed to fetch DM conversations:", err);
    }
  }, [incident?.id]);

  useEffect(() => {
    fetchActiveConversations();
  }, [fetchActiveConversations]);

  // Refresh conversations when a new DM notification arrives
  useEffect(() => {
    const handleRefresh = () => fetchActiveConversations();
    socketService.on("new_dm_notification", handleRefresh);
    return () => socketService.off("new_dm_notification", handleRefresh);
  }, [fetchActiveConversations]);

  // Refresh conversations when a DM message is sent or received in the active room
  useEffect(() => {
    const handleMessageReceived = () => {
      fetchActiveConversations();
    };
    window.addEventListener("dm_message_received", handleMessageReceived);
    return () => window.removeEventListener("dm_message_received", handleMessageReceived);
  }, [fetchActiveConversations]);

  // Timeline control states - moved from IncidentTimeline to IncidentDetail
  const [filter, setFilter] = useState('all');
  const [searchQuery, setSearchQuery] = useState('');
  const [expandedGroups, setExpandedGroups] = useState(() => {
    // Load from localStorage or default to all expanded
    if (id) {
      const saved = localStorage.getItem(`timeline-groups-${id}`);
      return saved ? JSON.parse(saved) : {
        report: true,
        notification: true,
        acknowledgment: true,
        assignment: true,
        response_action: true,
        status_update: true,
        resolution: true
      };
    }
    return {
      report: true,
      notification: true,
      acknowledgment: true,
      assignment: true,
      response_action: true,
      status_update: true,
      resolution: true
    };
  });

  useEffect(() => {
    const checkLeaderStatus = async () => {
      try {
        const storedUser = localStorage.getItem('user');
        if (!storedUser) return;
        const user = JSON.parse(storedUser);
        const admin = isInstitutionIncidentAdministrator(user);
        setIsAdmin(admin);
        if (!user?.id) return;

        const res = admin
          ? await CommanServices.departments()
          : await loadScopedRecipientDirectory(id);
        if (res) {
          const scopedDirectory = admin ? null : res;
          const rawDepts = scopedDirectory?.departments
            || (Array.isArray(res) ? res : (res.status && res.data ? res.data : []));
          const depts = rawDepts.map(d => ({
            ...d,
            id: d.id || d._id
          }));
          setAllDepartments(depts);
          if (scopedDirectory) {
            setAppUsers(scopedDirectory.users);
            setAllTeams(scopedDirectory.teams);
            setServerRecipientScope({
              userIds: scopedDirectory.allowedUserIds,
              departmentIds: scopedDirectory.allowedDepartmentIds,
              teamIds: scopedDirectory.allowedTeamIds,
              crewIds: scopedDirectory.allowedCrewIds,
            });
          }
          const ledIds = scopedDirectory?.allowedDepartmentIds || [];
          if (admin) {
            for (const d of depts) {
              let leader = false;
              if (d.leaders) {
                leader = d.leaders.some(l =>
                  l === user.id || l?.id === user.id || l?.user_account === user.id
                );
              }
              if (!leader && d.members) {
                leader = d.members.some(m =>
                  (m === user.id || m?.id === user.id || m?.user_account === user.id) && m?.is_leader === true
                );
              }
              if (leader && d.id) ledIds.push(d.id);
            }
          }
          setManagedDepartmentIds(ledIds);
          // Leadership is dormant until this incident explicitly grants a
          // durable organizational scope. Merely being a department/team/crew
          // leader must never expose incident-management controls.
          setIsDepartmentLeader(
            (incident?.scoped_leader_user_ids || []).map(String).includes(String(user.id))
          );
        }
      } catch (err) {
        console.error("Error checking leader status", err);
      }
    };
    checkLeaderStatus();
  }, [incident?.id, incident?.scoped_leader_user_ids]);

  // Route changes must never render the previous incident while the next one
  // is loading. Clear both incident and timeline before paint, then invalidate
  // every request that was started for the old route.
  const activeIncidentIdRef = useRef(id);
  const incidentDetailRequestRef = useRef(0);
  const timelineRequestRef = useRef(0);
  const planAdherenceRequestRef = useRef(0);
  const incidentListRequestRef = useRef(0);
  useLayoutEffect(() => {
    activeIncidentIdRef.current = id;
    incidentDetailRequestRef.current += 1;
    timelineRequestRef.current += 1;
    planAdherenceRequestRef.current += 1;
    incidentListRequestRef.current += 1;
    setIncident(null);
    setTimelineItems([]);
    setPlanAdherenceSnapshot(null);
    setError(null);
    setLoading(true);
    // A newly opened incident/scenario/drill always starts at the top. Normal
    // in-place refreshes do not touch scrollTop, so manual reading is preserved.
    if (timelineScrollRef.current) timelineScrollRef.current.scrollTop = 0;
  }, [id]);

  const fetchIncidentDetail = async (silent = false, targetIncidentId = id) => {
    if (activeIncidentIdRef.current !== targetIncidentId) return null;
    const requestId = ++incidentDetailRequestRef.current;
    try {
      // Full-page spinner only while nothing is on screen yet; refreshes are in place.
      if (!silent && !incident) setLoading(true);
      const res = await CommanServices.getIncidentDetail(targetIncidentId);
      if (
        activeIncidentIdRef.current !== targetIncidentId ||
        incidentDetailRequestRef.current !== requestId
      ) return null;
      if (res) {
        // Handle both wrapped {status, data} and raw incident object
        const data = (res.status !== undefined && res.data !== undefined) ? res.data : res;

        if (data && data.id) {
          if (data.is_planned_event && !data.is_exercise) {
            navigate('/dashboard', { replace: true });
            return null;
          }
          if (data.is_scenario && data.scenario_id && !scenarioMode) {
            navigate(
              `/incident-details/${data.id}?scenario=1&sid=${encodeURIComponent(data.scenario_id)}`,
              { replace: true }
            );
          }
          setIncident(data);
          // A silent socket refresh can legitimately overtake the initial
          // route request. Its accepted payload also completes page loading.
          setLoading(false);

        } else {
          if (!silent) setError('Failed to resolve incident data');
        }
      } else {
        if (!silent) setError('Failed to fetch incident details');
      }
    } catch (err) {
      if (!silent) {
        if (
          activeIncidentIdRef.current !== targetIncidentId ||
          incidentDetailRequestRef.current !== requestId
        ) return null;
        setError('An unexpected error occurred while fetching incident details');
        console.error(err);
      }
    } finally {
      if (
        !silent &&
        activeIncidentIdRef.current === targetIncidentId &&
        incidentDetailRequestRef.current === requestId
      ) setLoading(false);
    }
    return null;
  };

  const handleDepartmentsSync = useCallback(async ({ impactedDepartments, distributionList }) => {
    if (!incident?.id) return false;
    try {
      await persistDepartmentSync(incident.id, { impactedDepartments, distributionList });
      setIncident((prev) => {
        if (!prev) return prev;
        return {
          ...prev,
          ...(impactedDepartments !== undefined ? { impacted_departments: impactedDepartments } : {}),
          ...(distributionList !== undefined ? { distribution_list: distributionList } : {}),
        };
      });
      fetchIncidentDetail(true);
      return true;
    } catch (err) {
      console.error('Failed to sync departments', err);
      return false;
    }
  }, [incident?.id]);

  // 13.5 Intelligence: Sidebar always visible (mitigation now shown inline in timeline)

  const fetchPlanAdherence = async (targetIncidentId = id) => {
    if (activeIncidentIdRef.current !== targetIncidentId) return null;
    const requestId = ++planAdherenceRequestRef.current;
    const clearCurrentSnapshot = () => {
      if (
        activeIncidentIdRef.current === targetIncidentId
        && planAdherenceRequestRef.current === requestId
      ) setPlanAdherenceSnapshot(null);
    };
    try {
      const response = await CommanServices.getIncidentPlanAdherence(targetIncidentId);
      if (
        activeIncidentIdRef.current !== targetIncidentId
        || planAdherenceRequestRef.current !== requestId
      ) return null;
      if (response?.status === false) {
        clearCurrentSnapshot();
        return null;
      }
      const data = response?.data ?? response;
      if (!data || typeof data !== 'object') {
        clearCurrentSnapshot();
        return null;
      }
      if (data.incidentId && String(data.incidentId) !== String(targetIncidentId)) {
        clearCurrentSnapshot();
        return null;
      }
      setPlanAdherenceSnapshot(data);
      return data;
    } catch (error) {
      // Timeline data remains the complete local fallback. A metrics endpoint
      // failure must never block or clear the operational timeline.
      clearCurrentSnapshot();
      console.warn('Plan adherence snapshot unavailable; using timeline fallback', error);
      return null;
    }
  };

  const fetchTimelineData = async (targetIncidentId = id) => {
    if (activeIncidentIdRef.current !== targetIncidentId) return null;
    // Start the canonical calculation alongside the timeline request, but do
    // not await it here: timeline loading and interaction remain independent.
    void fetchPlanAdherence(targetIncidentId);
    const requestId = ++timelineRequestRef.current;
    try {
      const response = await CommanServices.getincidentTimeline(targetIncidentId);
      if (
        activeIncidentIdRef.current !== targetIncidentId ||
        timelineRequestRef.current !== requestId
      ) return null;
      if (response.status) {
        const data = await response.data;
        setTimelineItems(data);
      }
    } catch (error) {
      console.error('Error fetching timeline data:', error);
    }
    return null;
  };

  // Fetch all incidents for related incidents tracking
  const fetchAllIncidents = async () => {
    const targetIncidentId = activeIncidentIdRef.current;
    const requestId = ++incidentListRequestRef.current;
    try {
      const response = await CommanServices.getIncidentsData()
      if (
        response.status
        && activeIncidentIdRef.current === targetIncidentId
        && incidentListRequestRef.current === requestId
      ) {
        const data = await response.data;
        setIncidents(data);
      }
    } catch (error) {
      console.error('Error fetching all incidents:', error);
    }
  };

  useEffect(() => {
    fetchIncidentDetail(false, id);
    fetchTimelineData(id); // Also fetch timeline data for metrics
    fetchAllIncidents(); // Fetch all incidents for related count
    fetchLocations();
    fetchAppUsers();
    fetchTeams();
    fetchAllDepartments();

    // Silence continuous alarm for this user — fire and forget
    CommanServices.stopIncidentAlarm(id).catch(() => { });
  }, [id]);

  // The "Save setup as pre-configuration?" prompt was removed entirely by request.

  // Listen for timeline refresh events and reload incidents
  useEffect(() => {
    let refreshTimer = null;
    let timelineRefreshRequested = false;
    let incidentListRefreshRequested = false;
    const queueRefresh = ({ timeline = false, incidentList = false } = {}) => {
      timelineRefreshRequested = timelineRefreshRequested || timeline;
      incidentListRefreshRequested = incidentListRefreshRequested || incidentList;
      if (refreshTimer) clearTimeout(refreshTimer);
      refreshTimer = setTimeout(() => {
        refreshTimer = null;
        const shouldRefreshTimeline = timelineRefreshRequested;
        const shouldRefreshIncidentList = incidentListRefreshRequested;
        timelineRefreshRequested = false;
        incidentListRefreshRequested = false;
        if (shouldRefreshTimeline) fetchTimelineData();
        if (shouldRefreshIncidentList) fetchAllIncidents();
      }, 120);
    };
    const handleTimelineRefresh = (event) => {
      const changedIncidentId = event?.detail?.incident_id;
      if (changedIncidentId && String(changedIncidentId) !== String(id)) return;
      queueRefresh({ timeline: true, incidentList: true });
    };
    const handleDashboardRefresh = (event) => {
      const changedIncidentId = event?.detail?.incident_id;
      const changeType = String(event?.detail?.change_type || '');
      const currentIncidentChanged = !changedIncidentId || String(changedIncidentId) === String(id);
      const canChangeRelatedSet = [
        'incident_created',
        'incident_updated',
        'incident_deleted',
        'incident_archived',
      ].includes(changeType);
      if (!currentIncidentChanged && !canChangeRelatedSet) return;
      // A newly reported child/nearby incident has its own ID. Refresh the
      // authorized incident list for relationship-changing events, but never
      // reload this incident's timeline for unrelated activity.
      queueRefresh({
        timeline: currentIncidentChanged,
        incidentList: true,
      });
    };
    const handleSocketReconnect = () => {
      // Recover any plan fire/dispatch event missed while the socket was down,
      // so live Plan Adherence never remains calculated from stale card state.
      fetchTimelineData(id);
      fetchAllIncidents();
      window.dispatchEvent(new CustomEvent('refresh-activity-feed', {
        detail: { incident_id: id, reason: 'socket-reconnect' },
      }));
    };
    const unsubscribeReconnect = socketService.on('connect', handleSocketReconnect);

    window.addEventListener('timelineRefresh', handleTimelineRefresh);
    window.addEventListener('dashboardRefresh', handleDashboardRefresh);

    return () => {
      if (refreshTimer) clearTimeout(refreshTimer);
      unsubscribeReconnect();
      window.removeEventListener('timelineRefresh', handleTimelineRefresh);
      window.removeEventListener('dashboardRefresh', handleDashboardRefresh);
    };
  }, [id]);

  // Personnel picks must appear in every card/widget immediately. Socket and
  // timeline reconciliation still confirm server truth afterward, but cannot
  // visually erase an active assignment while the modal remains open.
  useEffect(() => {
    const handleOptimisticAssignments = (event) => {
      const detail = event?.detail || {};
      if (String(detail.incident_id || '') !== String(id)) return;
      const updates = new Map((detail.items || []).map((row) => [String(row.id), row.roleAssignments]));
      if (!updates.size) return;
      setTimelineItems((current) => current.map((item) => {
        const roleAssignments = updates.get(String(item?.id));
        if (!roleAssignments) return item;
        return { ...item, meta: { ...(item.meta || {}), roleAssignments } };
      }));
    };
    window.addEventListener(PERSONNEL_ASSIGNMENTS_OPTIMISTIC_EVENT, handleOptimisticAssignments);
    return () => window.removeEventListener(PERSONNEL_ASSIGNMENTS_OPTIMISTIC_EVENT, handleOptimisticAssignments);
  }, [id]);

  useEffect(() => {
    const handleIncidentRealtimeSync = (event) => {
      const syncIncidentId = event?.detail?.incident_id;
      if (!syncIncidentId || String(syncIncidentId) !== String(id)) return;
      if (event?.detail?.payload?.exercise_transition) {
        fetchIncidentDetail(true);
      }
      const changeType = String(event?.detail?.change_type || '');
      if (
        ['plan_activated', 'incident_updated'].includes(changeType)
        || changeType.startsWith('plan_auto_activation_')
      ) {
        fetchIncidentDetail(true);
      }
      // If the current user just sent a status-update reply, avoid refetch flicker/reload.
      try {
        const last = window.__lastStatusUpdateReplySent;
        const itemId = event?.detail?.payload?.timeline_item_id;
        if (
          last &&
          String(last.incidentId) === String(id) &&
          (!itemId || String(last.timelineItemId) === String(itemId)) &&
          Date.now() - Number(last.ts || 0) < 4000
        ) {
          console.log("Skipping realtime refetch for own reply to avoid flicker");
          return;
        }
      } catch (_) { }

      // App.js forwards this socket event as a scoped timelineRefresh event.
      // Avoid a second timeline request here; this handler only refreshes the
      // incident shell for state transitions that affect the banner/header.
    };

    window.addEventListener('incidentRealtimeSync', handleIncidentRealtimeSync);
    return () => window.removeEventListener('incidentRealtimeSync', handleIncidentRealtimeSync);
  }, [id]);

  // Refresh the incident header when a card approval changes (may auto-advance to "approved").
  useEffect(() => {
    const onApprovalChanged = () => { fetchIncidentDetail(true); };
    window.addEventListener('card-approval-changed', onApprovalChanged);
    return () => window.removeEventListener('card-approval-changed', onApprovalChanged);
  }, [id]);

  // Fetch departments associated with incident location — also called after
  // creating a department from the incident page so the widget refreshes.
  const fetchLocationDepartments = useCallback(async () => {
    if (!incident?.location || incident.location.length === 0) {
      setLocationDepartments([]);
      return;
    }

    try {
      setLoadingDepartments(true);
      // Fetch departments for the first location in the array
      const locationId = incident.location[0];
      const response = await CommanServices.getLocationDepartmentCounts(locationId);

      if (response.status) {
        const data = await response.data;
        setLocationDepartments(data || []);
      } else {
        setLocationDepartments([]);
      }
    } catch (error) {
      console.error('Error fetching location departments:', error);
      setLocationDepartments([]);
    } finally {
      setLoadingDepartments(false);
    }
  }, [incident?.location]);

  useEffect(() => {
    fetchLocationDepartments();
  }, [fetchLocationDepartments]);

  // Resolve leader presence for departments that lack inline leader info
  useEffect(() => {
    if (!isAdmin) return;
    if (!locationDepartments || !locationDepartments.length) return;
    const toFetch = locationDepartments.filter((d) => {
      const leadersArr = Array.isArray(d.leaders) ? d.leaders : [];
      const membersArr = Array.isArray(d.members) ? d.members : [];
      const leaderCountRaw = d.leader_count ?? d.leaderCount;
      const leaderCount = Number(leaderCountRaw);
      const immediateHasLeader = (Number.isFinite(leaderCount) ? leaderCount > 0 : false)
        || leadersArr.length > 0
        || membersArr.some(m => m?.is_leader === true)
        || Boolean(d.department_leader || d.departmentLeader || d.department_leader_id);
      return !immediateHasLeader && d.id && !(d.id in deptLeaderMap);
    });

    if (!toFetch.length) return;

    (async () => {
      for (const d of toFetch) {
        try {
          const res = await CommanServices.getbyIddepartments(d.id);
          if (res?.status) {
            const full = res.data || {};
            const leadersArr = Array.isArray(full.leaders) ? full.leaders : [];
            const membersArr = Array.isArray(full.members) ? full.members : [];
            const leaderCountRaw = full.leader_count ?? full.leaderCount;
            const leaderCount = Number(leaderCountRaw);
            const hasLeader = (Number.isFinite(leaderCount) ? leaderCount > 0 : false)
              || leadersArr.length > 0
              || membersArr.some(m => m?.is_leader === true)
              || Boolean(full.department_leader || full.departmentLeader || full.department_leader_id);
            setDeptLeaderMap(prev => ({ ...prev, [d.id]: !!hasLeader }));
          } else {
            setDeptLeaderMap(prev => ({ ...prev, [d.id]: false }));
          }
        } catch (e) {
          console.error('Failed to resolve dept leaders for', d.id, e);
          setDeptLeaderMap(prev => ({ ...prev, [d.id]: false }));
        }
      }
    })();
  }, [isAdmin, locationDepartments, CommanServices, deptLeaderMap]);

  // Fetch matched responders based on incident conditions
  useEffect(() => {
    const fetchMatchedResponders = async () => {
      if (!incident) {
        setMatchedResponders([]);
        return;
      }

      try {
        setLoadingResponders(true);

        // Build request payload
        const requestPayload = {
          incidentType: incident.incident_type || '',
          event: incident.event || '',
          trigger: incident.trigger || '',
          locationPath: incident.location || []
        };

        console.log('Fetching matched responders with:', requestPayload);

        const response = await CommanServices.teamsMatchedData(requestPayload);

        if (response.status) {
          const data = await response.data;
          console.log('Matched responders:', data);
          setMatchedResponders(data.candidates || []);
        } else {
          setMatchedResponders([]);
        }
      } catch (error) {
        console.error('Error fetching matched responders:', error);
        setMatchedResponders([]);
      } finally {
        setLoadingResponders(false);
      }
    };

    if (incident) {
      fetchMatchedResponders();
    }
  }, [incident?.incident_type, incident?.event, incident?.trigger, incident?.location]);

  const fetchLocations = async () => {
    try {
      const res = await CommanServices.getlocationszonesdata();
      if (res.status && res.data) {
        setLocations(res.data);
      }
    } catch (err) {
      console.error("Error fetching locations", err);
    }
  };

  // Firestore chat messages → extract playable/viewable media for the Attachments widget
  useEffect(() => {
    if (!id) return;
    const q = query(collection(db, 'incidents', id, 'messages'), orderBy('createdAt'));
    const unsubscribe = onSnapshot(
      q,
      (snapshot) => {
        const msgs = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setChatMediaAttachments(collectAttachmentsFromFirestore(msgs));
      },
      (err) => {
        console.error('Firestore chat error:', err);
      }
    );
    return () => unsubscribe();
  }, [id]);

  /** Incident report files + timeline (status updates, etc.) + chat — deduped */
  const allAttachmentsForWidget = useMemo(() => {
    const seen = new Set();
    const result = [];
    const push = (att) => {
      if (!att || typeof att !== 'object') return;
      const dk = attachmentDedupeKey(att);
      if (dk && seen.has(dk)) return;
      if (dk) seen.add(dk);
      result.push(att);
    };
    (incident?.attachments || []).forEach(push);
    collectAttachmentsFromTimelineItems(timelineItems).forEach(push);
    (chatMediaAttachments || []).forEach(push);
    return result;
  }, [incident?.attachments, timelineItems, chatMediaAttachments]);

  const loadScopedRecipientDirectory = async (targetIncidentId = id) => {
    if (isInstitutionIncidentAdministrator(readStoredWebUser()) || !targetIncidentId) return null;
    if (
      scopedDirectoryRequestRef.current.incidentId !== String(targetIncidentId)
      || !scopedDirectoryRequestRef.current.promise
    ) {
      scopedDirectoryRequestRef.current = {
        incidentId: String(targetIncidentId),
        promise: CommanServices.getIncidentRecipientDirectory(targetIncidentId)
          .then(normalizeIncidentRecipientDirectory)
          .then((directory) => {
            setServerRecipientScope({
              userIds: directory.allowedUserIds,
              departmentIds: directory.allowedDepartmentIds,
              teamIds: directory.allowedTeamIds,
              crewIds: directory.allowedCrewIds,
            });
            return directory;
          }),
      };
    }
    return scopedDirectoryRequestRef.current.promise;
  };

  const fetchAppUsers = async () => {
    try {
      const scopedDirectory = await loadScopedRecipientDirectory();
      if (scopedDirectory) {
        setAppUsers(scopedDirectory.users);
        return;
      }
      const response = await CommanServices.getAppUsers();
      if (response.status) {
        const data = await response.data;
        setAppUsers(data);
      }
    } catch (error) {
      console.error('Error fetching app users:', error);
    }
  };

  const fetchTeams = async () => {
    try {
      const scopedDirectory = await loadScopedRecipientDirectory();
      if (scopedDirectory) {
        setAllTeams(scopedDirectory.teams);
        return;
      }
      const response = await CommanServices.getTeamsData();
      if (response.status) {
        const data = await response.data;
        setAllTeams(data || []);
      }
    } catch (error) {
      console.error('Error fetching all teams:', error);
    }
  };

  const fetchAllDepartments = async () => {
    try {
      const scopedDirectory = await loadScopedRecipientDirectory();
      if (scopedDirectory) {
        setAllDepartments(scopedDirectory.departments);
        return;
      }
      const response = await CommanServices.departments();
      if (response.status) {
        const data = await response.data;
        if (Array.isArray(data)) setAllDepartments(data);
      }
    } catch (error) {
      console.error('Error fetching departments:', error);
    }
  };

  // Advance an exercise through its approval workflow
  const handleExerciseTransition = async (targetStatus) => {
    try {
      const response = await CommanServices.exerciseTransition(id, { status: targetStatus });
      if (response.status) {
        const updatedExercise = response?.data?.id ? response.data : (response?.id ? response : null);
        if (updatedExercise) {
          setIncident((previous) => ({ ...(previous || {}), ...updatedExercise }));
        }
        toast.success(`Exercise moved to ${targetStatus}`);
        await fetchIncidentDetail(true);
      } else {
        toast.error(response.message || response.massage || 'Failed to update exercise status');
      }
    } catch (error) {
      console.error('Exercise transition failed:', error);
      toast.error('Failed to update exercise status');
    }
  };

  // Guarded activation: a single drill time must be set before going live.
  const handleActivateOrTransition = async (targetStatus) => {
    if (targetStatus === 'active') {
      const win = (incident?.planned_windows || [])[0];
      if (!win || !win.start) {
        toast.error('Please set the drill time first (Proposed Schedule → Edit).');
        return;
      }
    }
    await handleExerciseTransition(targetStatus);
  };

  // Activation entry point from the requested stage. If the exercise was
  // launched from a scenario AND its content was modified, prompt to save it as
  // a new scenario before activating.
  const [activatePrompt, setActivatePrompt] = useState(false);
  const [savingAsScenario, setSavingAsScenario] = useState(false);
  const [driftInfo, setDriftInfo] = useState(null);
  const [newScenarioName, setNewScenarioName] = useState('');
  // Requested drills may be activated directly. Their planned window remains
  // the schedule source of truth while the lifecycle stays "requested".
  const [activateChoice, setActivateChoice] = useState(false);
  const handleRequestActivate = async () => {
    const win = (incident?.planned_windows || [])[0];
    if (!win || !win.start) {
      toast.error('Please set the drill time first (Proposed Schedule → Edit).');
      return;
    }
    setActivateChoice(true);
  };
  // Activate immediately (with the scenario-drift prompt if applicable).
  const proceedActivateNow = async () => {
    setActivateChoice(false);
    try {
      const res = await CommanServices.getScenarioDrift(incident.id);
      const d = res?.data ?? res;
      if (d?.from_scenario && d?.changed) {
        setDriftInfo(d);
        setNewScenarioName(d.suggested_name || '');
        setActivatePrompt(true);
        return;
      }
    } catch (e) { /* fall through to direct activation */ }
    await handleExerciseTransition('active');
  };
  const activateNow = async () => {
    setActivatePrompt(false);
    await handleExerciseTransition('active');
  };
  const saveAsNewScenarioThenActivate = async () => {
    setSavingAsScenario(true);
    try {
      const name = (newScenarioName || '').trim() || `${driftInfo?.scenario_name || 'Scenario'} (v2)`;
      const res = await CommanServices.saveExerciseAsScenario(incident.id, { name });
      if (res?.status !== false) {
        toast.success('Saved as a new scenario in the library');
      } else {
        toast.error(res?.message || 'Could not save as new scenario');
      }
    } catch (e) {
      toast.error('Could not save as new scenario');
    } finally {
      setSavingAsScenario(false);
      setActivatePrompt(false);
      await handleExerciseTransition('active');
    }
  };

  // Format incident ID for display (MG-2025-001 format)
  const formatIncidentId = (id) => {
    if (!id) return 'Unknown';
    // Extract parts and format
    const shortId = id.substring(0, 8).replace(/-/g, '').substring(0, 3);
    return `MG-2025-${shortId}`;
  };

  // Calculate time values
  const getIncidentTime = (timestamp) => {
    if (!timestamp) return '—';
    return new Date(timestamp).toLocaleTimeString('en-US', {
      hour12: false,
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  const getDuration = (startTime) => {
    if (!startTime) return '—';
    const start = new Date(startTime);
    const now = new Date();
    const diffMinutes = Math.floor((now - start) / (1000 * 60));
    return `${diffMinutes} Min`;
  };

  // Live ticking clock for operational timers. "Last Update" is deliberately
  // a relative snapshot, not a running counter.
  const [nowTick, setNowTick] = useState(0);
  useEffect(() => {
    const i = setInterval(() => setNowTick((t) => t + 1), 1000);
    return () => clearInterval(i);
  }, []);
  const lastUpdateLabel = useMemo(() => {
    const snapshotNow = Date.now();
    const candidates = [
      incident?.last_update_at,
      incident?.updated_at,
      incident?.activated_at,
      incident?.created_at,
      ...timelineItems.flatMap((item) => [item?.updated_at, item?.created_at]),
    ];
    const latestUpdateMs = candidates.reduce((latest, value) => {
      const date = parseTimestamp(value);
      const timestamp = date?.getTime();
      if (!Number.isFinite(timestamp) || timestamp > snapshotNow + 60000) return latest;
      return Math.max(latest, timestamp);
    }, Number.NEGATIVE_INFINITY);
    if (!Number.isFinite(latestUpdateMs)) return '--';

    const totalMinutes = Math.max(0, Math.floor((snapshotNow - latestUpdateMs) / 60000));
    if (totalMinutes < 1) return 'Just now';
    if (totalMinutes < 60) return `${totalMinutes}m ago`;

    const hours = Math.floor(totalMinutes / 60);
    if (hours < 24) {
      const minutes = totalMinutes % 60;
      return `${hours}h${minutes ? ` ${minutes}m` : ''} ago`;
    }

    const days = Math.floor(hours / 24);
    const remainingHours = hours % 24;
    return `${days}d${remainingHours ? ` ${remainingHours}h` : ''} ago`;
  }, [incident, timelineItems]);
  const [cancellingAutoActivation, setCancellingAutoActivation] = useState(false);
  const autoActivationStatus = String(incident?.plan_auto_activation_status || '').trim().toLowerCase();
  const autoActivationDueAtMs = incident?.plan_auto_activation_due_at
    ? new Date(incident.plan_auto_activation_due_at).getTime()
    : Number.NaN;
  const autoActivationSecondsRemaining = useMemo(() => {
    // nowTick deliberately makes this server-deadline calculation repaint once
    // per second without changing the persisted deadline.
    void nowTick;
    if (!Number.isFinite(autoActivationDueAtMs)) return null;
    return Math.max(0, Math.ceil((autoActivationDueAtMs - Date.now()) / 1000));
  }, [autoActivationDueAtMs, nowTick]);
  const autoActivationCountdownActive = (
    incident?.plan_state === 'planned'
    && autoActivationStatus === 'scheduled'
    && autoActivationSecondsRemaining !== null
  );
  const autoActivationCountdownLabel = autoActivationSecondsRemaining === null
    ? '--:--'
    : `${String(Math.floor(autoActivationSecondsRemaining / 60)).padStart(2, '0')}:${String(autoActivationSecondsRemaining % 60).padStart(2, '0')}`;
  const responsePlanState = String(incident?.plan_state || '').trim().toLowerCase();
  const responsePlanIsActive = responsePlanState === 'active';
  const hasPersistentResponsePlan = (
    !incident?.is_exercise
    && !incident?.is_scenario
    && ['planned', 'active'].includes(responsePlanState)
  );
  const fallbackPlanAdherence = useMemo(() => {
    // Keep a live local fallback so the KPI remains available if the canonical
    // metrics request fails or has not returned yet.
    void nowTick;
    return calculatePlanExecutionCompliance(timelineItems, incident, new Date());
  }, [timelineItems, incident, nowTick]);
  const planAdherence = useMemo(() => {
    void nowTick;
    const evaluatedAtMs = planAdherenceSnapshot?.evaluatedAt
      ? new Date(planAdherenceSnapshot.evaluatedAt).getTime()
      : Number.NaN;
    const snapshotAgeMs = Date.now() - evaluatedAtMs;
    const snapshotIsFresh = (
      Number.isFinite(evaluatedAtMs)
      && snapshotAgeMs <= 15000
      && snapshotAgeMs >= -60000
    );
    const snapshotMatchesIncident = (
      planAdherenceSnapshot
      && (!planAdherenceSnapshot.incidentId
        || String(planAdherenceSnapshot.incidentId) === String(incident?.id))
    );
    return snapshotMatchesIncident && snapshotIsFresh
      ? { ...fallbackPlanAdherence, ...planAdherenceSnapshot }
      : fallbackPlanAdherence;
  }, [fallbackPlanAdherence, planAdherenceSnapshot, incident?.id, nowTick]);
  const planSlaAssessed = Number.isFinite(Number(planAdherence.slaAssessed))
    ? Number(planAdherence.slaAssessed)
    : Number(planAdherence.slaMet || 0) + Number(planAdherence.slaLate || 0);
  const planCompletionPercent = planAdherence.due > 0
    ? (
      Number.isFinite(Number(planAdherence.completionRate))
        ? Number(planAdherence.completionRate)
        : Math.round((Number(planAdherence.completed || 0) * 1000) / Number(planAdherence.due)) / 10
    )
    : null;
  useEffect(() => {
    if (!hasPersistentResponsePlan) return;
    // Pending plans open for staffing. Activated plans persist as a compact,
    // collapsed control and remain user-expandable afterward.
    setPlanTimelineOpen(responsePlanState === 'planned');
  }, [incident?.id, responsePlanState, hasPersistentResponsePlan]);
  const handleCancelAutoActivation = async () => {
    if (!canActivateResponsePlan || !incident?.id || !autoActivationCountdownActive || autoActivationSecondsRemaining <= 0 || cancellingAutoActivation) return;
    setCancellingAutoActivation(true);
    try {
      const response = await CommanServices.cancelIncidentAutoActivation(incident.id);
      if (response?.status === false) throw new Error(response?.message || 'Automatic activation can no longer be stopped');
      toast.success('Automatic activation stopped — the response plan remains staged');
      await fetchIncidentDetail(true);
      window.dispatchEvent(new CustomEvent('timelineRefresh', { detail: { incident_id: incident.id } }));
    } catch (error) {
      toast.error(error?.message || 'Failed to stop automatic activation');
      await fetchIncidentDetail(true);
    } finally {
      setCancellingAutoActivation(false);
    }
  };

  // Get severity display with proper styling
  const getSeverityDisplay = (incident) => {
    const severity = incident?.resolved_severity || incident?.severity || 'Medium';
    const normalizedSeverity = severity.charAt(0).toUpperCase() + severity.slice(1).toLowerCase();
    return normalizedSeverity;
  };

  // Get severity badge color
  const getSeverityBadgeColor = (severity) => {
    switch (severity?.toLowerCase()) {
      case 'high':
      case 'critical':
        return 'bg-red-100 text-red-800 border-red-200';
      case 'medium':
      case 'moderate':
        return 'bg-orange-100 text-orange-800 border-orange-200';
      case 'low':
      case 'minor':
        return 'bg-yellow-100 text-yellow-800 border-yellow-200';
      default:
        return 'bg-gray-100 text-gray-800 border-gray-200';
    }
  };

  // Toggle widget visibility
  const toggleWidget = (widgetId) => {
    setVisibleWidgets(prev => ({
      ...prev,
      [widgetId]: !prev[widgetId]
    }));
  };

  const incidentContactUserId = (person) => String(
    person?.userId || person?.id || person?._id || ''
  );
  const canContactIncidentUser = (person) => {
    if (isAdmin) return true;
    const targetId = incidentContactUserId(person);
    return Boolean(
      targetId
      && (scopedRecipientScope?.userIds || []).map(String).includes(targetId)
    );
  };
  const guardIncidentContact = (person) => {
    if (canContactIncidentUser(person)) return false;
    toast.error('You can contact only members of the unit that granted access to this incident.');
    return true;
  };

  // Handle live tracking of a responder on the on-page map
  const handleTrackUser = async (responder) => {
    try {
      console.log(`📡 Fetching live GPS location to track responder: ${responder.userName || responder.email}`);
      const res = await CommanServices.getTeamLocations(incident?.id);

      let list = [];
      if (res && res.status && Array.isArray(res.data)) {
        list = res.data;
      } else if (Array.isArray(res)) {
        list = res;
      } else if (res && Array.isArray(res.data)) {
        list = res.data;
      }

      const matched = list.find(t => String(t.user_id) === String(responder.userId));

      if (matched && matched.lat && matched.lng) {
        setTrackedUser({
          userId: responder.userId,
          userName: responder.userName || responder.email || 'Responder',
          lat: Number(matched.lat),
          lng: Number(matched.lng)
        });

        // Find the map card and scroll to it smoothly
        const mapCard = document.getElementById('location-map-card');
        if (mapCard) {
          mapCard.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      } else {
        alert(`No active GPS location found for ${responder.userName || 'this responder'}. Make sure they are active on duty.`);
      }
    } catch (err) {
      console.error("❌ Error tracking user location:", err);
      alert("Failed to track responder location. Please try again.");
    }
  };

  // Handle direct notification broadcast to a responder
  const handleNotifyUser = async (responder) => {
    if (guardIncidentMutation()) return;
    if (guardIncidentContact(responder)) return;
    try {
      console.log(`🔔 Sending attention-required notification to: ${responder.userName || responder.email}`);
      const response = await CommanServices.notificationMaunal(incident.id, {
        user_ids: [responder.userId],
        department_ids: [],
        crew_ids: [],
        force: true,
        is_attention_only: true
      });

      if (response && response.status !== false) {
        alert(`Attention alert successfully sent to ${responder.userName || 'the responder'}.`);
      } else {
        alert(response?.message || 'Failed to send attention notification.');
      }
    } catch (error) {
      console.error("❌ Error notifying user:", error);
      alert("Failed to notify responder. Please try again.");
    }
  };

  const handleAddImmediateTask = (responder) => {
    if (guardIncidentMutation()) return;
    if (guardIncidentContact(responder)) return;
    setResponseActionPrefills({
      prefilledName: 'Immediate action card',
      prefilledUserIds: [responder.userId],
      isImmediateTask: true,
    });
    setEditingResponseAction(null);
    setShowResponseActionModal(true);
  };

  const handleRemoveIncidentParticipant = async (responder) => {
    const userId = String(responder?.userId || responder?.id || '').trim();
    if (!userId || !incident?.id || !canRemoveIncidentUser || removingIncidentUserId) return;
    const name = responder?.userName || responder?.name || responder?.email || 'this user';
    const confirmed = window.confirm(
      `Remove ${name} from this incident? They will immediately lose access to the incident, chat, cards, and interactions unless they are added again.`
    );
    if (!confirmed) return;

    setRemovingIncidentUserId(userId);
    try {
      const response = await axios.delete(
        `${ApiEndPoint}/api/incidents/${incident.id}/access/${encodeURIComponent(userId)}`,
        { headers: { Authorization: `Bearer ${localStorage.getItem('access_token')}` } }
      );
      const mutation = incidentMutationResult(response, 'Failed to remove this user from the incident');
      if (!mutation.data) {
        toast.error(mutation.error);
        return;
      }
      setIncident((current) => current ? {
        ...current,
        assigned_users: (current.assigned_users || []).filter((idValue) => String(idValue) !== userId),
        access_revoked_user_ids: [...new Set([...(current.access_revoked_user_ids || []).map(String), userId])],
      } : current);
      await fetchIncidentDetail(true);
      toast.success(`${name} was removed from the incident`);
    } catch (error) {
      toast.error(error?.response?.data?.detail || error?.message || 'Failed to remove this user from the incident');
    } finally {
      setRemovingIncidentUserId('');
    }
  };

  const handleDirectCall = async (responder, mode = 'voice') => {
    if (guardIncidentMutation()) return;
    if (guardIncidentContact(responder)) return;
    try {
      const response = await axios.post(`${ApiEndPoint}/api/calls/create`, {
        callType: mode,
        incidentId: id,
        invitedUsers: [responder.userId]
      }, {
        headers: { Authorization: `Bearer ${localStorage.getItem('access_token')}` }
      });
      if (response.data.status) {
        const data = response.data.data;
        const roomName = data?.roomName || response.data?.roomName;
        const callId = data?.id || data?._id || response.data?.id;
        navigate(`/meets?meeting_id=${roomName}&meetMode=${mode}&incidentId=${id}&callId=${callId}`);
      }
    } catch (error) {
      console.error("Direct call error:", error);
      alert("Failed to initiate call: " + (error.response?.data?.detail || error.message));
    }
  };

  // Department-level: call the department leader
  const handleCallLeader = async (dept) => {
    if (guardIncidentMutation()) return;
    try {
      const res = isAdmin ? await CommanServices.getbyIddepartments(dept.id) : null;
      const full = res?.status ? (res.data || {}) : dept;
      const leaderId =
        full.department_leader_id ||
        full.department_leader?.id ||
        full.department_leader?._id ||
        (Array.isArray(full.leaders) && (typeof full.leaders[0] === 'object' ? (full.leaders[0]?.id || full.leaders[0]?.user_id) : full.leaders[0])) ||
        (Array.isArray(full.members) && full.members.find(m => m.is_leader)?.id);
      if (!leaderId) {
        alert('No department leader found to call.');
        return;
      }
      if (guardIncidentContact({ id: leaderId })) return;
      const response = await axios.post(`${ApiEndPoint}/api/calls/create`, {
        callType: 'voice',
        incidentId: id,
        invitedUsers: [leaderId]
      }, { headers: { Authorization: `Bearer ${localStorage.getItem('access_token')}` } });
      if (response.data.status) {
        const data = response.data.data;
        const roomName = data?.roomName || response.data?.roomName;
        const callId = data?.id || data?._id || response.data?.id;
        navigate(`/meets?meeting_id=${roomName}&meetMode=voice&incidentId=${id}&callId=${callId}`);
      }
    } catch (error) {
      console.error('Call leader error:', error);
      alert('Failed to initiate call: ' + (error.response?.data?.detail || error.message));
    }
  };

  // Department-level: group call with all department members
  const handleCallStaff = async (dept) => {
    if (guardIncidentMutation()) return;
    try {
      const res = isAdmin ? await CommanServices.getbyIddepartments(dept.id) : null;
      const full = res?.status ? (res.data || {}) : dept;
      const memberIds = [
        ...(Array.isArray(full.members) ? full.members.map(m => m.id || m.user_id).filter(Boolean) : []),
        ...(Array.isArray(full.leaders) ? full.leaders.map(l => l.id || l.user_id).filter(Boolean) : [])
      ];
      const uniqueIds = [...new Set(memberIds)].filter((memberId) => (
        isAdmin || canContactIncidentUser({ id: memberId })
      ));
      if (uniqueIds.length === 0) {
        alert('No department members found to call.');
        return;
      }
      const response = await axios.post(`${ApiEndPoint}/api/calls/create`, {
        callType: 'voice',
        incidentId: id,
        invitedUsers: uniqueIds
      }, { headers: { Authorization: `Bearer ${localStorage.getItem('access_token')}` } });
      if (response.data.status) {
        const data = response.data.data;
        const roomName = data?.roomName || response.data?.roomName;
        const callId = data?.id || data?._id || response.data?.id;
        navigate(`/meets?meeting_id=${roomName}&meetMode=voice&incidentId=${id}&callId=${callId}`);
      }
    } catch (error) {
      console.error('Call staff error:', error);
      alert('Failed to initiate group call: ' + (error.response?.data?.detail || error.message));
    }
  };

  // Department-level: notify only the leader
  const handleNotifyLeader = async (dept) => {
    if (guardIncidentMutation()) return;
    try {
      const res = isAdmin ? await CommanServices.getbyIddepartments(dept.id) : null;
      const full = res?.status ? (res.data || {}) : dept;
      const leaderId =
        full.department_leader_id ||
        full.department_leader?.id ||
        full.department_leader?._id ||
        (Array.isArray(full.leaders) && (typeof full.leaders[0] === 'object' ? (full.leaders[0]?.id || full.leaders[0]?.user_id) : full.leaders[0])) ||
        (Array.isArray(full.members) && full.members.find(m => m.is_leader)?.id);
      if (!leaderId) {
        alert('No department leader found to notify.');
        return;
      }
      if (guardIncidentContact({ id: leaderId })) return;
      const response = await CommanServices.notificationMaunal(incident.id, {
        user_ids: [leaderId],
        department_ids: [],
        crew_ids: [],
        force: true,
        is_attention_only: true,
        message: 'Get attention to that incident'
      });
      if (response && response.status !== false) {
        alert(`Attention alert sent to the department leader (${full.department_leader?.name || full.department_leader?.username || 'Leader'}).`);
      } else {
        alert(response?.message || 'Failed to send notification.');
      }
    } catch (error) {
      console.error('Notify leader error:', error);
      alert('Failed to notify department leader. Please try again.');
    }
  };

  // Department-level: notify all staff
  const handleNotifyStaff = async (dept) => {
    if (guardIncidentMutation()) return;
    try {
      const response = await CommanServices.notificationMaunal(incident.id, {
        user_ids: [],
        department_ids: [dept.id],
        crew_ids: [],
        force: true,
        is_attention_only: true,
        message: 'Get attention to that incident'
      });
      if (response && response.status !== false) {
        alert(`Attention alert sent to all staff of "${dept.department_name || 'this department'}".`);
      } else {
        alert(response?.message || 'Failed to send notification.');
      }
    } catch (error) {
      console.error('Notify staff error:', error);
      alert('Failed to notify department staff. Please try again.');
    }
  };

  const handleOpenPrivateChat = (targetUser) => {
    if (guardIncidentContact(targetUser)) return;
    const myId = currentUser?.id || currentUser?._id;
    const otherId = targetUser?.userId || targetUser?.id || targetUser?._id;

    if (myId && otherId) {
      const validIncId = (incident?.id && String(incident.id) !== "undefined" && String(incident.id) !== "null") ? String(incident.id) : null;
      const prefix = validIncId ? `DM-${validIncId}-` : "DM-";
      const room = targetUser.room || prefix + [String(myId), String(otherId)].sort().join("_");

      const exists = activeConversations.some(conv => conv.room === room);
      if (!exists) {
        const placeholder = {
          room,
          otherId: String(otherId),
          otherName: targetUser.name || "Responder",
          lastCreatedAt: new Date().toISOString(),
          lastText: "Opening chat..."
        };
        setActiveConversations(prev => [placeholder, ...prev]);
      }
    }

    setDmTargetUser(targetUser);
    setDmOpen(true);
  };

  // The catalog is workspace-aware: scenario templates omit live-only timing
  // and the redundant standalone chat card.
  const availableWidgets = buildIncidentDetailWidgetCatalog({
    incident,
    scenarioEnv,
    scenarioMode,
  });

  // Get location display - updated to handle LocationSelector arrays and location_names
  const getLocationDisplay = (incident) => {
    const projection = incident?.map_projection;
    const projected = projection?.official_coordinates || projection?.coordinates;
    const projectedLat = projected?.latitude ?? projected?.lat;
    const projectedLng = projected?.longitude ?? projected?.lng;
    if (projection?.official && projectedLat != null && projectedLng != null) {
      return `${Number(projectedLat).toFixed(6)}, ${Number(projectedLng).toFixed(6)}`;
    }
    if (projection?.location_name) return projection.location_name;
    const incidentGps = getIncidentGpsCoordinates(incident);
    if (isUnknownIncidentLocation(incident)) {
      if (incidentGps) {
        return `Reporter Device GPS (${incidentGps.lat.toFixed(6)}, ${incidentGps.lng.toFixed(6)})`;
      }
      return 'Unknown Location (Needs Mapping)';
    }
    if (incidentGps) {
      return `GPS (${incidentGps.lat.toFixed(6)}, ${incidentGps.lng.toFixed(6)})`;
    }
    // First check if we have resolved location names from backend
    if (incident?.location_names && Array.isArray(incident.location_names) && incident.location_names.length > 0) {
      return incident.location_names.join(', ');
    }

    // Fallback to location field
    const location = incident?.location || incident;

    // Handle LocationSelector array format (list of location IDs)
    if (Array.isArray(location)) {
      if (location.length === 0) return 'No location specified';
      return `${location.length} location(s) selected`;
    }

    // Handle legacy formats
    if (typeof location === 'string') return location;
    if (location?.display_label) return location.display_label;
    if (location?.location) return location.location;
    return 'No location specified';
  };

  const getDepartmentDetails = async (dept) => {
    console.log("dept", dept)
    // try {
    //   // Fetch full department details including members
    //   const response = await CommanServices.getbyIddepartments(dept.id);
    //   console.log("response", response)
    //   if (response.status) {
    //     const fullDepartment = await response.data;
    //     setSelectedDepartment(fullDepartment);
    //     setShowStaffModal(true);
    //   } else {
    //     console.error('Failed to fetch department details');
    //     // Fallback to existing data
    //     setSelectedDepartment(dept);
    //     setShowStaffModal(true);
    //   }
    // } catch (error) {
    //   console.error('Error fetching department:', error);
    //   // Fallback to existing data
    //   setSelectedDepartment(dept);
    //   setShowStaffModal(true);
    // }
  }

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-gray-100">
        <div className="text-center">
          <img src={Logo} alt="App logo" className="h-32 w-32 mx-auto animate-pulse" />
          <p className="mt-4 text-gray-600">Loading incident details...</p>
        </div>
      </div>
    );
  }

  if (error || !incident) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-gray-100">
        <div className="text-center">
          <AlertCircle className="h-16 w-16 text-red-500 mx-auto mb-4" />
          <p className="text-xl text-gray-700 mb-4">{error || 'Incident not found'}</p>
          <Button onClick={() => navigate('/')} variant="outline">
            Back to Dashboard
          </Button>
        </div>
      </div>
    );
  }

  if (scenarioMode && !canManageScenarioLibrary) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-gray-100 p-6">
        <div className="max-w-lg rounded-2xl border border-amber-200 bg-white p-8 text-center shadow-xl" role="alert">
          <AlertCircle className="h-14 w-14 text-amber-500 mx-auto mb-4" />
          <p className="text-xl font-bold text-gray-900">Scenario access required</p>
          <p className="mt-2 text-sm leading-6 text-gray-600">Only an Institution Administrator can manage scenario templates.</p>
          <Button onClick={() => navigate('/scenario-library')} variant="outline" className="mt-5">Back to Scenario Library</Button>
        </div>
      </div>
    );
  }

  // Active-stage exercise: drives the special active-only widget layout (Metrics → Map → Chat on top)
  // and the active-only big "Add Widget" button. Requested/Scenario keep their original layout.
  const isActiveExercise = !!incident?.is_exercise && String(incident?.status || '').toLowerCase() === 'active';
  const isCompletedStage = !!incident?.is_exercise && String(incident?.status || '').toLowerCase() === 'completed';
  // Once finished, freeze every timer/counter to the completion moment.
  const completionAnchor = isCompletedStage ? (incident?.completed_at || incident?.finished_at || incident?.updated_at) : null;
  // Real incidents freeze the same way at resolution: Resolve Incident stops all
  // counting at the resolved moment, exactly like Finish does for an exercise.
  const resolutionCard = (timelineItems || []).find((it) => it?.group === 'resolution' && it?.is_active !== false);
  const isResolvedRealIncident = !incident?.is_exercise
    && (['resolved', 'closed'].includes(String(incident?.status || '').toLowerCase()) || !!resolutionCard);
  const clockFreezeAnchor = isCompletedStage
    ? completionAnchor
    : (isResolvedRealIncident ? (incident?.resolved_at || resolutionCard?.timestamp || incident?.updated_at) : null);
  const clockNowMs = () => {
    if (clockFreezeAnchor) {
      const d = parseTimestamp(clockFreezeAnchor);
      if (d && !Number.isNaN(d.getTime())) return d.getTime();
    }
    return Date.now();
  };


  return (
    <div className="h-screen bg-gray-50 flex overflow-hidden">
      {/* Main Content Area */}
      <div className="flex-1 flex flex-col overflow-hidden">
        {/* Header - Exact Match to Dashboard Header Design */}
        <div className={`${scenarioMode ? 'bg-gradient-to-r from-violet-950 via-indigo-900 to-cyan-900 border-cyan-700/40' : 'bg-gradient-to-r from-gray-900 to-blue-900 border-blue-800'} border-b px-6 py-4 flex-shrink-0 shadow-md`}>
          <div className="flex items-center justify-between gap-4">
            {/* Left - Type — Event — Trigger */}
            <div className="flex-1 min-w-0">
              <h1 className="text-xl font-bold text-white truncate" title={scenarioMode ? (scenarioName || incident.title) : incident.incident_type}>
                {scenarioMode ? (
                  scenarioName || incident?.title || 'Untitled Scenario'
                ) : (() => {
                  // Build the title parts array, only including non-empty values (without location)
                  const parts = [];

                  // Add incident type if available
                  if (incident.incident_type && incident.incident_type !== 'Unknown Type') {
                    parts.push(incident.incident_type);
                  }

                  // Add event if available
                  if (incident.event) {
                    parts.push(incident.event);
                  }

                  // Add trigger if available  
                  if (incident.trigger) {
                    parts.push(incident.trigger);
                  }

                  // Join with em dashes, fallback to "Incident Details" if no parts
                  return parts.length > 0 ? parts.join(' — ') : 'Incident Details';
                })()}
              </h1>

              {/* Location as H2 below the main title */}
              {scenarioMode ? (
                <h2 className="text-sm text-cyan-300 mt-1 font-medium flex items-center gap-2" data-testid="scenario-env-label">
                  <FlaskConical className="h-4 w-4" />
                  Scenario Builder — design environment
                  {(() => {
                    const st = String(scenarioStatus || 'Draft');
                    const map = {
                      Draft: { label: 'Draft', cls: 'bg-amber-400/20 text-amber-200 border-amber-400/40' },
                      Active: { label: 'Active', cls: 'bg-emerald-400/20 text-emerald-200 border-emerald-400/40' },
                    };
                    const cfg = map[st] || { label: 'Achieved', cls: 'bg-violet-400/20 text-violet-200 border-violet-400/40' };
                    return (
                      <span data-testid="scenario-status-chip" className={`ml-1 inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-[10px] font-bold uppercase tracking-wide ${cfg.cls}`}>
                        <span className="h-1.5 w-1.5 rounded-full bg-current" /> {cfg.label}
                      </span>
                    );
                  })()}
                  {(() => {
                    const level = scenarioLevel || incident?.level;
                    if (!level) return null;
                    const map = {
                      Strategic: 'bg-purple-400/20 text-purple-100 border-purple-300/40',
                      Tactical: 'bg-blue-400/20 text-blue-100 border-blue-300/40',
                      Operational: 'bg-teal-400/20 text-teal-100 border-teal-300/40',
                    };
                    const cls = map[level] || 'bg-white/15 text-white border-white/30';
                    return (
                      <span data-testid="scenario-level-chip" className={`ml-1 inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-[10px] font-bold uppercase tracking-wide ${cls}`}>
                        {level}
                      </span>
                    );
                  })()}
                </h2>
              ) : (() => {
                const location = getLocationDisplay(incident);
                if (location && location !== 'No location specified' && !location.includes('location(s) selected')) {
                  return (
                    <h2 className="text-lg text-gray-300 mt-1">
                      Incident ID: {incident.id}
                    </h2>

                  );
                }
                return null;
              })()}
            </div>

            {/* Right - Status and Severity Chips */}
            <div className="flex items-center gap-3 ml-6">

              {/* Root Incident Chip (if has children but no parent) */}
              {(() => {
                const hasChildren = incidents.filter(i => i.parent_incident_id === incident?.id).length > 0;
                const hasNoParent = !incident?.parent_incident_id;

                if (hasChildren && hasNoParent) {
                  return (
                    <div
                      className="px-3 py-2 rounded-full font-semibold text-sm bg-yellow-100 text-yellow-800 border-2 border-yellow-400 shadow-lg"
                      title="This is a root incident with related child incidents"
                    >
                      Root Incident
                    </div>
                  );
                }
                return null;
              })()}

              {(() => {
                const linkedId = incident?.parent_incident_id;
                const hasLinked = !!linkedId && incident.id !== linkedId;

                return (
                  <div className="flex flex-wrap items-center gap-2">
                    {/* Child -> Parent Link */}
                    {hasLinked && (
                      <button
                        onClick={() => navigate(`/incident-details/${linkedId}`)}
                        className="px-4 py-2 rounded-xl font-bold text-[11px] uppercase tracking-wider text-white shadow-lg hover:-translate-y-0.5 transition-all flex items-center gap-2 border bg-purple-600 hover:bg-purple-700 border-purple-500"
                        title="Navigate to parent incident"
                      >
                        <Link2 className="w-4 h-4" />
                        Related Incident
                      </button>
                    )}
                  </div>
                );
              })()}

              {/* Status Chip */}
              {!scenarioMode && (() => {
                const status = incident?.status || 'open';
                const statusColors = {
                  'open': 'bg-red-500 text-white border-red-600',
                  'resolved': 'bg-green-500 text-white border-green-600',
                  'in_progress': 'bg-yellow-500 text-white border-yellow-600',
                  'requested': 'bg-violet-600 text-white border-violet-700',
                  'active': 'bg-indigo-600 text-white border-indigo-700',
                  'completed': 'bg-emerald-600 text-white border-emerald-700'
                };
                const statusLabels = {
                  'open': 'Open',
                  'resolved': 'Resolved',
                  'in_progress': 'In Progress',
                  'requested': 'Requested',
                  'active': 'Active',
                  'completed': 'Completed'
                };
                const colorClass = statusColors[status.toLowerCase()] || statusColors['open'];
                const label = statusLabels[status.toLowerCase()] || status;
                return <div className={`px-4 py-2 rounded-xl font-bold text-[11px] uppercase tracking-wider border-2 ${colorClass} shadow-lg shadow-black/10`}>{label}</div>;
              })()}

              {/* Alert Severity Chip */}
              {(() => {
                const severity = incident?.severity || incident?.alert_level || 'Medium';
                const severityColors = {
                  'Critical': 'bg-red-600 text-white border-red-700',
                  'High': 'bg-red-500 text-white border-red-600',
                  'Medium': 'bg-orange-500 text-white border-orange-600',
                  'Low': 'bg-yellow-400 text-yellow-900 border-yellow-500'
                };
                const colorClass = severityColors[severity] || severityColors['Medium'];

                return (
                  <div
                    data-testid="header-severity-chip"
                    className={`inline-flex items-center justify-center text-center min-w-[84px] px-4 py-2 rounded-xl font-bold text-[11px] uppercase tracking-wider border-2 ${colorClass} shadow-lg shadow-black/10`}
                  >
                    {severity}
                  </div>
                );
              })()}

              {/* Exercise Classification chip — visible to everyone */}
              {incident?.is_exercise && incident?.exercise_classification && (
                <div
                  data-testid="header-exercise-classification"
                  className="px-4 py-2 rounded-xl font-bold text-[11px] uppercase tracking-wider border-2 bg-emerald-100 text-emerald-700 border-emerald-300 shadow-lg shadow-black/10"
                >
                  {incident.exercise_classification}
                </div>
              )}

              {/* Current viewer's Discussion-Group role chip */}
              {(() => {
                if (!incident?.is_exercise) return null;
                const myId = currentUser?.id || currentUser?._id;
                if (!myId) return null;
                let myRole = '';
                for (const e of (incident.discussion_group || [])) {
                  const cps = e.contact_persons || [];
                  if (cps.some((c) => String(typeof c === 'object' ? c.id : c) === String(myId))) {
                    myRole = e.role;
                    break;
                  }
                }
                if (!myRole) return null;
                return (
                  <div
                    data-testid="header-my-role"
                    className="px-4 py-2 rounded-xl font-bold text-[11px] uppercase tracking-wider border-2 bg-indigo-100 text-indigo-700 border-indigo-300 shadow-lg shadow-black/10"
                  >
                    {myRole}
                  </div>
                );
              })()}

              {isContextAdmin && incidentCopilotEligible && (
                <IncidentCopilotButton onClick={() => setShowIncidentCopilot(true)} compact />
              )}

              {/* Workspace chat is always the final header control. */}
              <button
                type="button"
                onClick={() => navigate(chatWorkspaceUrl)}
                className="relative flex h-9 w-9 items-center justify-center rounded-lg bg-white/10 border border-white/15 text-white hover:bg-white/20 transition-colors"
                title={scenarioEnv ? 'Open scenario chat' : 'Open incident chat'}
                aria-label={scenarioEnv ? 'Open scenario chat' : 'Open incident chat'}
                data-testid="header-chat-btn"
              >
                <MessageSquare className="h-4 w-4" />
                {unreadCount > 0 && (
                  <span
                    className="absolute -top-1.5 -right-1.5 flex h-[18px] min-w-[18px] items-center justify-center rounded-full bg-red-500 px-1 text-[10px] font-bold text-white shadow"
                    data-testid="header-chat-unread"
                  >
                    {unreadCount > 99 ? '99+' : unreadCount}
                  </span>
                )}
              </button>

            </div>
          </div>
        </div>

        {/* Main Content - Two Column Layout with Dynamic Sidebar */}
        <div className="flex-1 overflow-hidden bg-gray-50">
          <div className={`grid ${isSidebarCollapsed ? 'grid-cols-1' : 'grid-cols-[minmax(400px,1fr)_640px]'} gap-6 h-full`}>
            {/* Left Main Content Area - Content depends on activeTab */}
            <main
              data-modal-scroll-root
              className={`no-scrollbar ${isAnyModalOpen ? 'overflow-hidden' : 'overflow-y-auto'} p-6 ${isActiveExercise ? 'flex flex-col' : ''}`}
            >

              {incident?.is_exercise && (
                <div className={`flex items-stretch gap-3 mb-4 ${isActiveExercise ? 'order-first' : ''}`}>
                  <div className="flex-1 min-w-0">
                    <RelatedIncidentsBanner incidents={incidents} incident={incident} navigate={navigate} inRow />
                  </div>
                  {String(incident?.status || '').toLowerCase() === 'active' && (canControlDrillRuntime || canChangeDrillStatus) ? (
                    <ExerciseHeaderControls
                      incident={incident}
                      onRefresh={(silent = true) => fetchIncidentDetail(silent)}
                      onFinish={() => handleActivateOrTransition('completed')}
                      canControlRuntime={canControlDrillRuntime}
                      canChangeStatus={canChangeDrillStatus}
                    />
                  ) : (
                    <button
                      data-testid="add-widget-inline-btn"
                      onClick={() => setShowAddWidgetModal(true)}
                      className="flex-shrink-0 flex items-center gap-2 bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 rounded-lg border border-blue-300 px-4 shadow-sm text-white text-xs font-semibold transition-all duration-200"
                      title="Add or manage widgets"
                    >
                      <Plus className="h-4 w-4" /> Add Widget
                    </button>
                  )}
                </div>
              )}

              {incident?.is_exercise && (
                scenarioEnv || String(incident?.status || '').toLowerCase() === 'requested'
              ) && (
                <div className="mb-4">
                  <PlanningTabContent
                    incident={incident}
                    isAdmin={isContextAdmin}
                    canChangeDrillStatus={canChangeDrillStatus}
                    canManageOperationalRoles={scenarioMode ? isContextAdmin : canManageOperationalRoles}
                    allDepartments={allDepartments}
                    onRefresh={(silent = false) => fetchIncidentDetail(silent)}
                    onDepartmentsSync={handleDepartmentsSync}
                    locations={locations}
                    onOpenLocationMapping={() => setShowLocationMappingModal(true)}
                    onExerciseTransition={handleExerciseTransition}
                    onRequestActivate={handleRequestActivate}
                    unstaffedInjectCount={unstaffedInjectCount}
                    scenarioMode={scenarioMode}
                    scenarioId={scenarioId}
                    scenarioAutoActivateOnMatch={scenarioAutoActivateOnMatch}
                    scenarioAutoActivateReadinessWindowMinutes={scenarioAutoActivateReadinessWindowMinutes}
                    onPersistScenarioActivationPolicy={persistScenarioActivationPolicy}
                    hideTimeline={true}
                    inlineStaffingAvailable={false}
                    onOpenQuickAssign={() => setShowQuickAssign(true)}
                  />
                </div>
              )}

              {incident?.is_exercise && visibleWidgets.simulationObjective && !isCompletedStage && (
                <CollapsibleWidget
                  title="Simulation Objective"
                  testId="widget-simulation-objective"
                  defaultOpen={!scenarioEnv && String(incident?.status || '').toLowerCase() !== 'completed'}
                  variant={scenarioEnv ? 'scenario' : 'default'}
                  icon={Target}
                >
                <Card className="bg-white shadow-none border-0 rounded-none">
                  <CardContent className="p-4">
                    <SimulationObjective
                      incident={incident}
                      isAdmin={isContextAdmin}
                      onRefresh={(silent = true) => fetchIncidentDetail(silent)}
                    />
                  </CardContent>
                </Card>
                </CollapsibleWidget>
              )}

              {incident?.is_exercise && visibleWidgets.discussionGroup && !isCompletedStage && (
                <CollapsibleWidget
                  title={scenarioEnv ? 'Scenario Discussion Group' : (String(incident?.status || '').toLowerCase() === 'active' ? 'Active Drill Discussion Group' : 'Plan Discussion Group')}
                  testId="widget-discussion-group"
                  defaultOpen={!scenarioEnv && String(incident?.status || '').toLowerCase() !== 'completed'}
                  variant={scenarioEnv ? 'scenario' : 'default'}
                  icon={MessageSquare}
                >
                <Card className="bg-white shadow-none border-0 rounded-none">
                  <CardContent className="p-4">
                    <ExerciseDiscussionGroup
                      incident={incident}
                      isAdmin={isContextAdmin}
                      scenarioMode={scenarioMode}
                      allDepartments={allDepartments}
                      appUsers={appUsers}
                      allTeams={allTeams}
                      onRefresh={() => fetchIncidentDetail(true)}
                      onChat={handleOpenPrivateChat}
                      onChatAll={() => navigate(chatWorkspaceUrl)}
                    />
                  </CardContent>
                </Card>
                </CollapsibleWidget>
              )}

              {/* Corrective Actions & AAR — placed right after the discussion group at the ACTIVE stage only */}
              {canRecordDrillEvaluations && isActiveExercise && visibleWidgets.correctiveActions && (
                <div className="mb-4" data-testid="widget-corrective-actions"><CorrectiveActionsPanel incident={incident} /></div>
              )}

              {incident?.is_exercise && visibleWidgets.assignedRoles && (
                <CollapsibleWidget
                  title="Required Roles"
                  testId="widget-assigned-roles"
                  defaultOpen={!scenarioEnv}
                  variant={scenarioEnv ? 'scenario' : 'default'}
                  icon={Users}
                >
                  <AssignedRolesWidget incident={incident} scenarioId={scenarioMode ? scenarioId : null} />
                </CollapsibleWidget>
              )}

              {incident?.is_exercise && (
                scenarioEnv || ['requested', 'active'].includes(String(incident?.status || '').toLowerCase())
              ) && visibleWidgets.exerciseTimeline && (
                <CollapsibleWidget
                  title="Injection Sequence"
                  testId="widget-exercise-timeline"
                  defaultOpen
                  variant={scenarioEnv ? 'scenario' : 'default'}
                  icon={Zap}
                >
                  {/* Drills use the same clean preview as the scenario env —
                      staffing happens through "Review staffing" (QuickAssign modal). */}
                  <div data-testid="exercise-timeline-after-discussion">
                    <ExerciseTimelinePreview incident={incident} />
                  </div>
                </CollapsibleWidget>
              )}

              {incident?.is_exercise && visibleWidgets.availableResources && (
                <CollapsibleWidget
                  title="Resources"
                  testId="widget-available-resources"
                  defaultOpen={!scenarioEnv}
                  variant={scenarioEnv ? 'scenario' : 'default'}
                  icon={Archive}
                >
                  <IncidentResourcesPanel incident={incident} isAdmin={isContextAdmin} />
                </CollapsibleWidget>
              )}

              {/* Exercise Control · LIVE — between Resources and Audit Log at the active stage */}
              {(canControlDrillRuntime || canManageDrillInjectors) && incident?.is_exercise && String(incident?.status || '').toLowerCase() === 'active' && (
                <div className="mb-4">
                  <ExerciseControlPanel
                    incident={incident}
                    onRefresh={(silent = true) => fetchIncidentDetail(silent)}
                    canControlRuntime={canControlDrillRuntime}
                    canManageInjectors={canManageDrillInjectors}
                  />
                </div>
              )}



              {(
                <div className={`${scenarioEnv ? 'space-y-0' : 'space-y-6'} ${isActiveExercise ? 'order-[-1] mb-6' : ''}`}>
                  {/* Exercise Control Panel for non-active exercise stages (active stage renders it above, between Resources & Audit Log) */}
                  {isAdmin && incident?.is_exercise && !isActiveExercise && (
                    <ExerciseControlPanel
                      incident={incident}
                      onRefresh={(silent = true) => fetchIncidentDetail(silent)}
                    />
                  )}
                  {/* Corrective Actions & AAR — original lower-block placement for non-active exercise stages */}
                  {isAdmin && incident?.is_exercise && !isActiveExercise && visibleWidgets.correctiveActions && (
                    <div data-testid="widget-corrective-actions"><CorrectiveActionsPanel incident={incident} /></div>
                  )}
                  {/* Live Line - Full Width (non-exercise; moved above planning for exercises) */}
                  {!incident?.is_exercise && (
                    <div className="flex items-stretch gap-3">
                      <div className="min-w-0 flex-1">
                        <RelatedIncidentsBanner incidents={incidents} incident={incident} navigate={navigate} inRow />
                      </div>
                    </div>
                  )}

                  {/* Response Actions (Task 4.13) - Commented out as it's redundant with timeline */}
                  {/* {(() => {
                    const responseActions = timelineItems.filter(item => item.group === 'response_action');
                    if (responseActions.length === 0) return null;

                    return (
                      <div className="bg-white rounded-xl border border-blue-200 shadow-sm overflow-hidden animate-in fade-in slide-in-from-top-4 duration-500">
                        <div className="bg-blue-50/50 px-4 py-3 border-b border-blue-100 flex items-center justify-between">
                          <h3 className="text-xs font-bold text-blue-900 uppercase tracking-widest flex items-center gap-2">
                            <Activity className="w-4 h-4 text-blue-600" />
                            Active Response Actions
                          </h3>
                          <div className="flex items-center gap-2">
                            <span className="text-[10px] text-blue-700 font-medium bg-blue-100 px-2 py-0.5 rounded-full">
                              {responseActions.length} Routing Item{responseActions.length > 1 ? 's' : ''}
                            </span>
                            <Badge variant="outline" className="bg-white text-blue-600 border-blue-200 text-[10px]">
                              Operational
                            </Badge>
                          </div>
                        </div>
                        <div className="p-4 space-y-6">
                          {responseActions.map((action) => (
                            <div key={action.id} className="relative pl-6 border-l-2 border-blue-400/30 py-1">
                              <div className="absolute -left-[9px] top-1.5 w-4 h-4 rounded-full bg-blue-600 border-2 border-white shadow-sm flex items-center justify-center">
                                <Zap className="w-2 h-2 text-white" />
                              </div>
                              <div className="flex justify-between items-start mb-3">
                                <div className="max-w-[80%]">
                                  <h4 className="text-sm font-bold text-slate-900 flex items-center gap-2">
                                    {action.title}
                                    {action.meta?.department && (
                                      <span className="text-[9px] font-bold text-indigo-600 bg-indigo-50 px-1.5 py-0.5 rounded border border-indigo-100 uppercase">
                                        {action.meta.department}
                                      </span>
                                    )}
                                  </h4>
                                  <p className="text-xs text-slate-600 mt-1 leading-relaxed">{action.details}</p>
                                </div>
                                <span className="text-[10px] font-mono font-bold text-slate-400 bg-slate-50 px-2 py-1 rounded-md border border-slate-100">
                                  {new Date(action.timestamp).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
                                </span>
                              </div>
                              
                              {action.meta?.tasks && (
                                <div className="mt-4 grid grid-cols-1 lg:grid-cols-2 gap-3">
                                  {action.meta.tasks.map((task, tidx) => (
                                    <div key={tidx} className="group flex items-center gap-3 bg-white p-3 rounded-xl border border-slate-200 hover:border-blue-300 hover:shadow-md transition-all duration-300">
                                      <div className={`flex-shrink-0 w-8 h-8 rounded-lg flex items-center justify-center ${task.is_completed ? 'bg-green-100 text-green-600' : 'bg-blue-50 text-blue-600 group-hover:bg-blue-600 group-hover:text-white transition-colors'}`}>
                                        {task.is_completed ? <CheckCircle2 className="w-5 h-5" /> : <PlayCircle className="w-5 h-5" />}
                                      </div>
                                      <div className="flex-1 min-w-0">
                                        <div className="flex items-center justify-between gap-2">
                                          <p className={`text-xs font-bold truncate ${task.is_completed ? 'text-slate-400 line-through' : 'text-slate-800'}`}>
                                            {task.task_text}
                                          </p>
                                          <span className="text-[9px] font-bold text-slate-400 shrink-0 uppercase tracking-tighter bg-slate-50 px-1.5 py-0.5 rounded">
                                            {task.timing}
                                          </span>
                                        </div>
                                        <div className="flex items-center gap-2 mt-1">
                                          <div className="flex -space-x-1.5">
                                            <div className="w-4 h-4 rounded-full bg-slate-200 border border-white flex items-center justify-center text-[8px] font-bold text-slate-500">
                                              {(task.assignee || 'U').charAt(0)}
                                            </div>
                                          </div>
                                          <p className="text-[10px] text-slate-500 font-medium">
                                            Assigned: {task.assignee || 'Unassigned'}
                                          </p>
                                        </div>
                                      </div>
                                    </div>
                                  ))}
                                </div>
                              )}
                            </div>
                          ))}
                        </div>
                      </div>
                    );
                  })()} */}

                  {/* Live timing belongs to incidents and drills, never a reusable scenario template. */}
                  {!scenarioEnv && (
                  <div className="grid grid-cols-4 gap-4" data-now={nowTick}>
                    {/* Incident Time */}
                    {visibleWidgets.metrics1 && (
                      <div className="bg-white rounded-md border border-gray-300 p-3 shadow-sm">
                        <div className="flex items-center justify-between mb-1">
                          <div className="text-xs text-gray-600 font-medium uppercase tracking-wide">Incident Time</div>
                          <Clock className="h-3 w-3 text-gray-500" />
                        </div>
                        <div className="text-lg font-semibold text-gray-900 tabular-nums">
                          {(() => {
                            // The moment the incident was created/reported — matches the
                            // Report & Detection card. Exercises show activation time.
                            const start = incident?.is_exercise
                              ? (incident?.activated_at || incident?.created_at)
                              : incident?.created_at;
                            return start ? formatTimestampWithSeconds(start) : '--:--:--';
                          })()}
                        </div>
                      </div>
                    )}

                    {/* Last Update */}
                    {visibleWidgets.metrics3 && (
                      <div className="bg-white rounded-md border border-gray-300 p-3 shadow-sm">
                        <div className="flex items-center justify-between mb-1">
                          <div className="text-xs text-gray-600 font-medium uppercase tracking-wide">Last Update</div>
                          <RefreshCw className="h-3 w-3 text-gray-500" />
                        </div>
                        <div className="text-lg font-semibold text-gray-900">
                          {lastUpdateLabel}
                        </div>
                      </div>
                    )}

                    {/* Incident Duration */}
                    {visibleWidgets.metrics4 && (
                      <div className="bg-white rounded-md border border-gray-300 p-3 shadow-sm">
                        <div className="flex items-center justify-between mb-1">
                          <div className="text-xs text-gray-600 font-medium uppercase tracking-wide">Duration</div>
                          <Timer className="h-3 w-3 text-gray-500" />
                        </div>
                        <div className="text-lg font-semibold text-gray-900">
                          {(() => {
                            // Exercises: duration runs from activation (activated_at), not the scenario/creation time.
                            const start = incident?.is_exercise
                              ? (incident?.activated_at || incident?.created_at)
                              : incident?.created_at;
                            if (!start) return '--';
                            const diff = Math.max(0, clockNowMs() - parseTimestamp(start).getTime());
                            const totalSecs = Math.floor(diff / 1000);
                            const minutes = Math.floor(totalSecs / 60);
                            const hours = Math.floor(minutes / 60);
                            if (hours > 0) return `${hours}h ${minutes % 60}m`;
                            if (minutes > 0) return `${minutes}m ${totalSecs % 60}s`;
                            return `${totalSecs}s`;
                          })()}
                        </div>
                      </div>
                    )}

                    {/* Resolved REAL incidents mirror the drill completed stage: stacked
                        actions in the 4th metrics cell — Add Widget takes Resolve's spot. */}
                    {isResolvedRealIncident ? (
                      <div className="flex flex-col justify-center gap-2 h-full" data-testid="resolved-stage-actions">
                        <Button
                          data-testid="add-widget-metrics-btn"
                          onClick={() => setShowAddWidgetModal(true)}
                          className="bg-blue-600 hover:bg-blue-700 text-white font-bold text-xs h-9 gap-2 px-3 shadow-sm w-full justify-center"
                        >
                          <Plus className="w-4 h-4" /> Add Widget
                        </Button>
                        {isAdmin && (
                          <Button
                            data-testid="resolved-extensive-btn"
                            onClick={() => setShowExtensiveModal(true)}
                            className="extensive-analysis-btn relative overflow-hidden border-0 text-white font-bold text-xs h-9 gap-2 px-3 shadow-lg w-full justify-center bg-gradient-to-r from-indigo-600 via-violet-600 to-fuchsia-600 hover:from-indigo-500 hover:via-violet-500 hover:to-fuchsia-500 ring-1 ring-violet-300/60 transition-all duration-300"
                          >
                            <Sparkles className="w-4 h-4 drop-shadow" />
                            <span className="relative z-10">Extensive Analysis</span>
                            <span className="extensive-analysis-shine pointer-events-none absolute inset-0" aria-hidden="true" />
                          </Button>
                        )}
                      </div>
                    ) : (!incident?.is_exercise || isActiveExercise) && (
                      /* Add Widget Button - big metrics-row button: non-exercise incidents OR active-stage exercises only.
                         Requested/Scenario exercises use the inline "Add Widget" button in the header row instead. */
                      <button
                        data-testid="add-widget-metrics-btn"
                        onClick={() => setShowAddWidgetModal(true)}
                        className="bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 rounded-md border border-blue-300 p-3 shadow-sm transition-all duration-200 flex flex-col items-center justify-center h-full"
                      >
                        <Plus className="h-6 w-6 text-white mb-1" />
                        <span className="text-xs font-semibold text-white">Add Widget</span>
                      </button>
                    )}

                    {/* Completed stage: stacked action buttons sit in the metrics row (4th cell). */}
                    {canResolveIncident && isCompletedStage && (
                      <div className="flex flex-col justify-center gap-2 h-full" data-testid="completed-stage-actions">
                        <Button
                          data-testid="completed-resolve-btn"
                          onClick={() => setShowResolutionModal(true)}
                          className="bg-emerald-600 hover:bg-emerald-700 text-white font-bold text-xs h-9 gap-2 px-3 shadow-sm w-full justify-center"
                        >
                          <CheckCircle2 className="w-4 h-4" /> Resolve Incident
                        </Button>
                        <Button
                          data-testid="completed-extensive-btn"
                          onClick={() => setShowExtensiveModal(true)}
                          className="extensive-analysis-btn relative overflow-hidden border-0 text-white font-bold text-xs h-9 gap-2 px-3 shadow-lg w-full justify-center bg-gradient-to-r from-indigo-600 via-violet-600 to-fuchsia-600 hover:from-indigo-500 hover:via-violet-500 hover:to-fuchsia-500 ring-1 ring-violet-300/60 transition-all duration-300"
                        >
                          <Sparkles className="w-4 h-4 drop-shadow" />
                          <span className="relative z-10">Extensive Analysis</span>
                          <span className="extensive-analysis-shine pointer-events-none absolute inset-0" aria-hidden="true" />
                        </Button>
                      </div>
                    )}
                  </div>
                  )}

                  {/* Persistent response plan — expanded for staffing, compact after activation. */}
                  {hasPersistentResponsePlan && (
                    <div
                      data-testid="plan-activation-banner"
                      data-plan-state={responsePlanState}
                      className={`relative mb-4 overflow-hidden rounded-xl border bg-gradient-to-br from-slate-950 via-slate-900 to-slate-950 shadow-xl shadow-black/25 ${responsePlanIsActive ? 'border-emerald-700/60' : 'border-amber-700/60'}`}
                    >
                      <div
                        className="absolute inset-x-0 top-0 h-1"
                        style={{ backgroundImage: responsePlanIsActive
                          ? 'repeating-linear-gradient(90deg, #34d399 0 24px, transparent 24px 42px)'
                          : 'repeating-linear-gradient(90deg, #f8c95c 0 24px, transparent 24px 42px)' }}
                        aria-hidden="true"
                      />
                      <div className={`flex flex-col px-5 sm:px-7 lg:flex-row lg:items-center lg:justify-between ${responsePlanIsActive ? 'gap-3 pb-4 pt-5 sm:pb-4 sm:pt-6' : 'gap-6 pb-6 pt-7 sm:pb-7 sm:pt-9'}`}>
                        <div className="min-w-0 flex-1">
                          <h2 className={`font-extrabold tracking-tight text-slate-100 ${responsePlanIsActive ? 'text-xl sm:text-2xl' : 'text-2xl sm:text-3xl'}`} data-testid="plan-unstaffed-warning">
                            {incident?.matched_scenario_name || 'Prepared response plan'}
                          </h2>
                          <p className={`mt-1.5 text-[10px] font-black uppercase tracking-[0.3em] sm:text-xs ${responsePlanIsActive ? 'text-emerald-300' : 'text-amber-300'}`}>
                            Response plan · {responsePlanIsActive
                              ? 'Activated'
                              : (plannedStaffingSummary.gaps > 0
                                ? `${plannedStaffingSummary.gaps} slot${plannedStaffingSummary.gaps === 1 ? '' : 's'} from launch`
                                : 'Ready to launch')}
                          </p>
                          {!responsePlanIsActive && <div className="mt-5 max-w-md">
                            <div
                              className="grid h-1.5 min-w-0 gap-px overflow-hidden rounded-full bg-slate-700/80"
                              style={{ gridTemplateColumns: `repeat(${Math.max(1, plannedStaffingSummary.required)}, minmax(0, 1fr))` }}
                              role="progressbar"
                              aria-label="Response plan staffing progress"
                              aria-valuemin={0}
                              aria-valuemax={plannedStaffingSummary.required}
                              aria-valuenow={plannedStaffingSummary.staffed}
                            >
                              {Array.from({ length: Math.max(1, plannedStaffingSummary.required) }, (_, index) => (
                                <span
                                  key={index}
                                  className={`h-full transition-colors duration-300 ${index < plannedStaffingSummary.staffed || plannedStaffingSummary.required === 0 ? 'bg-amber-300' : 'bg-slate-600'}`}
                                />
                              ))}
                            </div>
                          </div>}
                        </div>
                        {responsePlanIsActive && (
                          <div
                            data-testid="plan-adherence-kpi"
                            role="status"
                            title="Completion progress across every active, applicable plan obligation. Future T+ cards count as pending from activation; conditional cards join only after their condition fires. SLA shows only outcomes that have actually been assessed."
                            className="flex h-12 min-w-[232px] flex-shrink-0 items-center justify-between gap-4 rounded-lg border border-emerald-700/60 bg-emerald-950/35 px-4"
                          >
                            <div>
                              <p className="text-[9px] font-black uppercase tracking-[0.2em] text-emerald-300">
                                Plan adherence
                              </p>
                              <p className="mt-0.5 text-[9px] font-semibold text-slate-400">
                                {planAdherence.due > 0
                                  ? `${planAdherence.completed}/${planAdherence.due} completed · ${planAdherence.pending} pending · SLA ${planSlaAssessed > 0 ? `${planAdherence.slaMet}/${planSlaAssessed}` : '—'}`
                                  : 'No applicable actions yet · SLA —'}
                              </p>
                            </div>
                            <p
                              className="font-mono text-2xl font-black tabular-nums text-white"
                              aria-label={planCompletionPercent === null
                                ? 'Plan completion not available yet'
                                : `Plan completion ${planCompletionPercent} percent; ${planAdherence.completed} of ${planAdherence.due} actions completed`}
                            >
                              {planCompletionPercent === null ? '—' : `${planCompletionPercent}%`}
                            </p>
                          </div>
                        )}
                        <div className="flex w-full flex-shrink-0 items-center lg:w-auto lg:justify-end">
                          {responsePlanIsActive ? (
                            <Button
                              disabled
                              data-testid="plan-activated-btn"
                              className="h-12 w-full cursor-default rounded-lg border border-emerald-400 bg-emerald-500/15 px-6 text-xs font-black tracking-[0.18em] text-emerald-200 opacity-100 shadow-[0_8px_24px_rgba(16,185,129,0.12)] lg:min-w-[170px] lg:w-auto"
                            >
                              <CheckCircle2 className="mr-2 h-4 w-4" /> ACTIVATED
                            </Button>
                          ) : canActivateResponsePlan ? (autoActivationCountdownActive ? (
                            <button
                              type="button"
                              data-testid="cancel-auto-activation-countdown"
                              disabled={cancellingAutoActivation || autoActivationSecondsRemaining <= 0}
                              onClick={handleCancelAutoActivation}
                              aria-label={autoActivationSecondsRemaining > 0
                                ? `Stop automatic response-plan activation. ${autoActivationCountdownLabel} remaining`
                                : 'Automatic response-plan activation is starting'}
                              title={autoActivationSecondsRemaining > 0
                                ? 'Click to stop automatic activation. This option closes when the readiness window ends.'
                                : 'The readiness window has ended and automatic activation is starting.'}
                              className="group relative mx-auto flex h-28 w-28 shrink-0 flex-col items-center justify-center overflow-hidden rounded-full border-2 border-rose-300 bg-gradient-to-br from-rose-500 via-red-600 to-rose-800 text-white shadow-[0_0_0_6px_rgba(244,63,94,0.12),0_16px_34px_rgba(127,29,29,0.45)] transition hover:scale-[1.03] hover:from-rose-400 hover:to-rose-700 focus:outline-none focus:ring-4 focus:ring-rose-300/40 disabled:cursor-wait disabled:opacity-80 lg:h-32 lg:w-32"
                            >
                              <span className="text-[9px] font-black uppercase tracking-[0.2em] text-rose-100">
                                {cancellingAutoActivation ? 'Stopping' : (autoActivationSecondsRemaining > 0 ? 'Auto launch' : 'Starting')}
                              </span>
                              <span className="mt-1 font-mono text-xl font-black tabular-nums tracking-tight lg:text-2xl">
                                {cancellingAutoActivation ? '···' : autoActivationCountdownLabel}
                              </span>
                              <span className="mt-1 text-[8px] font-extrabold uppercase tracking-[0.12em] text-rose-100">
                                {autoActivationSecondsRemaining > 0 ? 'Click to stop' : 'Window closed'}
                              </span>
                              <span className="pointer-events-none absolute inset-1 rounded-full border border-white/20" aria-hidden="true" />
                            </button>
                          ) : (
                            <Button
                              className="h-14 w-full rounded-lg border border-amber-300 bg-amber-300 px-7 text-xs font-black tracking-[0.18em] text-slate-950 shadow-[0_8px_24px_rgba(248,201,92,0.2)] transition-colors hover:bg-amber-200 lg:h-16 lg:min-w-[200px] lg:w-auto disabled:cursor-not-allowed disabled:border-slate-600 disabled:bg-slate-800/70 disabled:text-slate-500 disabled:opacity-100 disabled:shadow-none"
                              data-testid="activate-plan-btn"
                              disabled={unstaffedPlannedCount > 0}
                              aria-label="Activate Response Plan"
                              title={plannedStaffingSummary.gaps > 0 ? `${plannedStaffingSummary.gaps} role slot(s) still need personnel before activation` : 'Activate Response Plan'}
                              onClick={async () => {
                                if (!canActivateResponsePlan) return;
                                try {
                                  await axios.post(`${ApiEndPoint}/api/incidents/${incident.id}/activate-plan`, {}, {
                                    headers: { Authorization: `Bearer ${localStorage.getItem('access_token')}` }
                                  });
                                  toast.success('Response plan activated');
                                  fetchIncidentDetail();
                                  // Refresh the timeline + Audit Log widget so the activation entry shows immediately.
                                  window.dispatchEvent(new Event('timelineRefresh'));
                                } catch (e) {
                                  toast.error(e?.response?.data?.detail || 'Failed to activate the response plan');
                                }
                              }}
                            >
                              ACTIVATE · {plannedStaffingSummary.required > 0
                                ? `${plannedStaffingSummary.staffed}/${plannedStaffingSummary.required}`
                                : 'READY'}
                            </Button>
                          )) : (
                            <div
                              className="rounded-lg border border-slate-700 bg-slate-900/70 px-4 py-3 text-center text-xs font-semibold text-slate-400"
                              data-testid="plan-activation-read-only"
                            >
                              Your assigned role cannot activate this plan
                            </div>
                          )}
                        </div>
                      </div>

                      {/* The timeline remains attached to the plan and defaults collapsed after activation. */}
                      <div className="border-t border-slate-700/70 px-4 pb-4 pt-2 sm:px-6">
                        <div className="flex flex-wrap items-center justify-between gap-2">
                          <button
                            type="button"
                            data-testid="plan-timeline-toggle"
                            onClick={() => setPlanTimelineOpen((o) => !o)}
                            className="flex min-w-[220px] flex-1 items-center justify-between py-1 text-slate-300 transition-colors hover:text-white"
                          >
                            <span className="inline-flex items-center gap-1.5 text-[10px] font-bold uppercase tracking-[0.18em]">
                              <Zap className={`h-3.5 w-3.5 ${responsePlanIsActive || unstaffedPlannedCount === 0 ? 'text-emerald-400' : 'text-amber-400'}`} />
                              {responsePlanIsActive ? 'Plan execution & timeline' : 'Review staffing & timeline'}
                            </span>
                            <ChevronDown className={`h-4 w-4 transition-transform ${planTimelineOpen ? 'rotate-180' : ''}`} />
                          </button>
                          {!responsePlanIsActive && <label
                            className="inline-flex cursor-pointer select-none items-center gap-2 rounded-md px-2 py-1 text-[10px] font-semibold text-slate-400 transition-colors hover:bg-slate-800 hover:text-slate-200"
                            data-testid="hide-planned-toggle-label"
                            title="Only cards awaiting activation are hidden; live cards remain visible."
                          >
                            <input
                              type="checkbox"
                              data-testid="hide-planned-toggle"
                              checked={hidePlanned}
                              onChange={(e) => setHidePlanned(e.target.checked)}
                              className="sr-only peer"
                            />
                            <span className={`relative h-4 w-7 flex-shrink-0 rounded-full transition-colors ${hidePlanned ? 'bg-amber-400' : 'bg-slate-600'}`}>
                              <span className={`absolute top-0.5 h-3 w-3 rounded-full bg-white shadow transition-all ${hidePlanned ? 'left-3.5' : 'left-0.5'}`} />
                            </span>
                            Hide pending cards
                          </label>}
                        </div>
                        {planTimelineOpen && (
                          <div className="mt-2 space-y-3 rounded-lg bg-slate-900/60 border border-slate-700/60 p-3" data-testid="plan-banner-timeline">
                            {canManageOperationalRoles && !responsePlanIsActive ? (
                              <QuickAssignModal
                                incident={incident}
                                items={timelineItems}
                                onlineUserIds={onlineParticipantIds}
                                presenceByUserId={mobilePresenceByUser}
                                isOpen={planTimelineOpen}
                                embedded
                                onChanged={async () => {
                                  await Promise.all([fetchIncidentDetail(true), fetchTimelineData()]);
                                  window.dispatchEvent(new Event('timelineRefresh'));
                                }}
                              />
                            ) : <ExerciseTimelinePreview incident={incident} variant="dark" itemsOverride={timelineItems} />}
                          </div>
                        )}
                      </div>
                    </div>
                  )}

                  {/* Completed stage: Corrective Actions → After Exercise Discussion → Simulation Objective */}
                  {isCompletedStage && (
                    <>
                      {isAdmin && <div className="mb-4" data-testid="widget-corrective-actions"><CorrectiveActionsPanel incident={incident} /></div>}
                      {visibleWidgets.discussionGroup && (
                        <CollapsibleWidget title="After Exercise Discussion" testId="widget-discussion-group" defaultOpen={false}>
                          <Card className="bg-white shadow-none border-0 rounded-none">
                            <CardContent className="p-4">
                              <ExerciseDiscussionGroup
                                incident={incident}
                              isAdmin={isContextAdmin}
                                scenarioMode={scenarioMode}
                                allDepartments={allDepartments}
                                appUsers={appUsers}
                                allTeams={allTeams}
                                onRefresh={() => fetchIncidentDetail(true)}
                                onChat={handleOpenPrivateChat}
                                onChatAll={() => navigate(chatWorkspaceUrl)}
                              />
                            </CardContent>
                          </Card>
                        </CollapsibleWidget>
                      )}
                      {visibleWidgets.simulationObjective && (
                        <CollapsibleWidget title="Simulation Objective" testId="widget-simulation-objective" defaultOpen={false}>
                          <Card className="bg-white shadow-none border-0 rounded-none">
                            <CardContent className="p-4">
                              <SimulationObjective incident={incident} isAdmin={isContextAdmin} onRefresh={(silent = true) => fetchIncidentDetail(silent)} />
                            </CardContent>
                          </Card>
                        </CollapsibleWidget>
                      )}
                    </>
                  )}

                  {visibleWidgets.locationMap && !isCompletedStage && (
                    <MaybeCollapsed
                      when={scenarioEnv}
                      title="Location Map"
                      testId="widget-location-map"
                      icon={MapPin}
                    >
                    <Card id="location-map-card" className="bg-white shadow-sm border border-gray-300">
                      <CardContent className="p-4">
                        <div className="text-sm font-semibold text-gray-800 mb-3 flex items-center justify-between">
                          <div className="flex items-center gap-2">
                            <MapPin className="h-4 w-4 mr-0.5 text-gray-600" />
                            {incident?.map_projection?.official ? (
                              <span
                                className="flex items-center gap-1.5 text-emerald-700"
                                title={incident.map_projection.source_label || 'Verified official GPS'}
                                data-testid="incident-map-official-gps"
                              >
                                <CheckCircle2 className="h-4 w-4" />
                                <span className="font-mono">{getLocationDisplay(incident)}</span>
                              </span>
                            ) : (
                              <span className="flex flex-col items-start leading-tight" data-testid="incident-map-unverified-gps">
                                <span>{getLocationDisplay(incident)}</span>
                                {incident?.map_projection?.reporter_coordinates ? (
                                  <span
                                    className="mt-0.5 flex items-center gap-1 font-mono text-[10px] font-medium text-amber-700"
                                    title="Reporter GPS — unverified"
                                  >
                                    <AlertCircle className="h-3 w-3 shrink-0" />
                                    {Number(incident.map_projection.reporter_coordinates.latitude ?? incident.map_projection.reporter_coordinates.lat).toFixed(6)}, {Number(incident.map_projection.reporter_coordinates.longitude ?? incident.map_projection.reporter_coordinates.lng).toFixed(6)}
                                  </span>
                                ) : null}
                              </span>
                            )}
                            {/* On-scene weather via the Open-Meteo API connection */}
                            <IncidentWeatherChip incidentId={incident?.id} hasGps={!!getIncidentGpsCoordinates(incident)} />
                          </div>
                          <div className="flex items-center gap-2">
                            {/* Geo-Fence: circle-select live-tracked users and send them
                                a notification / verification / status update / action card. */}
                            {canUseGeoFence && (
                              <Button
                                variant="outline"
                                size="sm"
                                className="h-7 text-xs px-2 bg-indigo-50 hover:bg-indigo-100 text-indigo-700 border-indigo-200"
                                onClick={() => setShowGeoFence(true)}
                                data-testid="geofence-open-btn"
                              >
                                <Target className="h-3 w-3 mr-1" />
                                Geo-Fence
                              </Button>
                            )}
                            {/* Pull the matched scenario's prepared map into this real incident —
                                independent of the Activate Response Plan button. */}
                            {isAdmin && !incident?.is_exercise && incident?.matched_scenario_id && (
                              <ScenarioMapOfferPrompt incidentId={incident.id} onApplied={fetchIncidentDetail} variant="button" />
                            )}
                            <Button
                              variant="ghost"
                              size="sm"
                              className="h-7 text-xs px-2 hover:bg-gray-100"
                              onClick={() => navigate(`/exercise-map/${id}`, { state: { from: window.location.pathname + window.location.search } })}
                              data-testid="open-exercise-map-btn"
                            >
                              <Navigation className="h-3 w-3 mr-1" />
                              {(incident?.is_scenario || String(incident?.status).toLowerCase() === 'requested') ? 'Create Map' : 'Full Map'}
                            </Button>
                          </div>
                        </div>
                        {/* <div className="relative bg-gray-50 rounded-md h-32 overflow-hidden border border-gray-300">
                        <div className="absolute inset-0">
                          <div className="absolute top-4 left-6 w-8 h-6 bg-gray-400 rounded-sm shadow-sm"></div>
                          <div className="absolute top-2 right-4 w-6 h-8 bg-gray-400 rounded-sm shadow-sm"></div>
                          <div className="absolute bottom-6 left-4 w-10 h-4 bg-gray-400 rounded-sm shadow-sm"></div>
                          <div className="absolute bottom-4 right-6 w-6 h-6 bg-gray-400 rounded-sm shadow-sm"></div>
                          <div className="absolute top-0 left-10 w-0.5 h-full bg-gray-500 opacity-60"></div>
                          <div className="absolute bottom-10 left-0 w-full h-0.5 bg-gray-500 opacity-60"></div>
                        </div>
                        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
                          <div className="absolute inset-0 bg-red-500 opacity-20 rounded-full w-8 h-8 -translate-x-4 -translate-y-4 animate-pulse"></div>
                          <div className="relative z-10">
                            <MapPin className="h-5 w-5 text-red-600 drop-shadow-sm" />
                          </div>
                        </div>
                      </div> */}

                        <div className="relative">
                          <MyMap
                            incident={incident}
                            trackedUser={trackedUser}
                            isAdmin={isAdmin && !isIncidentReadOnly}
                            generalInfoOpenRequest={generalInfoOpenRequest}
                          />
                          {incident?.map_projection && !incident.map_projection.official && isAdmin && !isIncidentReadOnly && (
                            <div className="absolute bottom-4 left-1/2 z-20 w-[min(92%,420px)] -translate-x-1/2 rounded-xl border border-amber-300 bg-white/95 p-3 shadow-xl backdrop-blur">
                              <p className="text-center text-xs font-bold text-amber-900">Unverified map point</p>
                              <Button
                                onClick={() => setShowLocationMappingModal(true)}
                                className="mt-2 h-8 w-full bg-amber-600 text-xs text-white hover:bg-amber-700"
                                data-testid="open-incident-location-mapping-overlay"
                              >
                                {incident.map_projection.location_id
                                  ? (incident.map_projection.reporter_coordinates ? 'Use reporter GPS or choose a point' : 'Choose the official GPS point')
                                  : 'Link/create location and choose GPS'}
                              </Button>
                            </div>
                          )}
                        </div>
                        {incident?.map_projection && !incident.map_projection.official && (
                          <div className="mt-4 p-4 bg-amber-50 border border-amber-200 rounded-xl">
                            <div className="flex items-start gap-3">
                              <div className="p-2 bg-amber-100 rounded-lg">
                                <MapPin className="h-4 w-4 text-amber-600" />
                              </div>
                              <div className="flex-1">
                                <p className="text-sm font-bold text-amber-900 mb-1">
                                  {incident.map_projection.location_name || 'Unknown location'} · official GPS required
                                </p>
                                <p className="text-xs text-amber-700 leading-relaxed">
                                  {incident.map_projection.reporter_coordinates
                                    ? 'The grayscale map shows reporter GPS as unverified evidence. It does not become the official incident location until an administrator confirms it or chooses another point.'
                                    : 'This historical incident has no captured reporter GPS. The map is centered on Saudi Arabia until an administrator chooses the official point.'}
                                </p>
                                {incident?.evidence && (
                                  <p className="mt-2 text-xs italic text-amber-800">Reporter evidence: “{incident.evidence}”</p>
                                )}
                              </div>
                            </div>
                          </div>
                        )}
                        {isAdmin && incident?.map_projection?.official && incident.map_projection.reporter_coordinates && (
                          <details className="mt-3 rounded-lg border border-slate-200 bg-slate-50 px-3 py-2 text-xs text-slate-600">
                            <summary className="cursor-pointer font-bold text-slate-700">Reporter GPS audit evidence</summary>
                            <p className="mt-2 font-mono">
                              {Number(incident.map_projection.reporter_coordinates.latitude ?? incident.map_projection.reporter_coordinates.lat).toFixed(6)}, {Number(incident.map_projection.reporter_coordinates.longitude ?? incident.map_projection.reporter_coordinates.lng).toFixed(6)}
                            </p>
                            <p className="mt-1 text-[11px]">Original captured evidence; it does not move the verified marker.</p>
                          </details>
                        )}
                      </CardContent>
                    </Card>
                    </MaybeCollapsed>
                  )}

                  {/* Drill Participants Widget */}
                  {visibleWidgets.teamsCrews && (
                    <CollapsibleWidget
                      title={(
                        <span className="flex items-center gap-2">
                          {incident?.is_exercise ? 'Drill Participants' : 'Incident Participants'}
                          {drillParticipants.length > 0 && (
                            <span
                              className="inline-flex items-center gap-1 rounded-full bg-emerald-50 border border-emerald-200 px-2 py-0.5 text-[10px] font-bold tracking-wide text-emerald-700 normal-case"
                              data-testid="drill-participants-presence-count"
                            >
                              <span className="relative flex h-1.5 w-1.5">
                                <span className="absolute inline-flex h-full w-full rounded-full bg-emerald-400 live-ping" />
                                <span className="relative inline-flex h-1.5 w-1.5 rounded-full bg-emerald-500" />
                              </span>
                              {drillParticipantsLiveCount} live / {drillParticipants.length} total
                            </span>
                          )}
                        </span>
                      )}
                      testId="widget-drill-participants"
                      defaultOpen={!scenarioEnv && !isActiveExercise}
                    >
                    <Card className="bg-white shadow-none border-0 rounded-none">
                      <CardContent className="p-4">
                        {/* New Team / Crew — creates records in the Teams & Crews module (the reference collection) */}
                        {isAdmin && (
                          <div className="flex justify-end mb-3">
                            <Button
                              variant="outline"
                              size="sm"
                              className="h-7 text-xs px-2.5 bg-indigo-50 hover:bg-indigo-100 text-indigo-700 border-indigo-200 hover:border-indigo-300 transition-colors shadow-sm font-medium"
                              onClick={() => setShowCreateTeamCrew(true)}
                              data-testid="participants-new-team-crew-btn"
                            >
                              <Plus className="h-3.5 w-3.5 mr-1 text-indigo-700 flex-shrink-0" />
                              New Team / Crew
                            </Button>
                          </div>
                        )}
                        {(() => {
                          const participants = drillParticipants;
                          if (participants.length === 0) {
                            return (
                              <div className="text-center py-6 text-gray-500 text-sm" data-testid="drill-participants-empty">
                                No participants were assigned to roles during the request stage.
                              </div>
                            );
                          }

                          return (
                            <div className="space-y-3" data-testid="drill-participants-list">
                              {participants.map((responder, index) => (
                                <div key={`${responder.userId}-${index}`} className="flex items-start gap-3 p-3.5 bg-white border border-gray-100 rounded-xl shadow-sm hover:shadow-md hover:border-blue-100 transition-all duration-300">
                                  <div className="flex items-center justify-center w-9 h-9 rounded-xl bg-gradient-to-br from-blue-500 to-indigo-600 text-white font-bold text-sm flex-shrink-0 shadow-sm">
                                    {responder.userName ? responder.userName.charAt(0).toUpperCase() : 'U'}
                                  </div>
                                  <div className="flex-1 min-w-0">
                                    <div className="flex items-center gap-2 mb-1.5">
                                      <span className="text-sm font-semibold text-slate-800">{responder.userName}</span>
                                      {responder.live ? (
                                        <span className="inline-flex items-center gap-1.5" title="Live · active now" data-testid={`participant-live-${responder.userId}`}>
                                          <span className="relative flex h-2 w-2">
                                            <span className="absolute inline-flex h-full w-full rounded-full bg-emerald-400 live-ping" />
                                            <span className="relative inline-flex h-2 w-2 rounded-full bg-emerald-500" />
                                          </span>
                                          <span className="text-[10px] font-bold uppercase tracking-wide text-emerald-600">Live</span>
                                        </span>
                                      ) : (
                                        <span className="inline-flex items-center gap-1.5" title="Offline" data-testid={`participant-off-${responder.userId}`}>
                                          <span className="h-2 w-2 rounded-full bg-slate-300" />
                                          <span className="text-[10px] font-bold uppercase tracking-wide text-slate-400">Off</span>
                                        </span>
                                      )}
                                    </div>
                                    {(responder.viaGroups || []).length > 0 && (
                                      <p className="text-[11px] font-medium text-indigo-500 -mt-1 mb-1.5" data-testid={`participant-via-${responder.userId}`}>
                                        {responder.viaGroups.join(' · ')}
                                      </p>
                                    )}
                                    <div className="flex items-center gap-1.5 mb-3 flex-wrap">
                                      {responder.roles.length > 0 ? (
                                        responder.roles.map((role, ri) => (
                                          <span key={ri} className="inline-flex items-center gap-1 rounded-full bg-violet-50 border border-violet-200 px-2.5 py-0.5 text-xs font-semibold text-violet-700">
                                            <Users className="h-3 w-3" /> {role}
                                          </span>
                                        ))
                                      ) : (
                                        <span className="inline-flex items-center px-2 py-0.5 border rounded-md text-xs font-medium bg-gray-50 text-gray-600 border-gray-200">No role</span>
                                      )}
                                    </div>
                                    <div className="flex flex-wrap gap-2">
                                      <Button
                                        variant="outline"
                                        size="sm"
                                        className="h-7 text-xs px-2.5 bg-blue-50 hover:bg-blue-100 text-blue-700 border-blue-200 hover:border-blue-300 transition-colors shadow-sm font-medium"
                                        onClick={() => handleTrackUser(responder)}
                                      >
                                        <MapPin className="h-3.5 w-3.5 mr-1 text-blue-600 flex-shrink-0" />
                                        Track!
                                      </Button>
                                      <Button
                                        variant="outline"
                                        size="sm"
                                        className="h-7 text-xs px-2.5 text-slate-600 border-slate-200 hover:bg-slate-50 transition-colors shadow-sm"
                                        onClick={() => handleOpenPrivateChat({ id: responder.userId, name: responder.userName || responder.email })}
                                      >
                                        <MessageCircle className="h-3.5 w-3.5 mr-1 text-slate-500 flex-shrink-0" />
                                        Chat
                                      </Button>
                                      {!isIncidentReadOnly && (
                                        <Button
                                          variant="outline"
                                          size="sm"
                                          className="h-7 text-xs px-2.5 bg-emerald-50 hover:bg-emerald-100 text-emerald-700 border-emerald-200 hover:border-emerald-300 transition-colors shadow-sm font-medium"
                                          onClick={() => handleDirectCall(responder, 'voice')}
                                        >
                                          <Phone className="h-3.5 w-3.5 mr-1 text-emerald-600 flex-shrink-0" />
                                          Call
                                        </Button>
                                      )}
                                      {!isIncidentReadOnly && (
                                        <Button
                                          variant="outline"
                                          size="sm"
                                          className="h-7 text-xs px-2.5 bg-amber-50 hover:bg-amber-100 text-amber-700 border-amber-200 hover:border-amber-300 transition-colors shadow-sm font-medium"
                                          onClick={() => handleNotifyUser(responder)}
                                        >
                                          <Bell className="h-3.5 w-3.5 mr-1 text-amber-600 flex-shrink-0" />
                                          Notify
                                        </Button>
                                      )}
                                      <Button
                                        variant="outline"
                                        size="sm"
                                        className="h-7 text-xs px-2.5 text-slate-600 border-slate-200 hover:bg-slate-50 transition-colors shadow-sm"
                                        onClick={() => {
                                          setHistoryResponder(responder);
                                          setShowHistoryModal(true);
                                        }}
                                      >
                                        <ClipboardList className="h-3.5 w-3.5 mr-1 text-slate-500 flex-shrink-0" />
                                        Action Cards
                                      </Button>
                                      {!isIncidentReadOnly && (
                                        <Button
                                          variant="outline"
                                          size="sm"
                                          className="h-7 text-xs px-2.5 bg-blue-50 border-blue-200 text-blue-700 hover:bg-blue-100 transition-colors shadow-sm"
                                          onClick={() => handleAddImmediateTask(responder)}
                                        >
                                          <Plus className="h-3.5 w-3.5 mr-1 text-blue-700 flex-shrink-0" />
                                          Add immediate task
                                        </Button>
                                      )}
                                      {canRemoveIncidentUser && !scenarioMode && !incident?.is_scenario && !isIncidentReadOnly && (
                                        <Button
                                          variant="outline"
                                          size="sm"
                                          className="h-7 text-xs px-2.5 bg-red-50 hover:bg-red-100 text-red-700 border-red-200 hover:border-red-300 transition-colors shadow-sm font-medium"
                                          disabled={Boolean(removingIncidentUserId)}
                                          onClick={() => handleRemoveIncidentParticipant(responder)}
                                          data-testid={`participant-remove-${responder.userId}`}
                                        >
                                          <UserMinus className="h-3.5 w-3.5 mr-1 text-red-600 flex-shrink-0" />
                                          {removingIncidentUserId === String(responder.userId) ? 'Removing…' : 'Remove from incident'}
                                        </Button>
                                      )}
                                    </div>
                                  </div>
                                </div>
                              ))}

                              {/* Crews / departments added to the incident — expandable to their members */}
                              {incidentCrews.map((crew) => (
                                <div key={`crew-${crew.name}`} className="p-3.5 bg-white border border-indigo-100 rounded-xl shadow-sm" data-testid={`participant-crew-${crew.name}`}>
                                  <div className="flex items-center gap-3">
                                    <div className="flex items-center justify-center w-9 h-9 rounded-xl bg-gradient-to-br from-indigo-500 to-violet-600 text-white flex-shrink-0 shadow-sm">
                                      <Users className="h-4 w-4" />
                                    </div>
                                    <div className="flex-1 min-w-0">
                                      <span className="text-sm font-semibold text-slate-800">{crew.name}</span>
                                      <span className="ml-2 text-[10px] font-bold uppercase tracking-wide text-indigo-500">{crew.type}</span>
                                      <p className="text-[11px] text-slate-500">{crew.memberIds.length} member(s)</p>
                                    </div>
                                    <Button
                                      variant="ghost"
                                      size="sm"
                                      className="h-7 w-7 p-0"
                                      data-testid={`crew-expand-${crew.name}`}
                                      onClick={() => setExpandedCrews((prev) => ({ ...prev, [crew.name]: !prev[crew.name] }))}
                                    >
                                      <ChevronDown className={`h-4 w-4 text-slate-500 transition-transform ${expandedCrews[crew.name] ? 'rotate-180' : ''}`} />
                                    </Button>
                                  </div>
                                  {(() => {
                                    const members = crew.memberIds
                                      .map((mid) => drillParticipants.find((pp) => String(pp.userId) === String(mid)))
                                      .filter(Boolean);
                                    const firstLive = members.find((m) => m.live) || members[0];
                                    return (
                                      <div className="flex flex-wrap gap-2 mt-2.5 pl-12">
                                        {/* View Staff — same capability as the department card's button */}
                                        <Button variant="outline" size="sm" className="h-7 text-xs px-2.5 shadow-sm"
                                          data-testid={`crew-view-staff-${crew.name}`}
                                          onClick={async () => {
                                            if (crew.type === 'department') {
                                              // Departments reuse the existing staff modal
                                              const dept = (allDepartments || []).find((d) => (d.department_name || d.name) === crew.name);
                                              if (!dept) { toast.error('Department not found'); return; }
                                              try {
                                                const response = isAdmin
                                                  ? await CommanServices.getbyIddepartments(dept.id)
                                                  : { status: true, data: dept };
                                                setSelectedDepartment(response?.status ? await response.data : dept);
                                              } catch { setSelectedDepartment(dept); }
                                              setShowStaffModal(true);
                                              return;
                                            }
                                            // Crews: resolve id + team from the teams list. Cards label
                                            // crews either "Crew 1" or "Crew 1 — Team" — match both.
                                            let target = null;
                                            (allTeams || []).forEach((t) => (t.crews || []).forEach((c) => {
                                              const plain = c.crew_name || 'Crew';
                                              const composed = `${plain} — ${t.team_name || ''}`.trim();
                                              if (plain === crew.name || composed === crew.name) {
                                                target = { id: c.id, crew_name: c.crew_name, team_id: t.id, team_name: t.team_name };
                                              }
                                            }));
                                            if (!target) { toast.error('Crew not found'); return; }
                                            setCrewStaffTarget(target);
                                          }}>
                                          <Users className="h-3.5 w-3.5 mr-1 flex-shrink-0" /> View Staff
                                        </Button>
                                        {crew.type === 'crew' && (() => {
                                          const parentTeam = (allTeams || []).find((team) => (team.crews || []).some((item) => {
                                            const plain = item.crew_name || 'Crew';
                                            return plain === crew.name || `${plain} — ${team.team_name || ''}`.trim() === crew.name;
                                          }));
                                          return parentTeam ? (
                                            <Button variant="outline" size="sm" className="h-7 px-2.5 text-xs shadow-sm" onClick={() => setTeamStaffTarget(parentTeam)}>
                                              <Users className="mr-1 h-3.5 w-3.5" /> Team Staff
                                            </Button>
                                          ) : null;
                                        })()}
                                        <Button variant="outline" size="sm" className="h-7 text-xs px-2.5 bg-blue-50 hover:bg-blue-100 text-blue-700 border-blue-200 shadow-sm font-medium"
                                          onClick={() => members.forEach((m) => handleTrackUser(m))}>
                                          <MapPin className="h-3.5 w-3.5 mr-1 text-blue-600 flex-shrink-0" /> Track!
                                        </Button>
                                        <Button variant="outline" size="sm" className="h-7 text-xs px-2.5 text-slate-600 border-slate-200 hover:bg-slate-50 shadow-sm"
                                          onClick={() => navigate(chatWorkspaceUrl)}>
                                          <MessageCircle className="h-3.5 w-3.5 mr-1 text-slate-500 flex-shrink-0" /> Chat
                                        </Button>
                                        <Button variant="outline" size="sm" className="h-7 text-xs px-2.5 text-slate-600 border-slate-200 hover:bg-slate-50 shadow-sm"
                                          disabled={!firstLive}
                                          title={firstLive ? `Call ${firstLive.userName}` : 'No member available to call'}
                                          onClick={() => firstLive && handleDirectCall(firstLive, 'voice')}>
                                          <Phone className="h-3.5 w-3.5 mr-1 text-slate-500 flex-shrink-0" /> Call
                                        </Button>
                                        <Button variant="outline" size="sm" className="h-7 text-xs px-2.5 text-slate-600 border-slate-200 hover:bg-slate-50 shadow-sm"
                                          onClick={() => members.forEach((m) => handleNotifyUser(m))}>
                                          <Bell className="h-3.5 w-3.5 mr-1 text-amber-600 flex-shrink-0" /> Notify
                                        </Button>
                                        <Button variant="outline" size="sm" className="h-7 text-xs px-2.5 text-slate-600 border-slate-200 hover:bg-slate-50 shadow-sm"
                                          onClick={() => {
                                            setHistoryResponder({ userId: null, userName: crew.name, memberIds: crew.memberIds, isCrew: true });
                                            setShowHistoryModal(true);
                                          }}>
                                          <ClipboardList className="h-3.5 w-3.5 mr-1 text-slate-500 flex-shrink-0" /> Action Cards
                                        </Button>
                                        {!isIncidentReadOnly && (
                                          <Button variant="outline" size="sm" className="h-7 text-xs px-2.5 bg-blue-50 border-blue-200 text-blue-700 hover:bg-blue-100 shadow-sm"
                                            onClick={() => {
                                              if (guardIncidentMutation()) return;
                                              setResponseActionPrefills({ prefilledName: 'Immediate action card', prefilledUserIds: crew.memberIds, isImmediateTask: true });
                                              setEditingResponseAction(null);
                                              setShowResponseActionModal(true);
                                            }}>
                                            <Plus className="h-3.5 w-3.5 mr-1 text-blue-700 flex-shrink-0" /> Add immediate task
                                          </Button>
                                        )}
                                      </div>
                                    );
                                  })()}
                                  {expandedCrews[crew.name] && (
                                    <div className="mt-2 pl-12 space-y-1">
                                      {crew.memberIds.map((mid) => {
                                        const m = drillParticipants.find((pp) => String(pp.userId) === String(mid));
                                        return (
                                          <p key={mid} className="text-xs text-slate-700 flex items-center gap-1.5">
                                            <UserCircle2 className="h-3.5 w-3.5 text-indigo-400" />
                                            {m?.userName || appUsers.find((u) => String(u.id) === String(mid))?.name || mid}
                                          </p>
                                        );
                                      })}
                                      {crew.memberIds.length === 0 && <p className="text-xs text-slate-400">No members recorded yet.</p>}
                                    </div>
                                  )}
                                </div>
                              ))}
                            </div>
                          );
                        })()}
                      </CardContent>
                    </Card>
                    </CollapsibleWidget>
                  )}

                  {/* Departments and Units Widget */}
                  {visibleWidgets.departments && (
                    <CollapsibleWidget title="Organization and Departments" testId="widget-organization-departments" defaultOpen={!scenarioEnv && !isActiveExercise}>
                    <Card className="bg-white shadow-none border-0 rounded-none">
                      <CardContent className="p-4">
                        {(() => {
                          // Show only the departments that were selected for this request (impacted_departments),
                          // enriched with full data from the location/department lists when available.
                          let selectedDeptIds = normalizeDepartmentIds(incident?.impacted_departments);
                          // Real incidents rarely pick departments explicitly — fall back to
                          // the departments linked to the reported location.
                          if (!selectedDeptIds.length && !incident?.is_exercise && (locationDepartments || []).length) {
                            selectedDeptIds = (locationDepartments || []).map((d) => String(d.id)).filter(Boolean);
                          }
                          const selectedDepartments = selectedDeptIds.map((idStr) => {
                            const fromLoc = (locationDepartments || []).find((d) => String(d.id) === idStr);
                            if (fromLoc) return fromLoc;
                            const fromAll = (allDepartments || []).find((d) => String(d.id || d._id) === idStr);
                            return fromAll
                              ? { ...fromAll, id: idStr, department_name: fromAll.department_name || fromAll.name || idStr, relationship_type: fromAll.relationship_type || 'secondary' }
                              : { id: idStr, department_name: idStr, relationship_type: 'secondary' };
                          });
                          const incidentLocationId = Array.isArray(incident?.location) ? incident.location[0] : null;
                          const hasRealLocation = !!incidentLocationId && incidentLocationId !== 'unknown';
                          return (
                        <div data-testid="organization-departments-list">
                          {/* New Department — creates a record in the Departments & Units module
                              and auto-links it to the incident location (Locations & Zones stays in sync) */}
                          {isAdmin && !incident?.is_exercise && (
                            <div className="flex justify-end mb-3">
                              <Button
                                variant="outline"
                                size="sm"
                                className="h-7 text-xs px-2.5 bg-indigo-50 hover:bg-indigo-100 text-indigo-700 border-indigo-200 hover:border-indigo-300 transition-colors shadow-sm font-medium disabled:opacity-50"
                                onClick={() => setShowCreateDepartment(true)}
                                disabled={!hasRealLocation}
                                title={hasRealLocation ? 'Create a department and link it to the incident location' : 'Assign a location to this incident first'}
                                data-testid="departments-new-department-btn"
                              >
                                <Plus className="h-3.5 w-3.5 mr-1 text-indigo-700 flex-shrink-0" />
                                New Department
                              </Button>
                            </div>
                          )}
                          {loadingDepartments ? (
                            <div className="text-center py-4 text-gray-500 text-sm">
                              Loading departments...
                            </div>
                          ) : selectedDepartments.length === 0 ? (
                            <div className="text-center py-4 text-gray-500 text-sm">
                              {incident?.is_exercise ? 'No departments were selected for this request' : 'No departments are linked to the reported location'}
                            </div>
                          ) : (
                            <div className="space-y-3">
                              {selectedDepartments.map((dept, index) => (
                                <div key={dept.id} className="flex items-start gap-3 p-3 border border-gray-200 rounded-lg hover:bg-gray-50 transition-colors">
                                  <div className={`flex items-center justify-center w-8 h-8 rounded-full ${dept.relationship_type === 'primary' ? 'bg-purple-100 text-purple-700' : 'bg-gray-100 text-gray-700'
                                    } font-bold text-sm flex-shrink-0`}>
                                    {index + 1}
                                  </div>
                                  <div className="flex-1 min-w-0">
                                    <div className="text-sm font-medium text-gray-900 mb-1">
                                      {dept.department_name || 'Unknown Department'}
                                    </div>
                                    <div className="flex items-center gap-2 mb-2">
                                      <span className={`inline-flex items-center px-2 py-0.5 rounded text-xs font-medium ${dept.relationship_type === 'primary'
                                        ? 'bg-purple-100 text-purple-800'
                                        : 'bg-gray-100 text-gray-800'
                                        }`}>
                                        {dept.relationship_type === 'primary' ? 'Primary' : 'Secondary'}
                                      </span>
                                    </div>
                                    {/* Count badges row */}
                                    {(() => {
                                      const membersArr = Array.isArray(dept.members) ? dept.members : [];
                                      const leadersArr = Array.isArray(dept.leaders) ? dept.leaders : [];
                                      const leaderCountRaw = dept.leader_count ?? dept.leaderCount;
                                      const memberCountRaw = dept.member_count ?? dept.memberCount ?? dept.total_members;
                                      const leaderCount = Number.isFinite(Number(leaderCountRaw)) ? Number(leaderCountRaw) : leadersArr.length;
                                      const memberCount = Number.isFinite(Number(memberCountRaw)) ? Number(memberCountRaw) : membersArr.length;
                                      return (
                                        <div className="flex items-center gap-1.5 mb-2">
                                          <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[11px] font-semibold bg-violet-100 text-violet-800 border border-violet-200">
                                            <svg className="w-3 h-3" viewBox="0 0 20 20" fill="currentColor"><path d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z" /></svg>
                                            Leader: {leaderCount}
                                          </span>
                                          <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[11px] font-semibold bg-blue-100 text-blue-800 border border-blue-200">
                                            <svg className="w-3 h-3" viewBox="0 0 20 20" fill="currentColor"><path d="M13 6a3 3 0 11-6 0 3 3 0 016 0zM18 8a2 2 0 11-4 0 2 2 0 014 0zM2 8a2 2 0 114 0A2 2 0 012 8zM5.3 14.7A6.98 6.98 0 0110 13a6.98 6.98 0 014.7 1.7A7.95 7.95 0 0110 16a7.95 7.95 0 01-4.7-1.3zM16 11a1 1 0 10-2 0v.001a7.008 7.008 0 01-4 6.32A7.008 7.008 0 016 11V11a1 1 0 10-2 0 9 9 0 0018 0z" /></svg>
                                            Members: {memberCount}
                                          </span>
                                        </div>
                                      );
                                    })()}
                                    <div className="flex flex-wrap gap-1.5">
                                      {/* View Staff */}
                                      <Button
                                        variant="outline"
                                        size="sm"
                                        className="h-7 text-xs px-2"
                                        onClick={async () => {
                                          try {
                                            // Fetch full department details including members
                                            const response = isAdmin
                                              ? await CommanServices.getbyIddepartments(dept.id)
                                              : { status: true, data: dept };
                                            if (response.status) {
                                              const fullDepartment = await response.data;
                                              setSelectedDepartment(fullDepartment);
                                              setShowStaffModal(true);
                                            } else {
                                              console.error('Failed to fetch department details');
                                              // Fallback to existing data
                                              setSelectedDepartment(dept);
                                              setShowStaffModal(true);
                                            }
                                          } catch (error) {
                                            console.error('Error fetching department:', error);
                                            // Fallback to existing data
                                            setSelectedDepartment(dept);
                                            setShowStaffModal(true);
                                          }
                                        }}
                                      >
                                        <Users className="h-3 w-3 mr-1" />
                                        View Staff
                                      </Button>

                                      {(
                                        <>
                                          {/* Call Leader */}
                                          <Button
                                            variant="outline"
                                            size="sm"
                                            className="h-7 text-xs px-2 bg-emerald-50 hover:bg-emerald-100 text-emerald-700 border-emerald-200 hover:border-emerald-300 transition-colors shadow-sm font-medium"
                                            onClick={() => handleCallLeader(dept)}
                                          >
                                            <Phone className="h-3 w-3 mr-1 text-emerald-600" />
                                            Call Leader
                                          </Button>

                                          {/* Call Staff */}
                                          <Button
                                            variant="outline"
                                            size="sm"
                                            className="h-7 text-xs px-2 bg-teal-50 hover:bg-teal-100 text-teal-700 border-teal-200 hover:border-teal-300 transition-colors shadow-sm font-medium"
                                            onClick={() => handleCallStaff(dept)}
                                          >
                                            <Phone className="h-3 w-3 mr-1 text-teal-600" />
                                            Call Staff
                                          </Button>

                                          {/* Notify Leader */}
                                          <Button
                                            variant="outline"
                                            size="sm"
                                            className="h-7 text-xs px-2 bg-amber-50 hover:bg-amber-100 text-amber-700 border-amber-200 hover:border-amber-300 transition-colors shadow-sm font-medium"
                                            onClick={() => handleNotifyLeader(dept)}
                                          >
                                            <Bell className="h-3 w-3 mr-1 text-amber-600" />
                                            Notify Leader
                                          </Button>

                                          {/* Notify Staff */}
                                          <Button
                                            variant="outline"
                                            size="sm"
                                            className="h-7 text-xs px-2 bg-orange-50 hover:bg-orange-100 text-orange-700 border-orange-200 hover:border-orange-300 transition-colors shadow-sm font-medium"
                                            onClick={() => handleNotifyStaff(dept)}
                                          >
                                            <Bell className="h-3 w-3 mr-1 text-orange-600" />
                                            Notify Staff
                                          </Button>
                                        </>
                                      )}

                                      {/* Assign Leader (admin only, when no leader) */}
                                      {isAdmin && (() => {
                                        const membersArr = Array.isArray(dept.members) ? dept.members : [];
                                        const leadersArr = Array.isArray(dept.leaders) ? dept.leaders : [];
                                        const leaderCountRaw = dept.leader_count ?? dept.leaderCount;
                                        const leaderCount = Number(leaderCountRaw);
                                        const immediateHasLeader = Boolean(
                                          (Number.isFinite(leaderCount) ? leaderCount > 0 : false) ||
                                          leadersArr.length > 0 ||
                                          membersArr.some(m => m?.is_leader === true) ||
                                          Boolean(dept.department_leader || dept.departmentLeader || dept.department_leader_id)
                                        );
                                        const resolved = (dept && dept.id && (dept.id in deptLeaderMap)) ? deptLeaderMap[dept.id] : undefined;
                                        const hasLeader = immediateHasLeader || resolved === true;

                                        if (hasLeader) return null;

                                        return (
                                          <div className="w-full mt-2">
                                            <div className="text-[11px] text-red-700 bg-red-50 border border-red-200 rounded px-2 py-1 mb-2">
                                              No department leader assigned.
                                            </div>
                                            <Button
                                              variant="outline"
                                              size="sm"
                                              className="h-7 text-xs px-2 bg-red-50 border-red-200 text-red-700 hover:bg-red-100 disabled:opacity-50"
                                              disabled={loadingDepartments}
                                              onClick={async () => {
                                                try {
                                                  const response = await CommanServices.getbyIddepartments(dept.id);
                                                  if (response?.status) {
                                                    setSelectedDepartment(response.data);
                                                  } else {
                                                    setSelectedDepartment(dept);
                                                  }
                                                  setShowStaffModal(true);
                                                } catch (err) {
                                                  console.error('Error opening staff modal:', err);
                                                  setSelectedDepartment(dept);
                                                  setShowStaffModal(true);
                                                }
                                              }}
                                            >
                                              Assign Leader
                                            </Button>
                                          </div>
                                        );
                                      })()}
                                    </div>
                                  </div>
                                </div>
                              ))}
                            </div>
                          )}
                        </div>
                          );
                        })()}
                      </CardContent>
                    </Card>
                    </CollapsibleWidget>
                  )}

                  {/* Corrective Actions & Review — real incidents: sits directly
                      below Organization and Departments (parity with drills). */}
                  {isAdmin && !incident?.is_exercise && !incident?.is_scenario && visibleWidgets.correctiveActions && (
                    <div className="mb-4" data-testid="widget-corrective-actions"><CorrectiveActionsPanel incident={incident} /></div>
                  )}

                  {/* Resources — real incidents: sits below Organization and Departments */}
                  {!incident?.is_exercise && visibleWidgets.availableResources && (
                    <CollapsibleWidget title="Resources" testId="widget-available-resources">
                      <IncidentResourcesPanel incident={incident} isAdmin={isContextAdmin} />
                    </CollapsibleWidget>
                  )}

                  {/* Attachments Widget — incident report + timeline (e.g. status updates) + Firestore chat media */}
                  {visibleWidgets.attachments && !isCompletedStage && (() => {
                    const attachments = allAttachmentsForWidget;

                    return (
                      <Card className="bg-white shadow-sm border border-gray-200">
                        <CardContent className="p-4">
                          <h3 className="text-sm font-bold text-gray-900 mb-1 flex items-center gap-2">
                            <Paperclip className="h-4 w-4 text-gray-600" />
                            Attachments
                            {attachments.length > 0 && (
                              <span className="ml-auto inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
                                {attachments.length} file{attachments.length !== 1 ? 's' : ''}
                              </span>
                            )}
                          </h3>
                          <p className="text-xs text-gray-500 mb-3">
                            Report, timeline updates, and team chat media
                          </p>

                          {attachments.length === 0 ? (
                            <div className="flex flex-col items-center justify-center py-8 text-gray-400">
                              <Paperclip className="h-10 w-10 mb-2 opacity-40" />
                              <p className="text-sm">No media or attachments yet</p>
                            </div>
                          ) : (
                            <>
                              {/* Thumbnail Grid */}
                              <div className="flex flex-wrap gap-3">
                                {attachments.map((att, idx) => {
                                  const filename = att.filename || att.key?.split('/').pop() || `File ${idx + 1}`;
                                  const url = att.url || att.file_url
                                    || (att.key ? `${ApiEndPoint}/api/files/${String(att.key).replace(/^\/+/, '')}` : null)
                                    || att.s3_url;
                                  const contentType = (att.content_type || att.type || '').toLowerCase();
                                  const urlStr = url || '';
                                  const isPDF =
                                    contentType.includes('pdf')
                                    || /\.pdf(\?|$)/i.test(urlStr)
                                    || /\.pdf$/i.test(filename || '');
                                  const isImage =
                                    contentType.startsWith('image/')
                                    || /\.(jpe?g|png|gif|webp|bmp|svg|heic|heif)(\?|$)/i.test(urlStr);
                                  const isVideo =
                                    contentType.startsWith('video/')
                                    || /\.(mp4|webm|mov|m4v|mkv|avi|ogv)(\?|$)/i.test(urlStr);
                                  const isAudio =
                                    contentType.startsWith('audio/')
                                    || /\.(mp3|wav|m4a|aac|ogg|opus)(\?|$)/i.test(urlStr);
                                  const isDoc =
                                    !isPDF
                                    && /(msword|officedocument|presentation|spreadsheet|excel|sheet)/i.test(contentType);

                                  const openPreview = () => {
                                    setAttachmentPreview({
                                      url,
                                      filename,
                                      contentType: att.content_type || att.type || '',
                                      isImage,
                                      isVideo,
                                      isAudio,
                                      isPDF,
                                    });
                                  };

                                  return (
                                    <div
                                      key={idx}
                                      className="relative w-16 h-16 rounded-lg overflow-hidden border border-gray-200 shadow-sm group cursor-pointer"
                                      onClick={openPreview}
                                      title={filename}
                                    >
                                      {isImage ? (
                                        <AuthenticatedMedia
                                          as="img"
                                          src={url}
                                          alt={filename}
                                          className="object-cover w-full h-full"
                                          onError={(e) => { e.target.style.display = 'none'; e.target.nextSibling?.style && (e.target.nextSibling.style.display = 'flex'); }}
                                        />
                                      ) : isVideo ? (
                                        <AuthenticatedMedia
                                          as="video"
                                          src={url}
                                          className="object-cover w-full h-full"
                                          muted
                                        />
                                      ) : isAudio ? (
                                        <div className="w-full h-full flex flex-col items-center justify-center bg-indigo-50">
                                          <span className="text-lg" aria-hidden>🎵</span>
                                          <span className="text-[10px] text-indigo-700 mt-0.5">Audio</span>
                                        </div>
                                      ) : isPDF ? (
                                        <div className="w-full h-full flex flex-col items-center justify-center bg-rose-50 border border-rose-100">
                                          <FileText className="h-6 w-6 text-rose-600" />
                                          <span className="text-[10px] font-semibold text-rose-800 mt-0.5">PDF</span>
                                        </div>
                                      ) : (
                                        <div className="w-full h-full flex flex-col items-center justify-center bg-gray-50">
                                          <svg xmlns="http://www.w3.org/2000/svg" className="h-7 w-7 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M7 7h6l4 4v6a2 2 0 01-2 2H7a2 2 0 01-2-2V7z" />
                                          </svg>
                                          <div className="text-xs text-gray-500 mt-1">
                                            {isDoc ? 'DOC' : 'FILE'}
                                          </div>
                                        </div>
                                      )}

                                      {/* Hover overlay */}
                                      <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-30 transition-all flex items-center justify-center">
                                        <Download className="h-4 w-4 text-white opacity-0 group-hover:opacity-100 transition-opacity" />
                                      </div>
                                    </div>
                                  );
                                })}
                              </div>

                              {/* Lightbox Preview Modal */}
                              {attachmentPreview && (
                                <div
                                  className="fixed inset-0 bg-black bg-opacity-80 flex items-center justify-center z-[9999] p-4"
                                  onClick={() => setAttachmentPreview(null)}
                                >
                                  <div
                                    className="relative max-w-4xl w-full max-h-[90vh] bg-white rounded-xl overflow-hidden shadow-2xl"
                                    onClick={(e) => e.stopPropagation()}
                                  >
                                    {/* Modal header */}
                                    <div className="flex items-center justify-between px-4 py-3 border-b">
                                      <span className="text-sm font-medium text-gray-800 truncate max-w-xs" title={attachmentPreview.filename}>
                                        {attachmentPreview.filename}
                                      </span>
                                      <div className="flex items-center gap-2 flex-shrink-0">
                                        {attachmentPreview.url && (
                                          <AuthenticatedMediaLink
                                            href={attachmentPreview.url}
                                            download={attachmentPreview.filename}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="flex items-center gap-1 px-3 py-1.5 text-xs font-medium text-white bg-blue-600 rounded-lg hover:bg-blue-700 transition-colors"
                                            onClick={(e) => e.stopPropagation()}
                                          >
                                            <Download className="h-3 w-3" />
                                            {attachmentPreview.isImage || attachmentPreview.isVideo || attachmentPreview.isPDF
                                              ? 'Download'
                                              : 'Download'}
                                          </AuthenticatedMediaLink>
                                        )}
                                        <button
                                          onClick={() => setAttachmentPreview(null)}
                                          className="p-1.5 text-gray-500 hover:text-gray-900 hover:bg-gray-100 rounded-lg transition-colors"
                                        >
                                          <X className="h-4 w-4" />
                                        </button>
                                      </div>
                                    </div>

                                    {/* Preview body — image, video, PDF (iframe), audio */}
                                    <div className="flex flex-col items-stretch bg-gray-100 min-h-[300px] max-h-[80vh] overflow-hidden">
                                      {attachmentPreview.isImage ? (
                                        <div className="flex items-center justify-center bg-gray-900 min-h-[300px] max-h-[75vh] overflow-auto p-2">
                                          <AuthenticatedMedia
                                            as="img"
                                            src={attachmentPreview.url}
                                            alt={attachmentPreview.filename}
                                            className="max-w-full max-h-[75vh] object-contain"
                                          />
                                        </div>
                                      ) : attachmentPreview.isVideo ? (
                                        <div className="flex items-center justify-center bg-black min-h-[300px] max-h-[75vh]">
                                          <AuthenticatedMedia
                                            as="video"
                                            src={attachmentPreview.url}
                                            controls
                                            playsInline
                                            className="max-w-full max-h-[75vh]"
                                          />
                                        </div>
                                      ) : attachmentPreview.isPDF ? (
                                        <div className="flex flex-col w-full bg-white min-h-[50vh] max-h-[75vh]">
                                          <AuthenticatedMedia
                                            as="iframe"
                                            title={attachmentPreview.filename}
                                            src={attachmentPreview.url}
                                            className="w-full flex-1 min-h-[60vh] border-0 bg-white"
                                          />
                                          <p className="text-xs text-gray-500 px-3 py-2 border-t bg-gray-50">
                                            If the preview is blank, use &quot;Open in new tab&quot; — some servers send PDFs as download-only.
                                          </p>
                                        </div>
                                      ) : attachmentPreview.isAudio ? (
                                        <div className="flex flex-col items-center justify-center p-8 w-full bg-gray-900">
                                          <AuthenticatedMedia
                                            as="audio"
                                            src={attachmentPreview.url}
                                            controls
                                            className="w-full max-w-lg"
                                          >
                                            Your browser does not support audio.
                                          </AuthenticatedMedia>
                                        </div>
                                      ) : (
                                        <div className="flex flex-col items-center justify-center p-12 text-gray-500 bg-gray-900 min-h-[300px]">
                                          <FileText className="h-16 w-16 mb-4 text-gray-400" />
                                          <p className="text-sm text-gray-300">{attachmentPreview.filename}</p>
                                          <p className="text-xs text-gray-500 mt-2 text-center max-w-sm">
                                            Preview is not available for this file type. Use Download to open it.
                                          </p>
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                </div>
                              )}
                            </>
                          )}
                        </CardContent>
                      </Card>
                    );
                  })()}

                  {/* Scenario communication stays in the header and discussion group. */}
                  {visibleWidgets.chat && !scenarioEnv && (
                    <Card className="bg-white shadow-sm border border-gray-200 overflow-hidden rounded-xl">
                      <Link to={chatWorkspaceUrl}>
                        {/* Top banner (blue) */}
                        <div className="bg-gradient-to-r from-blue-600 to-blue-500 p-4 text-white flex items-center justify-between hover:opacity-95 transition-opacity">
                          <div className="flex items-center gap-3">
                            {/* Chat icon with unread badge */}
                            <div className="relative">
                              <div className="w-10 h-10 rounded-full bg-white/20 flex items-center justify-center">
                                <MessageSquare className="h-5 w-5 text-white" />
                              </div>
                              {unreadCount > 0 && (
                                <span className="absolute -top-1 -right-1 bg-red-500 text-white text-[10px] font-bold h-5 w-5 rounded-full flex items-center justify-center border-2 border-blue-600 shadow animate-pulse">
                                  {unreadCount}
                                </span>
                              )}
                            </div>
                            <div>
                              <h3 className="font-bold text-base leading-tight">
                                {scenarioEnv ? 'Scenario Chat' : 'Incident Chat'}
                              </h3>
                              <p className="text-xs text-blue-100/90 mt-0.5 font-medium">
                                {unreadCount > 0
                                  ? `${unreadCount} unread message${unreadCount !== 1 ? 's' : ''}`
                                  : '0 unread messages'}
                              </p>
                            </div>
                          </div>
                          <span className="text-sm font-bold flex items-center gap-1 hover:underline">
                            Open <span className="text-lg">→</span>
                          </span>
                        </div>
                        {/* Bottom tip banner (light blue) */}
                        <div className="bg-blue-50/70 border-t border-blue-100/50 p-3 flex items-center gap-2 text-xs text-blue-900 font-medium">
                          <span>💡</span>
                          <span>Showing unread messages only. Click "Open" to view all messages.</span>
                        </div>
                      </Link>
                    </Card>
                  )}

                  {/* Audit Log — real incidents: sits below Incident Chat */}
                  {!incident?.is_exercise && visibleWidgets.auditLog && (
                    <CollapsibleWidget title="Audit Log" testId="widget-audit-log">
                      <AuditLogWidget incident={incident} />
                    </CollapsibleWidget>
                  )}

                  {/* Scenario env & drills: Audit Log is ALWAYS the last widget on the page */}
                  {(scenarioEnv || incident?.is_exercise) && visibleWidgets.auditLog && (
                    <CollapsibleWidget
                      title="Audit Log"
                      testId="widget-audit-log"
                      defaultOpen={!scenarioEnv}
                      variant={scenarioEnv ? 'scenario' : 'default'}
                      icon={ClipboardList}
                    >
                      <AuditLogWidget incident={incident} />
                    </CollapsibleWidget>
                  )}

                  {/* Original large cards removed - content now in compact row above */}
                </div>
              )}
            </main>

            {/* Right Panel - Unified Incident Tracking with Phase Tabs */}
            {!isSidebarCollapsed && (
              <aside
                id="incident-tracking"
                ref={timelineScrollRef}
                data-testid="incident-tracking-scroll"
                data-modal-scroll-root
                style={{ scrollBehavior: 'auto' }}
                className={`no-scrollbar h-[calc(100vh-81px)] ${isAnyModalOpen ? 'overflow-hidden' : 'overflow-y-auto'} bg-white border-l border-gray-200 shadow-lg animate-in slide-in-from-right duration-300`}
              >
{/* Scenario map pull moved into the map widget header ("Activate scenario map") */}

                <QuickAssignModal
                  incident={incident}
                  items={timelineItems}
                  onlineUserIds={onlineParticipantIds}
                  presenceByUserId={mobilePresenceByUser}
                  isOpen={showQuickAssign}
                  onClose={() => setShowQuickAssign(false)}
                  onChanged={async () => {
                    await Promise.all([fetchIncidentDetail(true), fetchTimelineData()]);
                  }}
                />

                {/* Page-level personnel picker — summoned by every card's Assign button.
                    Mounted OUTSIDE the card tree so timeline remounts can't destabilise it. */}
                <AssignPersonnelModal
                  incident={incident}
                  allItems={timelineItems}
                  onlineUserIds={onlineParticipantIds}
                  presenceByUserId={mobilePresenceByUser}
                  isAdmin={isContextAdmin}
                />

                {/* Crew "View Staff" — same capability as the department staff modal */}
                {crewStaffTarget && (
                  <CrewStaffModal
                    crew={crewStaffTarget}
                    incidentId={incident?.id}
                    isAdmin={isContextAdmin}
                    onClose={() => setCrewStaffTarget(null)}
                    onCall={(m) => handleDirectCall({ userId: m.userId, userName: m.name }, 'voice')}
                    onNotify={(m) => handleNotifyUser({ userId: m.userId, userName: m.name })}
                  />
                )}
                {teamStaffTarget && (
                  <TeamStaffModal
                    team={teamStaffTarget}
                    incidentId={incident?.id}
                    isAdmin={isContextAdmin}
                    onClose={() => setTeamStaffTarget(null)}
                  />
                )}

                {showCreateTeamCrew && (
                  <CreateTeamCrewDialog
                    teams={allTeams}
                    incident={incident}
                    onClose={() => setShowCreateTeamCrew(false)}
                    onCreated={fetchTeams}
                  />
                )}

                {showCreateDepartment && (() => {
                  const incidentLocationId = Array.isArray(incident?.location) ? incident.location[0] : null;
                  const loc = (locations || []).find((l) => l.id === incidentLocationId);
                  return (
                    <CreateDepartmentDialog
                      incident={incident}
                      locationId={incidentLocationId}
                      locationName={loc?.zone_name || loc?.auto_label || ''}
                      onClose={() => setShowCreateDepartment(false)}
                      onCreated={fetchLocationDepartments}
                    />
                  );
                })()}

                {showGeoFence && canUseGeoFence && (
                  <GeoFenceModal
                    incident={incident}
                    involvedUserIds={[
                      ...(incident?.assigned_users || []),
                      ...(incident?.notified_user_ids || []),
                      ...(drillParticipants || []).map((participant) => participant.userId),
                    ].map(String)}
                    allowedUserIds={isAdmin ? null : (scopedRecipientScope?.userIds || [])}
                    onClose={() => setShowGeoFence(false)}
                    onAction={handleGeoFenceAction}
                  />
                )}


                {/* Timeline Content */}
                <div>
                  <IncidentTimeline
                    key={incident.id}
                    incident={incident}
                    departments={allDepartments}
                    readOnly={isIncidentReadOnly}
                    hidePlannedCards={hidePlanned}
                    scrollContainerRef={timelineScrollRef}
                    onRevealTimelineItem={revealTimelineItem}
                    activeTab={activeTab}
                    currentUser={currentUser}
                    isAdmin={isIncidentReadOnly ? false : isContextAdmin}
                    canResolveIncident={canResolveIncident}
                    isDepartmentLeader={isIncidentReadOnly ? false : isIncidentScopedLeader}
                    setActiveGroup={setActiveGroup}
                    setShowTimelineModal={guardModalOpen(setShowTimelineModal)}
                    setEditingItem={setEditingItem}
                    setShowAcknowledgmentModal={guardModalOpen(setShowAcknowledgmentModal)}
                    setEditingAcknowledgment={setEditingAcknowledgment}
                    setAcknowledgmentMode={setAcknowledgmentMode}
                    setShowResponseActionModal={guardModalOpen(setShowResponseActionModal)}
                    setEditingResponseAction={setEditingResponseAction}
                    setShowStatusUpdateModal={guardModalOpen(setShowStatusUpdateModal)}
                    setEditingStatusUpdate={setEditingStatusUpdate}
                    setStatusUpdateGroup={setStatusUpdateGroup}
                    setShowResolutionModal={guardModalOpen(setShowResolutionModal)}
                    setEditingResolution={setEditingResolution}
                    setShowNotificationModal={guardModalOpen(setShowNotificationModal)}
                    setEditingNotification={setEditingNotification}
                    setShowManualNotificationModal={guardModalOpen(setShowManualNotificationModal)}
                    setEditingManualNotification={setEditingManualNotification}
                    onStartConditional={(sourceItem, sourceTaskIndex = null) => setConditionalPicker({ sourceItem, sourceTaskIndex })}
                    onRefreshIncident={fetchIncidentDetail}
                    onChatWithReporter={(targetUser) => handleOpenPrivateChat(targetUser)}
                    onOpenMapGeneralInfo={() => {
                      const mapCard = document.getElementById('location-map-card');
                      if (mapCard) mapCard.scrollIntoView({ behavior: 'smooth', block: 'start' });
                      setGeneralInfoOpenRequest((request) => request + 1);
                    }}
                  >
                    {/* Private Conversations Widget - Always visible for everyone (Task 13.2) */}
                    <div
                      className="flex items-center justify-between mb-4 cursor-pointer hover:opacity-80"
                      onClick={() => setIsDmSidebarOpen(!isDmSidebarOpen)}
                    >
                      <h3 className="text-sm font-bold text-gray-900 flex items-center gap-2">
                        <MessageCircle className="h-4 w-4 text-indigo-600" />
                        Active Private Chats {activeConversations.length > 0 ? `(${activeConversations.length})` : ''}
                      </h3>
                      {activeConversations.length > 0 && (
                        isDmSidebarOpen ? <Minus className="h-4 w-4 text-gray-400" /> : <Plus className="h-4 w-4 text-gray-400" />
                      )}
                    </div>

                    {isDmSidebarOpen && activeConversations.length > 0 && (
                      <div className="space-y-3 animate-in fade-in slide-in-from-top-2 duration-300">
                        {activeConversations.map((conv) => (
                          <button
                            key={conv.room}
                            onClick={() => handleOpenPrivateChat({ id: conv.otherId, name: conv.otherName, room: conv.room })}
                            className="w-full text-left p-3 rounded-xl border border-gray-100 hover:border-indigo-200 hover:bg-indigo-50/30 transition-all flex items-center gap-3 group"
                          >
                            <div className="w-10 h-10 rounded-full bg-indigo-100 text-indigo-700 flex items-center justify-center font-bold shrink-0">
                              {conv.otherName.charAt(0).toUpperCase()}
                            </div>
                            <div className="flex-1 min-w-0">
                              <div className="flex justify-between items-baseline mb-0.5">
                                <p className="text-sm font-semibold text-gray-900 truncate group-hover:text-indigo-700 transition-colors">
                                  {conv.otherName}
                                </p>
                                <span className="text-[10px] text-gray-400">
                                  {new Date(conv.lastCreatedAt).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
                                </span>
                              </div>
                              <p className="text-xs text-gray-500 truncate italic">
                                {conv.lastText}
                              </p>
                            </div>
                          </button>
                        ))}
                      </div>
                    )}

                    {activeConversations.length === 0 && isDmSidebarOpen && (
                      <p className="text-xs text-gray-400 italic py-2">No active private conversations yet.</p>
                    )}
                  </IncidentTimeline>
                </div>
              </aside>
            )}
          </div>
        </div>
      </div>

      {/* DM Notification Toast */}
      {dmNotification && (
        <div className="fixed bottom-6 left-6 z-[200] animate-in fade-in slide-in-from-bottom-4 duration-300">
          <div className="bg-white rounded-xl shadow-2xl border border-indigo-100 p-4 w-80 flex gap-4 items-start">
            <div className="w-10 h-10 rounded-full bg-indigo-600 flex items-center justify-center text-white font-bold shrink-0 shadow-inner">
              {dmNotification.senderName.charAt(0).toUpperCase()}
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-xs font-bold text-indigo-600 mb-0.5">New Private Message</p>
              <p className="text-sm font-semibold text-gray-900 truncate">{dmNotification.senderName}</p>
              <p className="text-sm text-gray-600 line-clamp-2 mt-1 leading-snug">
                {dmNotification.text}
              </p>
              <div className="flex gap-2 mt-3">
                <button
                  onClick={() => {
                    handleOpenPrivateChat({ id: dmNotification.senderId, name: dmNotification.senderName });
                    setDmNotification(null);
                  }}
                  className="px-3 py-1.5 bg-indigo-600 text-white text-xs font-bold rounded-lg hover:bg-indigo-700 transition-colors shadow-sm"
                >
                  Reply Now
                </button>
                <button
                  onClick={() => setDmNotification(null)}
                  className="px-3 py-1.5 bg-gray-100 text-gray-600 text-xs font-bold rounded-lg hover:bg-gray-200 transition-colors"
                >
                  Dismiss
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Chat Modal */}
      {showChatModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg shadow-xl max-w-2xl w-full max-h-[80vh] overflow-y-auto m-4">
            <div className="p-6 border-b border-gray-200 flex items-center justify-between">
              <h2 className="text-xl font-semibold">{scenarioEnv ? 'Scenario Chat' : 'Incident Chat'}</h2>
              <Button variant="ghost" size="sm" onClick={() => setShowChatModal(false)}>
                <X className="h-4 w-4" />
              </Button>
            </div>
            <div className="p-6">
              <p className="text-gray-600">Chat functionality would be implemented here.</p>
            </div>
          </div>
        </div>
      )}

      {/* Staff Modal */}
      {showStaffModal && selectedDepartment && (
        <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50 backdrop-blur-sm">
          <div className="bg-white rounded-2xl shadow-2xl max-w-3xl w-full max-h-[88vh] flex flex-col m-4 overflow-hidden">
            {/* Modal Header */}
            <div className="px-6 py-4 border-b border-gray-100 flex items-center justify-between bg-gradient-to-r from-slate-800 to-indigo-900 rounded-t-2xl">
              <div className="flex items-center gap-3">
                <div className="w-9 h-9 rounded-xl bg-white/10 flex items-center justify-center">
                  <Users className="h-5 w-5 text-white" />
                </div>
                <div>
                  <h2 className="text-lg font-bold text-white">{selectedDepartment.department_name}</h2>
                  <p className="text-xs text-indigo-300">Department Staff</p>
                </div>
              </div>
              <Button variant="ghost" size="sm" className="text-white/70 hover:text-white hover:bg-white/10 rounded-full" onClick={() => {
                setShowStaffModal(false);
                setSelectedDepartment(null);
                setSelectedStaff(new Set());
                setStaffModalTab('contact');
              }}>
                <X className="h-4 w-4" />
              </Button>
            </div>

            {/* Tab bar — always show Staff & Contact; Manage only for admins */}
            <div className="flex border-b border-gray-100 px-6 bg-white flex-shrink-0">
              <button
                onClick={() => setStaffModalTab('contact')}
                className={`px-4 py-2.5 text-sm font-semibold border-b-2 transition-colors ${staffModalTab === 'contact'
                    ? 'border-indigo-600 text-indigo-700'
                    : 'border-transparent text-gray-500 hover:text-gray-700'
                  }`}
              >
                Staff &amp; Contact
              </button>
              {isAdmin && (
                <button
                  onClick={() => setStaffModalTab('manage')}
                  className={`px-4 py-2.5 text-sm font-semibold border-b-2 transition-colors ${staffModalTab === 'manage'
                      ? 'border-indigo-600 text-indigo-700'
                      : 'border-transparent text-gray-500 hover:text-gray-700'
                    }`}
                >
                  Manage Members
                </button>
              )}
            </div>
            <div className="flex-1 overflow-y-auto">
              <div className="p-6">
                {/* ── Manage Members tab (admin only) ── */}
                {isAdmin && staffModalTab === 'manage' ? (
                  <EmployeesPanel
                    department={selectedDepartment}
                    onClose={() => {
                      setShowStaffModal(false);
                      setSelectedDepartment(null);
                      setSelectedStaff(new Set());
                    }}
                    setSelectedDepartment={setSelectedDepartment}
                    setDepartments={setLocationDepartments}
                  />
                ) : (
                  /* ── Staff & Contact tab (all users) ── */
                  <div>
                    {(() => {
                      const leaders = (selectedDepartment.leaders || []).map(l => {
                        const leaderObj = typeof l === 'string' ? { id: l } : l;
                        return { ...leaderObj, is_leader: true };
                      });
                      const members = (selectedDepartment.members || []).map(m => ({
                        ...m,
                        is_leader: m.is_leader || false,
                      }));

                      const appUsersMap = new Map();
                      appUsers.forEach(u => {
                        if (u.id) appUsersMap.set(u.id, u);
                      });

                      const combinedMap = new Map();
                      leaders.forEach(l => {
                        const key = l.id || l.email || l.user_account || l.userName;
                        if (key) combinedMap.set(key, l);
                      });
                      members.forEach(m => {
                        const key = m.id || m.email || m.user_account || m.userName;
                        if (key && !combinedMap.has(key)) combinedMap.set(key, m);
                      });

                      const staffList = Array.from(combinedMap.values())
                        .map(member => {
                          if (!(member.full_name || member.fullName || member.name || member.userName || member.username)) {
                            const resolvedUser = appUsersMap.get(member.id);
                            if (resolvedUser) {
                              return {
                                ...member,
                                name: resolvedUser.name || member.name,
                                fullName: resolvedUser.fullName || resolvedUser.full_name || member.fullName,
                                position: resolvedUser.position || member.position,
                                contact: resolvedUser.contact || resolvedUser.phone_number || member.contact,
                                email: resolvedUser.email || member.email,
                              };
                            }
                          }
                          return member;
                        })
                        .sort((a, b) => {
                          if (a.is_leader && !b.is_leader) return -1;
                          if (!a.is_leader && b.is_leader) return 1;
                          return 0;
                        });

                      if (staffList.length === 0) {
                        return (
                          <div className="text-center py-12 text-gray-400">
                            <Users className="h-14 w-14 mx-auto mb-3 text-gray-300" />
                            <p className="font-medium">No staff members assigned to this department</p>
                          </div>
                        );
                      }

                      const myId = currentUser?.id || currentUser?._id;

                      const toggleSelect = (key) => {
                        setSelectedStaff(prev => {
                          const next = new Set(prev);
                          if (next.has(key)) next.delete(key); else next.add(key);
                          return next;
                        });
                      };

                      const handleStaffCall = async (memberId, memberName, mode) => {
                        if (!myId || !memberId || String(memberId) === String(myId)) return;
                        try {
                          const res = await axios.post(`${ApiEndPoint}/api/calls/create`, {
                            callType: mode,
                            invitedUsers: [memberId],
                            incidentId: id
                          }, { headers: { Authorization: `Bearer ${localStorage.getItem('access_token')}` } });
                          const data = res.data?.data || res.data;
                          const roomName = data?.roomName || data?.room_name;
                          const callId = data?.id || data?._id;
                          if (roomName) {
                            setShowStaffModal(false);
                            setSelectedDepartment(null);
                            setSelectedStaff(new Set());
                            navigate(`/meets?meeting_id=${roomName}&meetMode=${mode}&incidentId=${id}&callId=${callId}`);
                          }
                        } catch (e) { console.error('Staff call error', e); }
                      };

                      const handleGroupAction = async (mode) => {
                        const ids = Array.from(selectedStaff).filter(sid => String(sid) !== String(myId));
                        if (ids.length === 0) return;
                        if (mode === 'chat') {
                          // Resolve display names for the selected users
                          const selectedUsers = ids.map(sid => {
                            const m = staffList.find(x => (x.id || x.email || x.user_account) === sid);
                            const name = m ? (m.full_name || m.fullName || m.name || m.userName || m.username || m.email || 'Member') : 'Member';
                            return { id: sid, name };
                          });
                          setShowStaffModal(false);
                          setSelectedDepartment(null);
                          setSelectedStaff(new Set());
                          setStaffModalTab('contact');
                          navigate(chatWorkspaceUrl, {
                            state: { groupChatUsers: selectedUsers }
                          });
                          return;
                        }
                        try {
                          const res = await axios.post(`${ApiEndPoint}/api/calls/create`, {
                            callType: mode,
                            invitedUsers: ids,
                            incidentId: id
                          }, { headers: { Authorization: `Bearer ${localStorage.getItem('access_token')}` } });
                          const data = res.data?.data || res.data;
                          const roomName = data?.roomName || data?.room_name;
                          const callId = data?.id || data?._id;
                          if (roomName) {
                            setShowStaffModal(false);
                            setSelectedDepartment(null);
                            setSelectedStaff(new Set());
                            navigate(`/meets?meeting_id=${roomName}&meetMode=${mode}&incidentId=${id}&callId=${callId}`);
                          }
                        } catch (e) { console.error('Group call error', e); }
                      };

                      return (
                        <div className="space-y-4">
                          {/* Summary row */}
                          <div className="flex items-center justify-between px-1">
                            <p className="text-sm font-medium text-gray-500">
                              {staffList.length} staff member{staffList.length !== 1 ? 's' : ''}
                              {selectedStaff.size > 0 && (
                                <span className="ml-2 px-2 py-0.5 rounded-full bg-indigo-100 text-indigo-700 text-xs font-bold">
                                  {selectedStaff.size} selected
                                </span>
                              )}
                            </p>
                            {selectedStaff.size > 0 && (
                              <button
                                onClick={() => setSelectedStaff(new Set())}
                                className="text-xs text-gray-400 hover:text-red-500 transition-colors font-medium"
                              >
                                Clear selection
                              </button>
                            )}
                          </div>

                          {/* Group action toolbar — appears when ≥1 selected */}
                          {selectedStaff.size >= 1 && (
                            <div className="flex flex-wrap items-center gap-2 p-3 bg-indigo-50 border border-indigo-100 rounded-xl">
                              <span className="text-xs font-bold text-indigo-700 mr-1">
                                {selectedStaff.size >= 2 ? 'Group Actions:' : 'Actions:'}
                              </span>
                              {selectedStaff.size === 1 ? (
                                <button
                                  onClick={() => {
                                    const memberId = Array.from(selectedStaff)[0];
                                    const m = staffList.find(x => (x.id || x.email || x.user_account) === memberId);
                                    if (m) {
                                      setStaffDmTarget({ id: memberId, name: m.full_name || m.fullName || m.name || m.userName || m.username || m.email || 'Staff Member' });
                                    }
                                  }}
                                  className="flex items-center gap-1.5 px-3 py-1.5 bg-white border border-indigo-200 text-indigo-700 text-xs font-semibold rounded-lg hover:bg-indigo-600 hover:text-white hover:border-indigo-600 transition-all shadow-sm"
                                >
                                  <MessageSquare size={13} /> Chat
                                </button>
                              ) : (
                                <button
                                  onClick={() => handleGroupAction('chat')}
                                  className="flex items-center gap-1.5 px-3 py-1.5 bg-white border border-indigo-200 text-indigo-700 text-xs font-semibold rounded-lg hover:bg-indigo-600 hover:text-white hover:border-indigo-600 transition-all shadow-sm"
                                >
                                  <MessageSquare size={13} /> Group Chat
                                </button>
                              )}
                              <button
                                onClick={() => {
                                  if (selectedStaff.size === 1) {
                                    const mid = Array.from(selectedStaff)[0];
                                    const m = staffList.find(x => (x.id || x.email || x.user_account) === mid);
                                    if (m) handleStaffCall(mid, m.full_name || m.name || 'Member', 'voice');
                                  } else {
                                    handleGroupAction('voice');
                                  }
                                }}
                                className="flex items-center gap-1.5 px-3 py-1.5 bg-white border border-emerald-200 text-emerald-700 text-xs font-semibold rounded-lg hover:bg-emerald-600 hover:text-white hover:border-emerald-600 transition-all shadow-sm"
                              >
                                <Phone size={13} /> {selectedStaff.size >= 2 ? 'Group Voice' : 'Voice Call'}
                              </button>
                              <button
                                onClick={() => {
                                  if (selectedStaff.size === 1) {
                                    const mid = Array.from(selectedStaff)[0];
                                    const m = staffList.find(x => (x.id || x.email || x.user_account) === mid);
                                    if (m) handleStaffCall(mid, m.full_name || m.name || 'Member', 'video');
                                  } else {
                                    handleGroupAction('video');
                                  }
                                }}
                                className="flex items-center gap-1.5 px-3 py-1.5 bg-white border border-violet-200 text-violet-700 text-xs font-semibold rounded-lg hover:bg-violet-600 hover:text-white hover:border-violet-600 transition-all shadow-sm"
                              >
                                <Video size={13} /> {selectedStaff.size >= 2 ? 'Group Video' : 'Video Call'}
                              </button>
                            </div>
                          )}

                          {/* Staff list */}
                          <div className="space-y-2">
                            {staffList.map((member, index) => {
                              const memberKey = member.id || member.email || member.user_account || member.userName || String(index);
                              const isMe = myId && String(memberKey) === String(myId);
                              const isSelected = selectedStaff.has(memberKey);
                              const displayName = member.full_name || member.fullName || member.name || member.userName || member.username || member.email || member.user_account || 'Staff Member';
                              const initial = (displayName[0] || 'S').toUpperCase();

                              return (
                                <div
                                  key={index}
                                  className={`flex items-center gap-3 p-4 border rounded-xl transition-all duration-200 group cursor-pointer ${isSelected
                                      ? 'border-indigo-300 bg-indigo-50/60 shadow-sm'
                                      : 'border-gray-100 hover:border-gray-200 hover:bg-gray-50/80'
                                    }`}
                                  onClick={() => !isMe && toggleSelect(memberKey)}
                                >
                                  {/* Checkbox */}
                                  {!isMe && (
                                    <div className={`w-5 h-5 rounded-full border-2 flex items-center justify-center flex-shrink-0 transition-all ${isSelected ? 'border-indigo-600 bg-indigo-600' : 'border-gray-300 group-hover:border-indigo-400'
                                      }`}>
                                      {isSelected && <Check className="h-3 w-3 text-white" />}
                                    </div>
                                  )}

                                  {/* Avatar */}
                                  <div className={`w-10 h-10 rounded-full flex items-center justify-center font-bold text-sm flex-shrink-0 ${member.is_leader ? 'bg-purple-100 text-purple-700' : 'bg-blue-100 text-blue-700'
                                    }`}>
                                    {initial}
                                  </div>

                                  {/* Info */}
                                  <div className="flex-1 min-w-0">
                                    <div className="flex items-center gap-2 flex-wrap">
                                      <span className="font-semibold text-gray-900 text-sm">{displayName}</span>
                                      {isMe && <span className="text-[10px] text-gray-400 font-medium">(You)</span>}
                                      {member.is_leader && (
                                        <span className="inline-flex items-center px-1.5 py-0.5 rounded-md text-[10px] font-bold bg-purple-100 text-purple-700">
                                          Leader
                                        </span>
                                      )}
                                      {member.role && (
                                        <span className="inline-flex items-center px-1.5 py-0.5 rounded-md text-[10px] font-bold bg-blue-100 text-blue-700">
                                          {member.role}
                                        </span>
                                      )}
                                    </div>
                                    <div className="flex flex-wrap gap-x-4 gap-y-0.5 mt-1">
                                      {member.position && (
                                        <span className="text-[11px] text-gray-500">{member.position}</span>
                                      )}
                                      {(member.contact || member.phone_number) && (
                                        <span className="text-[11px] text-gray-400 flex items-center gap-1">
                                          <Phone size={9} /> {member.contact || member.phone_number}
                                        </span>
                                      )}
                                      {member.email && (
                                        <span className="text-[11px] text-gray-400 truncate max-w-[180px]">{member.email}</span>
                                      )}
                                    </div>
                                  </div>

                                  {/* Per-member action buttons */}
                                  {!isMe && (
                                    <div
                                      className="flex items-center gap-1.5 opacity-0 group-hover:opacity-100 transition-all duration-200 flex-shrink-0"
                                      onClick={e => e.stopPropagation()}
                                    >
                                      <button
                                        title="Chat"
                                        onClick={() => {
                                          setStaffDmTarget({ id: memberKey, name: displayName });
                                        }}
                                        className="w-8 h-8 flex items-center justify-center rounded-full bg-white border border-indigo-100 text-indigo-600 hover:bg-indigo-600 hover:text-white hover:border-indigo-600 transition-all shadow-sm"
                                      >
                                        <MessageSquare size={14} />
                                      </button>
                                      <button
                                        title="Voice Call"
                                        onClick={() => handleStaffCall(memberKey, displayName, 'voice')}
                                        className="w-8 h-8 flex items-center justify-center rounded-full bg-white border border-emerald-100 text-emerald-600 hover:bg-emerald-600 hover:text-white hover:border-emerald-600 transition-all shadow-sm"
                                      >
                                        <Phone size={14} />
                                      </button>
                                      <button
                                        title="Video Call"
                                        onClick={() => handleStaffCall(memberKey, displayName, 'video')}
                                        className="w-8 h-8 flex items-center justify-center rounded-full bg-white border border-violet-100 text-violet-600 hover:bg-violet-600 hover:text-white hover:border-violet-600 transition-all shadow-sm"
                                      >
                                        <Video size={14} />
                                      </button>
                                    </div>
                                  )}
                                </div>
                              );
                            })}
                          </div>
                        </div>
                      );
                    })()}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Staff DM Modal — launched from Staff Modal member buttons */}
      {staffDmTarget && currentUser && (
        <PrivateChatModal
          isOpen={!!staffDmTarget}
          onClose={() => setStaffDmTarget(null)}
          currentUser={currentUser}
          targetUser={staffDmTarget}
          incidentId={id}
          displayIncidentId={incident ? `INC-${(incident.id || id).split('-').pop().substring(0, 8).toUpperCase()}` : id}
          incidentTitle={incident?.title || incident?.incident_type || ''}
        />
      )}

      {/* Add Widget Modal */}
      {showAddWidgetModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50" onClick={() => setShowAddWidgetModal(false)}>
          <div className="bg-white rounded-lg shadow-xl max-w-3xl w-full m-4 max-h-[90vh] overflow-y-auto" onClick={(e) => e.stopPropagation()}>
            <div className="p-6 border-b border-gray-200 flex items-center justify-between sticky top-0 bg-white z-10">
              <div>
                <h2 className="text-xl font-semibold">Manage Widgets</h2>
                <p className="text-sm text-gray-500 mt-1">Add or remove widgets from the incident detail page</p>
              </div>
              <Button variant="ghost" size="sm" onClick={() => setShowAddWidgetModal(false)}>
                <X className="h-4 w-4" />
              </Button>
            </div>
            <div className="p-6">
              {/* Group widgets by category */}
              {['Metrics', 'Core', 'Additional', ...(incident?.is_exercise ? ['Exercise'] : ['Scenario'])].map(category => {
                const categoryWidgets = availableWidgets.filter(w => w.category === category);
                if (categoryWidgets.length === 0) return null;

                return (
                  <div key={category} className="mb-6 last:mb-0">
                    <h3 className="text-sm font-semibold text-gray-700 mb-3 uppercase tracking-wide">{category}</h3>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                      {categoryWidgets.map((widget) => (
                        <div
                          key={widget.id}
                          onClick={() => toggleWidget(widget.id)}
                          className={`p-4 border-2 rounded-lg cursor-pointer transition-all ${visibleWidgets[widget.id]
                            ? 'border-green-500 bg-green-50'
                            : 'border-gray-300 hover:border-blue-500 hover:bg-blue-50'
                            }`}
                        >
                          <div className="flex items-center gap-3">
                            <span className="text-2xl">{widget.icon}</span>
                            <div className="flex-1">
                              <h3 className="font-semibold text-gray-900 text-sm">{widget.name}</h3>
                              <p className="text-xs text-gray-500 mt-0.5">
                                {visibleWidgets[widget.id] ? '✓ Active' : 'Click to add'}
                              </p>
                            </div>
                            {visibleWidgets[widget.id] && (
                              <div className="w-5 h-5 rounded-full bg-green-500 flex items-center justify-center">
                                <CheckCircle className="h-3 w-3 text-white" />
                              </div>
                            )}
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                );
              })}
            </div>
            <div className="p-4 bg-gray-50 border-t border-gray-200 flex justify-between items-center sticky bottom-0">
              <p className="text-sm text-gray-600">
                {availableWidgets.filter(w => visibleWidgets[w.id]).length} of {availableWidgets.length} widgets active
              </p>
              <Button onClick={() => setShowAddWidgetModal(false)}>
                Done
              </Button>
            </div>
          </div>
        </div>
      )}

      {/* Full Timeline Modal */}
      {showFullTimeline && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg shadow-xl max-w-4xl w-full max-h-[90vh] overflow-y-auto m-4">
            <div className="p-6 border-b border-gray-200 flex items-center justify-between">
              <h2 className="text-xl font-semibold">Full Timeline</h2>
              <Button variant="ghost" size="sm" onClick={() => setShowFullTimeline(false)}>
                <X className="h-4 w-4" />
              </Button>
            </div>
            <div className="p-6">
              <div className="space-y-6">
                {/* Status Update Section */}
                <div>
                  <h3 className="text-lg font-bold text-gray-900 mb-4 flex items-center">
                    <div className="w-3 h-3 bg-orange-500 rounded-full mr-3"></div>
                    Status Update
                  </h3>
                  <div className="ml-6 space-y-3 text-sm">
                    <div><strong>01:03</strong> <span className="bg-orange-100 text-orange-800 px-2 py-1 rounded-full text-xs font-medium">CONFIRMED</span> by <strong>Maintenance Supervisor</strong></div>
                    <div><strong>01:05</strong> Priority escalated to <span className="text-red-600 font-semibold">CRITICAL</span></div>
                  </div>
                </div>

                {/* Response Actions Section */}
                <div>
                  <h3 className="text-lg font-bold text-gray-900 mb-4 flex items-center">
                    <div className="w-3 h-3 bg-blue-500 rounded-full mr-3"></div>
                    Response Actions
                  </h3>
                  <div className="ml-6 space-y-3 text-sm">
                    <div className="border-l-2 border-blue-500 pl-4">
                      <div><strong>01:02</strong> <span className="underline text-xs">MAINTENANCE TEAM ALPHA</span></div>
                      <div className="text-gray-600">• Dispatched to OR Block, Level 2</div>
                      <div className="text-gray-600">• ETA: 3 minutes</div>
                    </div>
                    <div className="border-l-2 border-green-500 pl-4">
                      <div><strong>01:04</strong> <span className="underline text-xs">BACKUP SYSTEMS</span></div>
                      <div className="text-gray-600">• Emergency oxygen supply activated</div>
                      <div className="text-gray-600">• Backup pressure tanks online</div>
                    </div>
                    <div className="text-xs text-gray-500 mt-2">
                      <strong>Time Taken to Perform Actions:</strong> 16 min
                    </div>
                  </div>
                </div>

                {/* Resolution Section */}
                <div>
                  <h3 className="text-lg font-bold text-gray-900 mb-4 flex items-center">
                    <div className="w-3 h-3 bg-green-500 rounded-full mr-3"></div>
                    Resolution & Final Update
                  </h3>
                  <div className="ml-6 space-y-3 text-sm">
                    <div><strong>01:18</strong> Primary gas line pressure restored</div>
                    <div><strong>01:20</strong> System tests completed successfully</div>
                    <div><strong>01:22</strong> Incident marked as <span className="bg-green-100 text-green-800 px-2 py-1 rounded-full text-xs font-medium">RESOLVED</span></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {/* Add Timeline Entry Modal */}
      {showTimelineModal && !isIncidentReadOnly && (
        <TimelineEntryModal
          incident={incident}
          isAdmin={isContextAdmin}
          activeGroup={activeGroup}
          editItem={editingItem}
          onClose={() => {
            setShowTimelineModal(false);
            setActiveGroup(null);
            setEditingItem(null);
          }}
          onSuccess={async () => {
            setShowTimelineModal(false);
            setActiveGroup(null);
            setEditingItem(null);

            // Refresh incident data to get updated location
            try {
              const response = await CommanServices.getIncidentDetail(id);
              if (response.status) {
                const updatedIncident = await response.data;
                setIncident(updatedIncident);
              }
            } catch (error) {
              console.error('Failed to refresh incident:', error);
            }

            // Also refresh timeline data
            fetchTimelineData();
            // Notify the IncidentTimeline component (own state) to refetch so the
            // edited Report & Detection card updates without a hard refresh.
            window.dispatchEvent(new Event('timelineRefresh'));
          }}
        />
      )}

      {/* Acknowledgment Modal */}
      {showAcknowledgmentModal && !isIncidentReadOnly && (
        <AcknowledgmentModal
          incident={incident}
          onlineUserIds={onlineParticipantIds}
          presenceByUserId={mobilePresenceByUser}
          allowedRecipientUserIds={scopedRecipientScope?.userIds ?? null}
          allowedRecipientDepartmentIds={scopedRecipientScope?.departmentIds ?? null}
          allowedRecipientTeamIds={scopedRecipientScope?.teamIds ?? null}
          allowedRecipientCrewIds={scopedRecipientScope?.crewIds ?? null}
          scenarioStaffingDefaults={scenarioMode ? scenarioStaffingDefaults : null}
          onRoleCatalogUpsert={scenarioMode ? upsertScenarioRequiredRole : null}
          editingItem={editingAcknowledgment}
          mode={acknowledgmentMode}
          userRoleMap={userRoleMap}
          conditionalContext={conditionalContext}
          onAddConditional={handleAddConditionalFromModal}
          prefilledSelections={ackPrefilledSelections}
          geoFenceTargeting={ackGeoFenceTargeting}
          onClose={() => {
            setShowAcknowledgmentModal(false);
            setEditingAcknowledgment(null);
            setAcknowledgmentMode('config');
            setConditionalContext(null);
            setAckPrefilledSelections(null);
            setAckGeoFenceTargeting(null);
          }}
          onSuccess={() => {
            fetchTimelineData();
            fetchIncidentDetail(); // Refresh incident detail to update status in header
            // Trigger timeline refresh event for IncidentTimeline component
            announceIncidentTimelineChange(
              incident.id,
              ackGeoFenceTargeting ? 'geo_fence_verification_created' : 'timeline_card_changed'
            );
            setEditingAcknowledgment(null);
            setAcknowledgmentMode('config');
          }}
        />
      )}

      {/* Response Action Modal */}
      {showResponseActionModal && !isIncidentReadOnly && (
        <ResponseActionModal
          incident={incident}
          onlineUserIds={onlineParticipantIds}
          presenceByUserId={mobilePresenceByUser}
          allowedRecipientUserIds={scopedRecipientScope?.userIds ?? null}
          allowedRecipientDepartmentIds={scopedRecipientScope?.departmentIds ?? null}
          allowedRecipientTeamIds={scopedRecipientScope?.teamIds ?? null}
          allowedRecipientCrewIds={scopedRecipientScope?.crewIds ?? null}
          scenarioStaffingDefaults={scenarioMode ? scenarioStaffingDefaults : null}
          onRoleCatalogUpsert={scenarioMode ? upsertScenarioRequiredRole : null}
          editingItem={editingResponseAction}
          prefilledName={responseActionPrefills.prefilledName}
          prefilledUserIds={responseActionPrefills.prefilledUserIds}
          prefilledSelections={responsePrefilledSelections}
          geoFenceTargeting={responseGeoFenceTargeting}
          isImmediateTask={responseActionPrefills.isImmediateTask}
          conditionalContext={conditionalContext}
          onAddConditional={handleAddConditionalFromModal}
          onClose={() => {
            setShowResponseActionModal(false);
            setEditingResponseAction(null);
            setConditionalContext(null);
            setResponsePrefilledSelections(null);
            setResponseGeoFenceTargeting(null);
            setResponseActionPrefills({
              prefilledName: '',
              prefilledUserIds: [],
              isImmediateTask: false,
            });
          }}
          onSuccess={() => {
            fetchTimelineData();
            fetchIncidentDetail(true); // Freshly fetch incident to update virtual cards status
            // Trigger timeline refresh event for IncidentTimeline component
            announceIncidentTimelineChange(
              incident.id,
              responseGeoFenceTargeting ? 'geo_fence_action_card_created' : 'timeline_card_changed'
            );
            setEditingResponseAction(null);
            setResponseActionPrefills({
              prefilledName: '',
              prefilledUserIds: [],
              isImmediateTask: false,
            });
          }}
        />
      )}

      {/* Action Cards History Modal */}
      {showHistoryModal && historyResponder && (() => {
        const historyCards = timelineItems.filter(item => {
          const isActionGroup = item.group === 'response_action' || item.group === 'acknowledgment' || item.group === 'pre_incident_action';
          if (!isActionGroup) return false;

          const assignedIds = item.meta?.assignedUserIds || [];
          const assignedUsers = item.meta?.assignees || [];

          const matchesAssignedId = assignedIds.includes(historyResponder.userId);
          const matchesAssignee = assignedUsers.some(u => u.userId === historyResponder.userId);
          const matchesActor = item.actor?.id === historyResponder.userId;
          const matchesRecipient = item.meta?.recipientIds?.includes(historyResponder.userId);
          const matchesAcknowledgedBy = item.meta?.acknowledgedBy?.userId === historyResponder.userId;
          // Planned (scenario) cards staff people via meta.roleAssignments
          const matchesRoleAssignment = Object.values(item.meta?.roleAssignments || {}).some(
            (list) => (Array.isArray(list) ? list : []).some((a) => String(a?.id) === String(historyResponder.userId))
          );
          // Crew rows carry their member ids — match a card if ANY member is on it
          const memberIds = (historyResponder.memberIds || []).map(String);
          const matchesCrewMember = memberIds.length > 0 && (
            assignedIds.some((id) => memberIds.includes(String(id))) ||
            assignedUsers.some((u) => memberIds.includes(String(u.userId))) ||
            memberIds.includes(String(item.meta?.acknowledgedBy?.userId)) ||
            Object.values(item.meta?.roleAssignments || {}).some((list) => (Array.isArray(list) ? list : []).some((a) => memberIds.includes(String(a?.id))))
          );

          return matchesAssignedId || matchesAssignee || matchesActor || matchesRecipient || matchesAcknowledgedBy || matchesRoleAssignment || matchesCrewMember;
        });

        return (
          <div className="fixed inset-0 bg-black/60 backdrop-blur-sm z-50 flex items-center justify-center p-4">
            <div className="bg-white rounded-2xl shadow-2xl max-w-2xl w-full max-h-[85vh] overflow-hidden flex flex-col border border-slate-100">
              {/* Header */}
              <div className="flex justify-between items-center p-6 border-b border-slate-100 bg-gradient-to-r from-slate-50 to-blue-50/30">
                <div>
                  <h2 className="text-lg font-bold text-slate-800">Action Cards History</h2>
                  <p className="text-xs text-slate-500 mt-1">
                    Responder: <span className="font-semibold text-slate-700">{historyResponder.userName || historyResponder.email}</span>
                  </p>
                </div>
                <button
                  onClick={() => {
                    setShowHistoryModal(false);
                    setHistoryResponder(null);
                  }}
                  className="p-1.5 rounded-lg text-slate-400 hover:text-slate-600 hover:bg-slate-100 transition-colors"
                >
                  <X className="h-5 w-5" />
                </button>
              </div>

              {/* Body */}
              <div className="flex-1 overflow-y-auto p-6 space-y-4 bg-slate-50/50">
                {historyCards.length === 0 ? (
                  <div className="text-center py-12 text-slate-400">
                    <ClipboardList className="h-12 w-12 mx-auto mb-3 opacity-30 text-slate-500" />
                    <p className="text-sm font-medium">No action cards found for this responder</p>
                    <p className="text-xs mt-1">Immediate and manual tasks will show up here once created.</p>
                  </div>
                ) : (
                  historyCards.map((card, idx) => {
                    const meta = card.meta || {};
                    const isImmediate = meta.actionCardName === 'Immediate action card';
                    const isManual = meta.manuallyCreated || meta.createdBy;

                    let cardTypeLabel = 'Pre-configured';
                    let cardTypeClass = 'bg-slate-100 text-slate-700 border-slate-200';
                    if (isImmediate) {
                      cardTypeLabel = 'Immediate Task';
                      cardTypeClass = 'bg-rose-50 text-rose-700 border-rose-100';
                    } else if (isManual) {
                      cardTypeLabel = 'Manual Card';
                      cardTypeClass = 'bg-blue-50 text-blue-700 border-blue-100';
                    }

                    const tasks = meta.tasks || [];
                    const completedCount = tasks.filter(t => t.isCompleted).length;
                    const totalCount = tasks.length;

                    const notifiedAt = meta.notifiedAt || card.timestamp || card.created_at;
                    const dateStr = notifiedAt ? new Date(notifiedAt).toLocaleDateString() : '';
                    const timeStr = notifiedAt ? new Date(notifiedAt).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }) : '';

                    return (
                      <div key={card.id || idx} className="bg-white rounded-xl border border-slate-150 p-4 shadow-sm hover:shadow-md transition-shadow">
                        <div className="flex items-start justify-between gap-3 mb-2 flex-wrap">
                          <div>
                            <span className={`inline-flex items-center px-2 py-0.5 rounded text-[10px] font-bold border ${cardTypeClass} mr-2`}>
                              {cardTypeLabel}
                            </span>
                            <span className="text-sm font-bold text-slate-800">
                              {meta.actionCardName || card.title || 'Action Card'}
                            </span>
                          </div>
                          <div className="text-[11px] text-slate-400">
                            {dateStr} • {timeStr}
                          </div>
                        </div>

                        {/* Assignee / Created by detail */}
                        {meta.createdBy?.userName && (
                          <div className="text-[11px] text-slate-500 mb-2">
                            Assigned by: <span className="font-medium">{meta.createdBy.userName}</span>
                          </div>
                        )}

                        {/* Tasks Checklist */}
                        {tasks.length > 0 ? (
                          <div className="mt-3 bg-slate-50 rounded-lg p-3 space-y-2 border border-slate-100">
                            <div className="text-xs font-semibold text-slate-500 flex justify-between">
                              <span>Tasks ({completedCount}/{totalCount})</span>
                              {totalCount > 0 && (
                                <span>{Math.round((completedCount / totalCount) * 100)}%</span>
                              )}
                            </div>
                            <div className="space-y-1.5 pt-1">
                              {tasks.map((task, sIdx) => {
                                const isCompleted = task.isCompleted;
                                const isFailed = task.failedSLA;
                                return (
                                  <div key={task.taskId || sIdx} className="flex items-start gap-2 text-xs">
                                    {isCompleted ? (
                                      <span className="text-green-600 font-bold mt-0.5">✓</span>
                                    ) : isFailed ? (
                                      <span className="text-red-500 font-bold mt-0.5">✗</span>
                                    ) : (
                                      <span className="text-slate-300 font-bold mt-0.5">○</span>
                                    )}
                                    <div className="flex-1">
                                      <span className={`
                                        ${isCompleted ? 'line-through text-slate-400 font-normal' : 'text-slate-700 font-medium'}
                                        ${isFailed ? 'line-through text-slate-400' : ''}
                                      `}>
                                        {task.taskText}
                                      </span>
                                      {task.timerMinutes && !isCompleted && !isFailed && (
                                        <span className="text-[10px] text-amber-600 font-medium ml-1.5 bg-amber-50 px-1 py-0.2 rounded border border-amber-100/50">
                                          ⏱️ {task.timerMinutes}m
                                        </span>
                                      )}
                                      {isFailed && (
                                        <span className="text-[10px] text-red-500 font-semibold ml-1.5">
                                          (Expired)
                                        </span>
                                      )}
                                    </div>
                                  </div>
                                );
                              })}
                            </div>
                          </div>
                        ) : (
                          <div className="text-xs text-slate-400 italic mt-2">
                            No checklist tasks assigned.
                          </div>
                        )}
                      </div>
                    );
                  })
                )}
              </div>

              {/* Footer */}
              <div className="p-4 border-t border-slate-100 bg-slate-50 flex justify-end">
                <Button
                  onClick={() => {
                    setShowHistoryModal(false);
                    setHistoryResponder(null);
                  }}
                  variant="default"
                  size="sm"
                  className="px-5 bg-slate-800 text-white hover:bg-slate-900 rounded-lg text-xs h-9 font-semibold shadow-sm"
                >
                  Close
                </Button>
              </div>
            </div>
          </div>
        );
      })()}

      {/* Status Update Modal */}
      {showStatusUpdateModal && !isIncidentReadOnly && (
        <StatusUpdateModal
          incident={incident}
          isAdmin={isContextAdmin}
          scenarioStaffingDefaults={scenarioMode ? scenarioStaffingDefaults : null}
          onRoleCatalogUpsert={scenarioMode ? upsertScenarioRequiredRole : null}
          editingItem={editingStatusUpdate}
          groupKey={statusUpdateGroup}
          userRoleMap={userRoleMap}
          conditionalContext={conditionalContext}
          onAddConditional={handleAddConditionalFromModal}
          geoFenceTargeting={statusGeoFenceTargeting}
          onClose={() => {
            setShowStatusUpdateModal(false);
            setEditingStatusUpdate(null);
            setStatusUpdateGroup('status_update'); // Reset to default
            setConditionalContext(null);
            setStatusGeoFenceTargeting(null);
          }}
          onSuccess={() => {
            fetchTimelineData();
            if (statusGeoFenceTargeting?.userIds?.length) {
              const count = statusGeoFenceTargeting.userIds.length;
              toast.success(`Status update created for ${count} geo-fenced user${count === 1 ? '' : 's'}`);
            }
            // Trigger timeline refresh event for IncidentTimeline component
            announceIncidentTimelineChange(
              incident.id,
              statusGeoFenceTargeting ? 'geo_fence_status_update_created' : 'timeline_card_changed'
            );
            // Trigger dashboard refresh event for family tree and incidents list
            window.dispatchEvent(new Event('dashboardRefresh'));
            // Set flag to indicate dashboard needs refresh when user returns
            localStorage.setItem('dashboardNeedsRefresh', 'true');
            console.log('🔔 Set dashboardNeedsRefresh flag - new related incident created');
            setEditingStatusUpdate(null);
            setStatusUpdateGroup('status_update'); // Reset to default
          }}
        />
      )}

      {/* Resolution Modal */}
      {canResolveIncident && showResolutionModal && (!isIncidentReadOnly || isCompletedStage) && (
        <ResolutionModal
          incident={incident}
          editingItem={editingResolution}
          onClose={() => {
            setShowResolutionModal(false);
            setEditingResolution(null);
          }}
          onSuccess={() => {
            fetchTimelineData();
            fetchIncidentDetail(); // Refresh incident data to update status chip
            // Trigger timeline refresh event for IncidentTimeline component
            window.dispatchEvent(new Event('timelineRefresh'));
            setEditingResolution(null);
          }}
        />
      )}

      {isAdmin && showExtensiveModal && (
        <ExtensiveAnalysisModal
          onClose={() => setShowExtensiveModal(false)}
          title={`Extensive Analysis — ${incident?.id || ''}`}
          incidentId={incident?.id}
          reviewKind={(incident?.is_exercise === true || incident?.is_scenario === true) ? 'aar' : 'pir'}
          initialReport={extensiveReport}
          onReportChange={(md) => setExtensiveReport(md)}
          defaultObjective={(incident?.is_exercise === true || incident?.is_scenario === true)
            ? "Evaluate this exercise's end-to-end performance and produce a full, decision-ready After-Action Review."
            : "Evaluate this real incident's end-to-end response and produce a full, decision-ready Post-Incident Review."}
          defaultMaterial={[
            `# ${incident?.title || incident?.incident_type || ((incident?.is_exercise === true || incident?.is_scenario === true) ? 'Exercise' : 'Incident')}`,
            `**${(incident?.is_exercise === true || incident?.is_scenario === true) ? 'Exercise' : 'Incident'} ID:** ${incident?.id || ''} · ${incident?.incident_type || ''} · Status: ${incident?.status || ''}`,
          ].join('\n')}
        />
      )}

      {isContextAdmin && incidentCopilotEligible && showIncidentCopilot && incident && (
        <IncidentCopilotPanel
          incident={incident}
          onClose={() => setShowIncidentCopilot(false)}
        />
      )}

      {/* Requested-stage activation confirmation */}
      {activateChoice && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-[1000] p-4" data-testid="activate-choice-modal">
          <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full overflow-hidden">
            <div className="p-5 border-b border-gray-100">
              <h2 className="text-base font-bold text-gray-900">Activate the exercise?</h2>
              <p className="text-[12px] text-gray-500 mt-1">Start the live drill now. Its planned window remains available in the exercise plan.</p>
            </div>
            <div className="p-5 flex flex-col gap-2">
              <Button
                data-testid="activate-now-btn"
                className="w-full bg-emerald-600 hover:bg-emerald-500 text-white font-bold"
                onClick={proceedActivateNow}
              >
                Activate now
              </Button>
              <button
                className="w-full text-[12px] text-gray-400 hover:text-gray-600 py-1"
                onClick={() => setActivateChoice(false)}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}

      {activatePrompt && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-[1000] p-4" data-testid="activate-scenario-prompt">
          <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full overflow-hidden">
            <div className="p-5 border-b border-gray-100 flex items-center gap-3">
              <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-amber-100 text-amber-600"><Save className="w-5 h-5" /></span>
              <div>
                <h2 className="text-base font-bold text-gray-900">Save changes as a new scenario?</h2>
                <p className="text-[12px] text-gray-500">This exercise was built from a saved scenario.</p>
              </div>
            </div>
            <div className="p-5 text-sm text-gray-600">
              If you modified the cards, location info, resources, objectives or injects, you can save this version as a <b>new scenario</b> in the library before activating. Otherwise, activate the exercise directly.
              <div className="mt-3">
                <label className="block text-[11px] font-semibold text-gray-500 uppercase mb-1">New scenario name</label>
                <input
                  data-testid="new-scenario-name-input"
                  value={newScenarioName}
                  onChange={(e) => setNewScenarioName(e.target.value)}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-indigo-300"
                  placeholder="e.g. Structure Fire (v2)"
                />
              </div>
            </div>
            <div className="p-5 pt-0 flex flex-col gap-2">
              <Button
                data-testid="activate-save-new-scenario"
                className="w-full bg-indigo-600 hover:bg-indigo-700 text-white font-bold"
                onClick={saveAsNewScenarioThenActivate}
                disabled={savingAsScenario}
              >
                {savingAsScenario ? 'Saving…' : 'Save as new scenario & Activate'}
              </Button>
              <Button
                data-testid="activate-without-saving"
                variant="outline"
                className="w-full font-bold"
                onClick={activateNow}
                disabled={savingAsScenario}
              >
                Activate without saving
              </Button>
              <button
                data-testid="activate-cancel"
                className="w-full text-[12px] text-gray-400 hover:text-gray-600 py-1"
                onClick={() => setActivatePrompt(false)}
                disabled={savingAsScenario}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Manual Notification Modal */}
      <IncidentLocationMappingModal
        isOpen={showLocationMappingModal}
        incident={incident}
        locations={locations}
        onClose={() => setShowLocationMappingModal(false)}
        onMapped={async () => {
          await Promise.all([fetchLocations(), fetchIncidentDetail(true)]);
        }}
      />

      {showManualNotificationModal && !isIncidentReadOnly && (
        <ManualNotificationModal
          isOpen={showManualNotificationModal}
          onClose={() => { setShowManualNotificationModal(false); setEditingManualNotification(null); setConditionalContext(null); }}
          incident={incident}
          onlineUserIds={onlineParticipantIds}
          presenceByUserId={mobilePresenceByUser}
          allowedRecipientUserIds={scopedRecipientScope?.userIds ?? null}
          allowedRecipientDepartmentIds={scopedRecipientScope?.departmentIds ?? null}
          allowedRecipientTeamIds={scopedRecipientScope?.teamIds ?? null}
          allowedRecipientCrewIds={scopedRecipientScope?.crewIds ?? null}
          scenarioStaffingDefaults={scenarioMode ? scenarioStaffingDefaults : null}
          onRoleCatalogUpsert={scenarioMode ? upsertScenarioRequiredRole : null}
          editingItem={editingManualNotification}
          conditionalContext={conditionalContext}
          onAddConditional={handleAddConditionalFromModal}
          isAdmin={isContextAdmin}
          managedDepartmentIds={managedDepartmentIds}
          userRoleMap={userRoleMap}
          onSubmit={async () => {
            await fetchTimelineData();
            // Trigger timeline refresh event for IncidentTimeline component
            window.dispatchEvent(new Event('timelineRefresh'));
            setEditingManualNotification(null);
          }}
        />
      )}


      {/* Conditional follow-up picker (trigger + card type) */}
      {conditionalPicker && (
        <ConditionalInjectPicker
          sourceItem={conditionalPicker.sourceItem}
          sourceTaskIndex={conditionalPicker.sourceTaskIndex}
          onCancel={() => setConditionalPicker(null)}
          onConfirm={openConditionalTarget}
        />
      )}

      {/* Notification Edit Modal */}
      {showNotificationModal && editingNotification && !isIncidentReadOnly && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50" onClick={() => setShowNotificationModal(false)}>
          <div className="bg-white rounded-lg shadow-xl w-full max-w-md m-4" onClick={(e) => e.stopPropagation()}>
            {/* Header */}
            <div className="flex items-center justify-between p-6 border-b">
              <h2 className="text-xl font-semibold">Edit Notification</h2>
              <button onClick={() => setShowNotificationModal(false)} className="text-gray-400 hover:text-gray-600">
                <X className="h-5 w-5" />
              </button>
            </div>

            {/* Content */}
            <div className="p-6 space-y-4">
              {/* Duty Status Checkbox */}
              <div className="border border-gray-200 rounded-lg p-4 bg-gray-50">
                <label className="flex items-center space-x-3 cursor-pointer">
                  <input
                    type="checkbox"
                    checked={editingNotification.meta?.offDuty || false}
                    onChange={(e) => {
                      setEditingNotification({
                        ...editingNotification,
                        meta: {
                          ...editingNotification.meta,
                          offDuty: e.target.checked
                        }
                      });
                    }}
                    className="w-5 h-5 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
                  />
                  <div>
                    <span className="text-sm font-medium text-gray-900">Mark as Off Duty</span>
                    <p className="text-xs text-gray-500 mt-0.5">
                      Check this if the user was off duty at notification time
                    </p>
                  </div>
                </label>
              </div>

              {/* Off Duty Warning */}
              {editingNotification.meta?.offDuty && (
                <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-3">
                  <p className="text-sm text-yellow-800">
                    ⚠️ This notification will be marked as "Skipped" because the user is off duty.
                  </p>
                </div>
              )}

              {/* Acknowledgment Section - Show if NOT off duty OR if forced */}
              {(!editingNotification.meta?.offDuty || editingNotification.meta?.forced) && (
                <div className="border border-gray-200 rounded-lg p-4 bg-blue-50">
                  <div className="flex items-center justify-between mb-3">
                    <div>
                      <h3 className="text-sm font-semibold text-gray-900">Acknowledgment</h3>
                      <p className="text-xs text-gray-500 mt-0.5">
                        Mark when the user acknowledges this notification
                      </p>
                    </div>
                    {editingNotification.meta?.acknowledgedAt ? (
                      <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-green-100 text-green-800">
                        ✅ Acknowledged
                      </span>
                    ) : (
                      <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-yellow-100 text-yellow-800">
                        ⏳ Pending
                      </span>
                    )}
                  </div>

                  {editingNotification.meta?.acknowledgedAt ? (
                    <div className="text-sm text-gray-700">
                      <p><strong>Acknowledged at:</strong> {new Date(editingNotification.meta.acknowledgedAt).toLocaleString()}</p>
                      <Button
                        variant="outline"
                        size="sm"
                        className="mt-2"
                        onClick={() => {
                          setEditingNotification({
                            ...editingNotification,
                            meta: {
                              ...editingNotification.meta,
                              acknowledgedAt: null
                            }
                          });
                        }}
                      >
                        Clear Acknowledgment
                      </Button>
                    </div>
                  ) : (
                    <Button
                      className="w-full bg-green-600 hover:bg-green-700"
                      onClick={() => {
                        setEditingNotification({
                          ...editingNotification,
                          meta: {
                            ...editingNotification.meta,
                            acknowledgedAt: new Date().toISOString()
                          }
                        });
                      }}
                    >
                      ✓ Acknowledge Now
                    </Button>
                  )}
                </div>
              )}
            </div>

            {/* Footer */}
            <div className="flex justify-end gap-3 p-6 border-t bg-gray-50">
              <Button
                variant="outline"
                onClick={() => {
                  setShowNotificationModal(false);
                  setEditingNotification(null);
                }}
              >
                Cancel
              </Button>
              <Button
                disabled={loading}
                onClick={async () => {
                  // Prevent multiple saves
                  if (loading) return;
                  setLoading(true);

                  try {
                    // Build change history entries
                    const originalMeta = editingNotification._originalMeta || {};
                    const updatedMeta = { ...editingNotification.meta };
                    const newHistoryEntries = [];

                    // Track duty status change (only if boolean value changed)
                    if (editingNotification.meta?.offDuty !== originalMeta.offDuty) {
                      const action = editingNotification.meta?.offDuty ? 'marked as off duty' : 'marked as on duty';
                      newHistoryEntries.push({
                        actor: 'Admin',
                        action: action,
                        timestamp: new Date().toISOString()
                      });
                    }

                    // Track acknowledgment change (only check existence, not timestamp value)
                    const wasAcknowledged = originalMeta.acknowledgedAt != null;
                    const isAcknowledged = editingNotification.meta?.acknowledgedAt != null;

                    if (isAcknowledged !== wasAcknowledged) {
                      if (isAcknowledged && !wasAcknowledged) {
                        // Changed from not acknowledged to acknowledged
                        newHistoryEntries.push({
                          actor: 'Admin',
                          action: 'acknowledged',
                          timestamp: new Date().toISOString()
                        });
                      } else if (!isAcknowledged && wasAcknowledged) {
                        // Changed from acknowledged to not acknowledged
                        newHistoryEntries.push({
                          actor: 'Admin',
                          action: 'acknowledgment removed',
                          timestamp: new Date().toISOString()
                        });
                      }
                    }

                    // Add new history entries with deduplication
                    if (newHistoryEntries.length > 0) {
                      const existingHistory = updatedMeta.history || [];

                      // Deduplicate: remove any exact duplicates based on action + actor + similar timestamp
                      const dedupedHistory = [];
                      const seenEntries = new Set();

                      // First, add all existing entries (deduplicated)
                      for (const entry of existingHistory) {
                        const key = `${entry.action}|${entry.actor}|${new Date(entry.timestamp).getTime()}`;
                        if (!seenEntries.has(key)) {
                          seenEntries.add(key);
                          dedupedHistory.push(entry);
                        }
                      }

                      // Then, add new entries (but only if not duplicates of existing)
                      for (const newEntry of newHistoryEntries) {
                        const newKey = `${newEntry.action}|${newEntry.actor}|${new Date(newEntry.timestamp).getTime()}`;
                        // Check if similar entry exists (within 5 seconds)
                        let isDuplicate = false;
                        for (const existingEntry of dedupedHistory) {
                          const existingKey = `${existingEntry.action}|${existingEntry.actor}`;
                          const newKeyPrefix = `${newEntry.action}|${newEntry.actor}`;
                          const timeDiff = Math.abs(new Date(newEntry.timestamp).getTime() - new Date(existingEntry.timestamp).getTime());

                          if (existingKey === newKeyPrefix && timeDiff < 5000) {
                            isDuplicate = true;
                            break;
                          }
                        }

                        if (!isDuplicate) {
                          dedupedHistory.push(newEntry);
                        }
                      }

                      updatedMeta.history = dedupedHistory;
                    }

                    const data = {
                      meta: updatedMeta
                    }


                    const response = await CommanServices.updateIncidentTimeline(incident.id, editingNotification.id, data);

                    if (response.status) {
                      // Refresh timeline data
                      await fetchTimelineData();
                      window.dispatchEvent(new Event('timelineRefresh'));
                      setShowNotificationModal(false);
                      setEditingNotification(null);
                    }
                  } catch (error) {
                    console.error('Error updating notification:', error);
                    alert('Failed to update notification: ' + (error.response?.data?.detail || error.message));
                  } finally {
                    setLoading(false);
                  }
                }}
              >
                {loading ? 'Saving...' : 'Save Changes'}
              </Button>
            </div>
          </div>
        </div>
      )}
      {isAdmin && !scenarioMode && !incident?.is_scenario && (
        <IncidentReadinessPanel incident={incident} sendDisabled={isReadinessClosed} onlineUserIds={onlineParticipantIds} presenceByUserId={mobilePresenceByUser} />
      )}
      {/* 12.2 — Private 1:1 DM Modal */}
      <PrivateChatModal
        isOpen={dmOpen}
        onClose={() => { setDmOpen(false); setDmTargetUser(null); }}
        currentUser={currentUser}
        targetUser={dmTargetUser}
        incidentId={incident?.id}
        displayIncidentId={incident?.incident_id}
        incidentTitle={incident?.incident_id || incident?.incident_type}
        roomId={dmTargetUser?.room}
      />

    </div>
  );
};

// Exercise and scenario planning

const PlanningTabContent = ({
  incident,
  isAdmin,
  canChangeDrillStatus = isAdmin,
  canManageOperationalRoles = isAdmin,
  allDepartments,
  onRefresh,
  onDepartmentsSync,
  locations = [],
  onOpenLocationMapping = null,
  onExerciseTransition = null,
  onRequestActivate = null,
  unstaffedInjectCount = 0,
  scenarioMode = false,
  scenarioId = '',
  scenarioAutoActivateOnMatch = false,
  scenarioAutoActivateReadinessWindowMinutes = 5,
  onPersistScenarioActivationPolicy = null,
  hideTimeline = false,
  inlineStaffingAvailable = false,
  onOpenQuickAssign = null,
}) => {
  // scenario env = scenario route OR the scenario's backing incident
  const scenarioEnv = scenarioMode || !!incident?.is_scenario;
  const [activeWindowIndex, setActiveWindowIndex] = useState(0);
  const [transitioning, setTransitioning] = useState(null);
  const [savingScenario, setSavingScenario] = useState(false);
  const [savingActivationPolicy, setSavingActivationPolicy] = useState(false);
  const [showAutoActivateConfirmation, setShowAutoActivateConfirmation] = useState(false);
  const saveActivationPolicy = async ({ enabled, readinessWindowMinutes, status }) => {
    if (!onPersistScenarioActivationPolicy) return;
    setSavingActivationPolicy(true);
    try {
      await onPersistScenarioActivationPolicy({ enabled, readinessWindowMinutes, status });
    } finally {
      setSavingActivationPolicy(false);
    }
  };
  const handleSaveScenario = async () => {
    if (!scenarioId) { toast.success('Scenario saved'); return; }
    setSavingScenario(true);
    try {
      const res = await CommanServices.syncScenario(scenarioId);
      if (res?.status !== false) {
        await saveActivationPolicy({
          enabled: scenarioAutoActivateOnMatch,
          readinessWindowMinutes: scenarioAutoActivateReadinessWindowMinutes,
          status: 'Active',
        });
        toast.success('Scenario saved — now available in the library');
        onRefresh?.();
      } else {
        toast.error(res?.message || 'Failed to save scenario');
      }
    } catch (e) {
      toast.error('Failed to save scenario');
    } finally {
      setSavingScenario(false);
    }
  };
  const [isEditing, setIsEditing] = useState(false);
  const [editedTitle, setEditedTitle] = useState('');
  const [editedDesc, setEditedDesc] = useState('');
  const [editedLocation, setEditedLocation] = useState([]);
  const [editedDepartments, setEditedDepartments] = useState([]);
  const [isEditingSchedule, setIsEditingSchedule] = useState(false);
  const [scheduleEditWindows, setScheduleEditWindows] = useState([]);
  const [isUpdating, setIsUpdating] = useState(false);
  const [hasAutoSwitched, setHasAutoSwitched] = useState(false);
  const manualImpactedDepartmentsRef = useRef(new Set());
  const [incidentTypes, setIncidentTypes] = useState([]);
  const [classificationEvents, setClassificationEvents] = useState([]);
  const [classificationTriggers, setClassificationTriggers] = useState([]);
  const [editedTypeId, setEditedTypeId] = useState('');
  const [editedEventId, setEditedEventId] = useState('none');
  const [editedTriggerId, setEditedTriggerId] = useState('none');
  const [editedExerciseClass, setEditedExerciseClass] = useState('');
  const [editedSeverity, setEditedSeverity] = useState('Medium');
  const [typeSearch, setTypeSearch] = useState('');
  const [eventSearch, setEventSearch] = useState('');
  const [triggerSearch, setTriggerSearch] = useState('');
  const [showCorrectionConfirmation, setShowCorrectionConfirmation] = useState(false);
  const [pendingCorrectionChanges, setPendingCorrectionChanges] = useState([]);
  const [pendingCorrectionContext, setPendingCorrectionContext] = useState(null);
  const [correctionReason, setCorrectionReason] = useState('');

  const isRealIncident = Boolean(
    incident
    && !scenarioMode
    && !incident.is_exercise
    && !incident.is_scenario
    && !incident.is_planned_event
  );
  const correctionLockReason = isRealIncident
    ? realIncidentCorrectionLockReason(incident)
    : '';
  const canEditCoreDefinition = !isRealIncident
    || canCorrectRealIncidentReport(incident, isAdmin);

  const syncEditedClassificationFromIncident = useCallback(() => {
    setEditedTypeId(incident?.type_id || '');
    setEditedEventId(incident?.event_id || 'none');
    setEditedTriggerId(incident?.trigger_id || 'none');
    setTypeSearch('');
    setEventSearch('');
    setTriggerSearch('');
  }, [incident?.type_id, incident?.event_id, incident?.trigger_id]);

  const fetchIncidentTypes = useCallback(async () => {
    try {
      const response = await CommanServices.incidentClassifications();
      if (response.status) {
        const data = await response.data;
        setIncidentTypes(
          (Array.isArray(data) ? data : []).map((entry) => ({
            ...entry,
            id: entry.id || entry._id,
          }))
        );
      }
    } catch (error) {
      console.error('Error fetching incident types:', error);
      setIncidentTypes([]);
    }
  }, []);

  const fetchClassificationBundle = useCallback(async (typeId) => {
    if (!typeId) {
      setClassificationEvents([]);
      setClassificationTriggers([]);
      return;
    }
    try {
      const response = await CommanServices.getincidentclassificationtypes(typeId);
      if (response.status) {
        const bundle = await response.data;
        setClassificationEvents(
          (bundle.events || []).map((entry) => ({
            ...entry,
            id: entry.id || entry._id,
          }))
        );
        setClassificationTriggers(
          (bundle.triggers || []).map((entry) => ({
            ...entry,
            id: entry.id || entry._id,
          }))
        );
      } else {
        setClassificationEvents([]);
        setClassificationTriggers([]);
      }
    } catch (error) {
      console.error('Error fetching classification bundle:', error);
      setClassificationEvents([]);
      setClassificationTriggers([]);
    }
  }, []);

  useEffect(() => {
    if (isAdmin) {
      fetchIncidentTypes();
    }
  }, [isAdmin, fetchIncidentTypes]);

  useEffect(() => {
    if (!isAdmin || !editedTypeId) {
      if (!editedTypeId) {
        setClassificationEvents([]);
        setClassificationTriggers([]);
      }
      return;
    }
    fetchClassificationBundle(editedTypeId);
  }, [isAdmin, editedTypeId, fetchClassificationBundle]);

  useEffect(() => {
    if (isEditing) return;
    syncEditedClassificationFromIncident();
  }, [incident?.id, incident?.type_id, incident?.event_id, incident?.trigger_id, isEditing, syncEditedClassificationFromIncident]);

  const filteredIncidentTypes = useMemo(() => {
    const query = typeSearch.trim().toLowerCase();
    return incidentTypes.filter((entry) =>
      (entry.incident_type || '').toLowerCase().includes(query)
    );
  }, [incidentTypes, typeSearch]);

  const filteredClassificationEvents = useMemo(() => {
    const query = eventSearch.trim().toLowerCase();
    return classificationEvents.filter((entry) =>
      (entry.name || '').toLowerCase().includes(query)
    );
  }, [classificationEvents, eventSearch]);

  const filteredClassificationTriggers = useMemo(() => {
    const baseTriggers = editedEventId === 'none'
      ? classificationTriggers
      : classificationTriggers.filter(
          (entry) => String(entry.event_id) === String(editedEventId)
        );
    const query = triggerSearch.trim().toLowerCase();
    return baseTriggers.filter((entry) =>
      (entry.name || '').toLowerCase().includes(query)
    );
  }, [classificationTriggers, editedEventId, triggerSearch]);

  const resetEditedScopeFromIncident = useCallback(() => {
    if (!incident) return;
    const rawTitle = incident.title || '';
    setEditedTitle(rawTitle.replace(/Reported by Anonymous/i, `Reported by ${incident.created_by_name || incident.reporter_name || 'System'}`));
    setEditedDesc(incident.description || '');
    setEditedLocation(incident.location || []);
    const initialDepts = Array.isArray(incident.impacted_departments)
      ? incident.impacted_departments.map((entry) => (typeof entry === 'object' ? (entry.id || entry._id) : entry))
      : [];
    manualImpactedDepartmentsRef.current = new Set(initialDepts.map(String));
    setEditedDepartments(
      syncImpactedDepartments(incident.location || [], manualImpactedDepartmentsRef.current, locations, allDepartments)
    );
    setEditedExerciseClass(incident.exercise_classification || '');
    setEditedSeverity(incident.severity || 'Medium');
    syncEditedClassificationFromIncident();
  }, [incident, locations, allDepartments, syncEditedClassificationFromIncident]);

  // Allow opening the scope editor from the Report & Detection timeline card (pen icon).
  useEffect(() => {
    const handler = () => {
      if (!isAdmin) return;
      manualImpactedDepartmentsRef.current = new Set(editedDepartments.map(String));
      setEditedExerciseClass(incident?.exercise_classification || '');
      setEditedSeverity(incident?.severity || 'Medium');
      syncEditedClassificationFromIncident();
      setIsEditing(true);
      setTimeout(() => {
        document.getElementById('exercise-scope-editor')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }, 100);
    };
    window.addEventListener('openExerciseScopeEdit', handler);
    return () => window.removeEventListener('openExerciseScopeEdit', handler);
  }, [incident, isAdmin, editedDepartments, syncEditedClassificationFromIncident]);

  useEffect(() => {
    if (incident && !hasAutoSwitched) {
      const rawTitle = incident.title || '';
      setEditedTitle(rawTitle.replace(/Reported by Anonymous/i, `Reported by ${incident.created_by_name || incident.reporter_name || 'System'}`));
      setEditedDesc(incident.description || '');
      setEditedLocation(incident.location || []);
      const initialDepts = Array.isArray(incident.impacted_departments)
        ? incident.impacted_departments.map(d => typeof d === 'object' ? (d.id || d._id) : d)
        : [];
      manualImpactedDepartmentsRef.current = new Set(initialDepts.map(String));
      setEditedDepartments(
        syncImpactedDepartments(incident.location || [], manualImpactedDepartmentsRef.current, locations, allDepartments)
      );
      syncEditedClassificationFromIncident();
      setHasAutoSwitched(true);
    }
  }, [incident, hasAutoSwitched]);

  useEffect(() => {
    if (!incident?.id || isEditing) return;
    const synced = normalizeDepartmentIds(incident.impacted_departments);
    manualImpactedDepartmentsRef.current = new Set(synced);
    setEditedDepartments(synced);
  }, [incident?.id, incident?.impacted_departments, isEditing]);

  useEffect(() => {
    if (!isEditing) return;
    const synced = syncImpactedDepartments(
      editedLocation,
      manualImpactedDepartmentsRef.current,
      locations,
      allDepartments
    );
    setEditedDepartments((prev) => {
      const current = prev.map(String).sort().join(',');
      const next = synced.map(String).sort().join(',');
      if (current === next) return prev;
      return synced;
    });
  }, [isEditing, editedLocation, locations, allDepartments]);

  const handleEditedLocationChange = async (value) => {
    setEditedLocation(value);
    const synced = syncImpactedDepartments(
      value,
      manualImpactedDepartmentsRef.current,
      locations,
      allDepartments
    );
    const distributionList = syncDistributionListWithDepartments(
      synced,
      incident?.distribution_list,
      allDepartments
    );
    setEditedDepartments(synced);
    // Real-incident scope changes stay local until the protected correction
    // (if any) is confirmed and accepted by the incident PATCH endpoint.
    if (onDepartmentsSync && !isRealIncident) {
      setIsUpdating(true);
      try {
        await onDepartmentsSync({ impactedDepartments: synced, distributionList });
      } finally {
        setIsUpdating(false);
      }
    }
  };

  const handleEditedDepartmentsChange = async (selected) => {
    const nextManual = new Set(
      (selected || []).filter((id) => id && id !== 'undefined').map(String)
    );
    const removedIds = editedDepartments
      .map(String)
      .filter((id) => !nextManual.has(id));
    if (
      removedIds.some((id) =>
        isDepartmentLinkedToIncidentLocations(id, editedLocation, locations, allDepartments)
      )
    ) {
      toast.error('This department is linked to a location and cannot be removed.');
      return;
    }
    manualImpactedDepartmentsRef.current = nextManual;
    const synced = syncImpactedDepartments(
      editedLocation,
      manualImpactedDepartmentsRef.current,
      locations,
      allDepartments
    );
    const distributionList = syncDistributionListWithDepartments(
      synced,
      incident?.distribution_list,
      allDepartments
    );
    setEditedDepartments(synced);
    if (onDepartmentsSync && !isRealIncident) {
      setIsUpdating(true);
      try {
        await onDepartmentsSync({ impactedDepartments: synced, distributionList });
      } finally {
        setIsUpdating(false);
      }
    }
  };

  const handleRemoveDepartmentFromScope = async (deptId) => {
    const id = String(deptId);
    if (isDepartmentLinkedToIncidentLocations(id, editedLocation, locations, allDepartments)) {
      toast.error('This department is linked to a location and cannot be removed.');
      return;
    }
    const nextManual = new Set(
      [...manualImpactedDepartmentsRef.current].filter((existingId) => String(existingId) !== id)
    );
    manualImpactedDepartmentsRef.current = nextManual;
    const synced = syncImpactedDepartments(
      editedLocation,
      nextManual,
      locations,
      allDepartments
    );
    const distributionList = syncDistributionListWithDepartments(
      synced,
      incident?.distribution_list,
      allDepartments
    );
    setEditedDepartments(synced);
    if (onDepartmentsSync && !isRealIncident) {
      setIsUpdating(true);
      try {
        await onDepartmentsSync({ impactedDepartments: synced, distributionList });
      } finally {
        setIsUpdating(false);
      }
    }
  };

  const windows = incident?.planned_windows || [];
  const departments = normalizeDepartmentIds(incident?.impacted_departments);

  const startScheduleEdit = () => {
    const initial = (incident.planned_windows || []).length
      ? incident.planned_windows.slice(0, 1).map((w) => ({
          start: toLocalDateTimeInput(w.start),
          end: toLocalDateTimeInput(w.end),
          end_open: !!w.end_open || (!w.end && !!incident.is_exercise),
        }))
      : [{ start: getLocalDateTimeInputValue(), end: getLocalDateTimeInputValue(), end_open: false }];
    setScheduleEditWindows(initial);
    setIsEditingSchedule(true);
  };

  const handleUpdateSchedule = async () => {
    const validationError = validatePlannedWindows(scheduleEditWindows);
    if (validationError) {
      toast.error(validationError);
      return;
    }
    try {
      setIsUpdating(true);
      const normalizedWindows = scheduleEditWindows.map((w) => ({
        start: localDateTimeToISO(w.start),
        end: w.end_open ? null : localDateTimeToISO(w.end),
        end_open: !!w.end_open,
      }));
      const res = await CommanServices.updatePatchIncidents(incident.id, {
        planned_windows: normalizedWindows,
      });
      if (res) {
        onRefresh();
        setIsEditingSchedule(false);
        toast.success('Schedule updated');
      }
    } catch (error) {
      console.error('Error updating schedule:', error);
      toast.error('Failed to update schedule');
    } finally {
      setIsUpdating(false);
    }
  };

  const resolveDeptName = (id) => {
    if (!id || id === 'undefined') return "Unassigned Unit";
    const dept = allDepartments?.find(d => d.id === id);
    return dept ? dept.department_name : id;
  };

  const prepareDetailsUpdate = () => {
    if (!editedTypeId) {
      toast.error('Incident Type is required.');
      return null;
    }
    if (
      editedEventId !== 'none'
      && editedEventId
      && !classificationEvents.some((entry) => String(entry.id) === String(editedEventId))
    ) {
      toast.error('Select a valid Event.');
      return null;
    }
    const allowedTriggers = editedEventId === 'none'
      ? classificationTriggers
      : classificationTriggers.filter((entry) => String(entry.event_id) === String(editedEventId));
    if (
      editedTriggerId !== 'none'
      && editedTriggerId
      && !allowedTriggers.some((entry) => String(entry.id) === String(editedTriggerId))
    ) {
      toast.error('Select a valid Trigger.');
      return null;
    }

    const eventId = editedEventId === 'none' ? '' : editedEventId;
    const triggerId = editedTriggerId === 'none' ? '' : editedTriggerId;
    const hasRealLocation = editedLocation.length > 0 && !editedLocation.includes('unknown');
    const syncedDepartments = syncImpactedDepartments(
      editedLocation,
      manualImpactedDepartmentsRef.current,
      locations,
      allDepartments
    );
    const syncedDistribution = syncDistributionListWithDepartments(
      syncedDepartments,
      incident?.distribution_list,
      allDepartments
    );
    const selectedType = incidentTypes.find((entry) => String(entry.id) === String(editedTypeId));
    const selectedEvent = classificationEvents.find((entry) => String(entry.id) === String(eventId));
    const selectedTrigger = classificationTriggers.find((entry) => String(entry.id) === String(triggerId));
    const typeChanged = String(editedTypeId) !== String(incident?.type_id || '');
    const resolvedTitle = typeChanged && selectedType?.incident_type
      ? buildRequestTitle(selectedType.incident_type, incident)
      : editedTitle;
    const locationNames = editedLocation
      .filter((locationId) => locationId && locationId !== 'unknown')
      .map((locationId) => {
        const location = locations.find((entry) => String(entry.id || entry._id) === String(locationId));
        return location?.zone_name || location?.auto_label || location?.location_name || location?.name || String(locationId);
      });
    const nextUnknownLocation = editedLocation.includes('unknown')
      || (!editedLocation.length && Boolean(incident?.is_unknown_location));
    const definitionPayload = {
      type_id: editedTypeId,
      incident_type: selectedType?.incident_type || incident?.incident_type || '',
      event_id: eventId,
      event: selectedEvent?.name || '',
      trigger_id: triggerId,
      trigger: selectedTrigger?.name || '',
      severity: incident?.severity,
      location: editedLocation,
      location_names: locationNames,
      is_unknown_location: nextUnknownLocation,
    };

    return {
      hasRealLocation,
      syncedDepartments,
      syncedDistribution,
      resolvedTitle,
      eventId,
      triggerId,
      definitionRevision: Number(incident?.definition_revision || 0),
      correctionChanges: isRealIncident
        ? buildIncidentDefinitionChanges(incident, definitionPayload)
        : [],
    };
  };

  const persistDetailsUpdate = async (context, reason = '') => {
    if (!context || !isAdmin) return;
    const hasProtectedCorrection = isRealIncident && context.correctionChanges.length > 0;
    if (hasProtectedCorrection && !canCorrectRealIncidentReport(incident, isAdmin)) {
      toast.error(realIncidentCorrectionLockReason(incident) || 'Incident classification is locked.');
      setShowCorrectionConfirmation(false);
      setPendingCorrectionContext(null);
      return;
    }
    const normalizedReason = String(reason || '').trim();
    if (hasProtectedCorrection && !normalizedReason) {
      toast.error('Enter a reason for this correction.');
      return;
    }

    try {
      setIsUpdating(true);
      // Preserve the existing exercise/scenario workflow. Real incidents defer
      // department/distribution persistence until the protected PATCH succeeds.
      if (onDepartmentsSync && !isRealIncident) {
        await onDepartmentsSync({
          impactedDepartments: context.syncedDepartments,
          distributionList: context.syncedDistribution,
        });
      }

      const res = await CommanServices.updatePatchIncidents(incident.id, {
        title: context.resolvedTitle,
        description: editedDesc,
        location: editedLocation,
        impacted_departments: context.syncedDepartments,
        type_id: editedTypeId,
        event_id: context.eventId,
        trigger_id: context.triggerId,
        ...(incident?.is_exercise ? { exercise_classification: editedExerciseClass || '', severity: editedSeverity } : {}),
        ...(context.hasRealLocation ? { is_unknown_location: false } : {}),
        ...(hasProtectedCorrection ? {
          correction_reason: normalizedReason,
          correction_expected_revision: context.definitionRevision,
        } : {}),
      });
      if (res?.status === false) {
        throw new Error(res?.message || res?.data?.detail || 'Failed to update event details');
      }

      if (onDepartmentsSync && isRealIncident) {
        try {
          await onDepartmentsSync({
            impactedDepartments: context.syncedDepartments,
            distributionList: context.syncedDistribution,
          });
        } catch (syncError) {
          console.error('Incident correction saved, but department distribution sync failed:', syncError);
          toast.warning('Incident correction saved; refresh if the department distribution does not update immediately.');
        }
      }

      toast.success(isRealIncident ? 'Incident details updated' : 'Exercise details updated');
      onRefresh();
      window.dispatchEvent(new Event('timelineRefresh'));
      setIsEditing(false);
      setShowCorrectionConfirmation(false);
      setPendingCorrectionChanges([]);
      setPendingCorrectionContext(null);
      setCorrectionReason('');
    } catch (error) {
      console.error('Error updating details:', error);
      toast.error(error?.response?.data?.detail || error?.message || 'Failed to update event details');
    } finally {
      setIsUpdating(false);
    }
  };

  const handleUpdateDetails = async () => {
    if (!isAdmin) return;
    const context = prepareDetailsUpdate();
    if (!context) return;

    if (isRealIncident && context.correctionChanges.length > 0) {
      if (!canCorrectRealIncidentReport(incident, isAdmin)) {
        toast.error(realIncidentCorrectionLockReason(incident) || 'Incident classification is locked.');
        return;
      }
      setPendingCorrectionChanges(context.correctionChanges);
      setPendingCorrectionContext(context);
      setCorrectionReason('');
      setShowCorrectionConfirmation(true);
      return;
    }

    await persistDetailsUpdate(context);
  };

  return (
    <div className="space-y-6 max-w-[1600px] mx-auto">
      {/* TOP ACTION BAR - Phase Indicator & Admin Controls */}
      <div className="flex flex-col md:flex-row md:items-center justify-between bg-white p-4 rounded-xl shadow-sm border border-gray-100 gap-4">
        <div className="flex items-center gap-4">
          <div className="p-3 bg-blue-50 rounded-xl">
            <ClipboardList className="w-6 h-6 text-blue-600" />
          </div>
          <div>
            <h2 className="text-base font-extrabold text-gray-900 uppercase tracking-tight">
              {scenarioEnv ? 'Design the disaster simulation scenario' : 'Simulation Planning & Coordination'}
            </h2>
            <div className="flex items-center gap-2 mt-0.5">
              <p className="text-[11px] text-gray-500 font-medium">
                {scenarioEnv
                  ? 'Set the injection timeline, roles and objective — then Save to publish it to your library.'
                  : 'Review the simulation scenario, coordinate the plan discussion group.'}
              </p>
            </div>
          </div>
        </div>

        {scenarioMode ? (
          <div className="flex flex-wrap items-center justify-end gap-2">
            <Button
              data-testid="scenario-save-btn"
              className="bg-emerald-600 hover:bg-emerald-700 text-white font-bold text-[11px] h-9 gap-2 px-8 shadow-md"
              onClick={handleSaveScenario}
              disabled={savingScenario || savingActivationPolicy}
            >
              <Save className="w-4 h-4" /> {savingScenario ? 'SAVING...' : 'SAVE'}
            </Button>
          </div>
        ) : canChangeDrillStatus && (
          <div className="flex gap-2">
            {incident?.is_exercise && !incident?.is_scenario && incident.status === 'requested' && (
              <>
                {canManageOperationalRoles && !inlineStaffingAvailable && (
                  <Button
                    variant="outline"
                    data-testid="exercise-staffing-readiness-btn"
                    className="border-cyan-300 text-cyan-700 hover:bg-cyan-50 font-bold text-[11px] h-9 gap-2 px-4"
                    onClick={onOpenQuickAssign}
                  >
                    <Users className="w-4 h-4" /> STAFFING
                  </Button>
                )}
                <Button
                  data-testid="exercise-activate-btn"
                  className="bg-emerald-600 hover:bg-emerald-700 text-white font-bold text-[11px] h-9 gap-2 px-6 shadow-md"
                  onClick={async () => {
                    if (!onExerciseTransition) return;
                    const win = (incident?.planned_windows || [])[0];
                    if (!win || !win.start) {
                      toast.error('Please set the drill time first (Proposed Schedule → Edit).');
                      startScheduleEdit();
                      return;
                    }
                    if (unstaffedInjectCount > 0) {
                      toast.error(`Activation blocked — assign personnel to all roles first. ${unstaffedInjectCount} inject${unstaffedInjectCount > 1 ? 's' : ''} still need staffing.`);
                      return;
                    }
                    if (onRequestActivate) { onRequestActivate(); return; }
                    setTransitioning('active');
                    try { await onExerciseTransition('active'); } finally { setTransitioning(null); }
                  }}
                  disabled={!!transitioning}
                >
                  <Rocket className="w-4 h-4" /> {transitioning === 'active' ? 'ACTIVATING...' : 'ACTIVATE EXERCISE'}
                </Button>
              </>
            )}
          </div>
        )}
      </div>

      {scenarioMode && (
        <section
          data-testid="scenario-auto-activation-policy"
          className={`overflow-hidden rounded-2xl border shadow-sm transition-colors ${scenarioAutoActivateOnMatch
            ? 'border-amber-300 bg-gradient-to-br from-amber-50 via-white to-orange-50'
            : 'border-slate-200 bg-white'}`}
        >
          <div className="flex flex-col gap-4 p-4 sm:flex-row sm:items-center sm:justify-between sm:p-5">
            <div className="flex min-w-0 items-start gap-3">
              <span className={`inline-flex h-10 w-10 shrink-0 items-center justify-center rounded-xl ${scenarioAutoActivateOnMatch ? 'bg-amber-500 text-white shadow-md shadow-amber-200' : 'bg-slate-100 text-slate-500'}`}>
                <Timer className="h-5 w-5" />
              </span>
              <div className="min-w-0">
                <p className="text-[10px] font-black uppercase tracking-[0.18em] text-slate-400">Response plan automation</p>
                <h3 className="mt-0.5 text-sm font-extrabold text-slate-900">Auto-activate on match</h3>
                <p className="mt-1 max-w-3xl text-[11px] leading-relaxed text-slate-600">
                  Automatically staff a matching real incident, check candidate readiness, then launch the prepared response plan. If a required role is unfilled, launch waits for staffing.
                </p>
              </div>
            </div>
            <button
              type="button"
              role="switch"
              aria-checked={scenarioAutoActivateOnMatch}
              aria-label="Auto-activate matching real incidents"
              data-testid="scenario-auto-activate-toggle"
              disabled={savingActivationPolicy}
              onClick={async () => {
                if (!scenarioAutoActivateOnMatch) {
                  setShowAutoActivateConfirmation(true);
                  return;
                }
                try {
                  await saveActivationPolicy({
                    enabled: false,
                    readinessWindowMinutes: scenarioAutoActivateReadinessWindowMinutes,
                  });
                  toast.success('Automatic activation disabled');
                } catch (error) {
                  toast.error(error?.message || 'Failed to disable automatic activation');
                }
              }}
              className={`inline-flex h-10 shrink-0 items-center gap-2.5 rounded-xl border px-3 text-left transition disabled:cursor-not-allowed disabled:opacity-60 ${scenarioAutoActivateOnMatch
                ? 'border-amber-400 bg-amber-500 text-white shadow-sm hover:bg-amber-600'
                : 'border-slate-200 bg-slate-50 text-slate-600 hover:border-slate-300 hover:bg-slate-100'}`}
            >
              <span className={`relative h-5 w-9 shrink-0 rounded-full transition-colors ${scenarioAutoActivateOnMatch ? 'bg-amber-900/40' : 'bg-slate-300'}`} aria-hidden="true">
                <span className={`absolute top-0.5 h-4 w-4 rounded-full bg-white shadow transition-transform ${scenarioAutoActivateOnMatch ? 'translate-x-[18px]' : 'translate-x-0.5'}`} />
              </span>
              <span className="text-[10px] font-black uppercase tracking-[0.12em]">
                {savingActivationPolicy ? 'Saving…' : (scenarioAutoActivateOnMatch ? 'Enabled' : 'Disabled')}
              </span>
            </button>
          </div>

          {scenarioAutoActivateOnMatch && (
            <div className="border-t border-amber-200/80 bg-amber-50/70 px-4 py-3 sm:px-5" data-testid="scenario-auto-activation-window">
              <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
                <div>
                  <p className="text-[10px] font-black uppercase tracking-[0.15em] text-amber-900">Readiness &amp; cancellation window</p>
                  <p className="mt-0.5 text-[10px] text-amber-800/80">This is the only window in which an administrator can stop automatic launch.</p>
                </div>
                <div className="grid h-10 min-w-[230px] grid-cols-3 rounded-xl border border-amber-300 bg-white p-1 shadow-sm" role="group" aria-label="Automatic readiness response window">
                  {AUTO_ACTIVATE_READINESS_WINDOWS.map((minutes) => (
                    <button
                      type="button"
                      key={minutes}
                      aria-pressed={scenarioAutoActivateReadinessWindowMinutes === minutes}
                      data-testid={`scenario-auto-activation-window-${minutes}`}
                      disabled={savingActivationPolicy}
                      onClick={async () => {
                        if (scenarioAutoActivateReadinessWindowMinutes === minutes) return;
                        try {
                          await saveActivationPolicy({ enabled: true, readinessWindowMinutes: minutes });
                          toast.success(`${minutes}-minute readiness window saved`);
                        } catch (error) {
                          toast.error(error?.message || 'Failed to save readiness window');
                        }
                      }}
                      className={`inline-flex items-center justify-center rounded-lg text-[11px] font-extrabold transition disabled:cursor-not-allowed disabled:opacity-50 ${scenarioAutoActivateReadinessWindowMinutes === minutes
                        ? 'bg-amber-500 text-white shadow-sm'
                        : 'text-slate-500 hover:bg-amber-50 hover:text-amber-900'}`}
                    >
                      {minutes}m
                    </button>
                  ))}
                </div>
              </div>
            </div>
          )}
        </section>
      )}

      <AlertDialog open={showAutoActivateConfirmation} onOpenChange={(open) => !savingActivationPolicy && setShowAutoActivateConfirmation(open)}>
        <AlertDialogContent className="max-w-md">
          <AlertDialogHeader>
            <AlertDialogTitle className="flex items-center gap-2 text-slate-900">
              <Timer className="h-5 w-5 text-amber-500" />
              Enable automatic response-plan launch?
            </AlertDialogTitle>
            <AlertDialogDescription className="space-y-2 text-left text-slate-600">
              <span className="block">
                When a real incident matches this scenario, DisasterMS will automatically staff the plan and begin a {normalizeAutoActivateReadinessWindow(scenarioAutoActivateReadinessWindowMinutes)}-minute readiness check.
              </span>
              <span className="block rounded-lg border border-amber-200 bg-amber-50 px-3 py-2 text-amber-900">
                This readiness window is the only time an administrator can stop automatic launch. After it closes, a fully staffed plan activates and every planned card fires immediately.
              </span>
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel disabled={savingActivationPolicy}>Keep manual activation</AlertDialogCancel>
            <AlertDialogAction
              disabled={savingActivationPolicy}
              className="bg-amber-500 font-bold text-white hover:bg-amber-600"
              onClick={async (event) => {
                event.preventDefault();
                try {
                  await saveActivationPolicy({
                    enabled: true,
                    readinessWindowMinutes: scenarioAutoActivateReadinessWindowMinutes,
                  });
                  setShowAutoActivateConfirmation(false);
                  toast.success('Automatic activation enabled and saved');
                } catch (error) {
                  toast.error(error?.message || 'Failed to enable automatic activation');
                }
              }}
            >
              {savingActivationPolicy ? 'Saving…' : 'Enable auto-activation'}
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>

      <AlertDialog
        open={showCorrectionConfirmation}
        onOpenChange={(open) => {
          if (isUpdating) return;
          setShowCorrectionConfirmation(open);
          if (!open) {
            setPendingCorrectionChanges([]);
            setPendingCorrectionContext(null);
            setCorrectionReason('');
          }
        }}
      >
        <AlertDialogContent className="max-w-xl">
          <AlertDialogHeader>
            <AlertDialogTitle className="flex items-center gap-2 text-slate-900">
              <AlertCircle className="h-5 w-5 text-amber-500" />
              Confirm incident correction
            </AlertDialogTitle>
            <AlertDialogDescription className="text-left text-slate-600">
              These core incident facts will be audited. Confirm the old and new values, then record why the correction is needed.
            </AlertDialogDescription>
          </AlertDialogHeader>
          <div className="max-h-64 space-y-2 overflow-y-auto">
            {pendingCorrectionChanges.map((change) => (
              <div key={change.field} className="rounded-lg border border-slate-200 bg-slate-50 px-3 py-2">
                <p className="text-[10px] font-black uppercase tracking-wide text-slate-500">{change.label}</p>
                <div className="mt-1 grid grid-cols-[1fr_auto_1fr] items-center gap-2 text-xs">
                  <span className="break-words text-slate-500 line-through">{change.oldValue}</span>
                  <span className="font-bold text-slate-400">→</span>
                  <span className="break-words font-bold text-slate-900">{change.newValue}</span>
                </div>
              </div>
            ))}
          </div>
          <div>
            <label htmlFor="scope-correction-reason" className="mb-1.5 block text-[10px] font-black uppercase tracking-widest text-slate-500">
              Correction reason <span className="text-red-500">*</span>
            </label>
            <textarea
              id="scope-correction-reason"
              value={correctionReason}
              onChange={(event) => setCorrectionReason(event.target.value)}
              maxLength={500}
              rows={3}
              autoFocus
              placeholder="Explain why the original classification or location was incorrect…"
              className="w-full resize-none rounded-lg border border-slate-300 px-3 py-2 text-sm outline-none focus:border-amber-500 focus:ring-2 focus:ring-amber-100"
            />
          </div>
          <AlertDialogFooter>
            <AlertDialogCancel disabled={isUpdating}>Cancel</AlertDialogCancel>
            <AlertDialogAction
              disabled={isUpdating || !correctionReason.trim()}
              className="bg-amber-600 font-bold text-white hover:bg-amber-700"
              onClick={async (event) => {
                event.preventDefault();
                await persistDetailsUpdate(pendingCorrectionContext, correctionReason);
              }}
            >
              {isUpdating ? 'Saving…' : 'Confirm correction'}
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>

      {/* Stage stepper intentionally removed from the Requested stage per request */}

      <div className="grid grid-cols-1 gap-6 items-start">
        {/* LEFT COLUMN: INTELLIGENCE & DATA */}
        <div className="space-y-6">
          {/* 1. Request Overview Card — for exercises the read-only summary is hidden;
              admins edit these fields from the Report & Detection card (pen icon). */}
          {(!incident?.is_exercise || isEditing) && (
          <Card id="exercise-scope-editor" className="border-none shadow-md overflow-hidden bg-white">
            <CardHeader className="border-b py-4 px-6 flex flex-row items-center justify-between bg-slate-50/50">
              <CardTitle className="text-[10px] font-black flex items-center gap-2 text-gray-400 uppercase tracking-[0.1em]">
                <FileText className="w-4 h-4 text-gray-400" /> Event Data Summary
              </CardTitle>
              {isAdmin && (
                <Button variant="outline" size="sm" className={`h-7 text-[10px] font-bold border-gray-200 ${isEditing ? 'bg-blue-50 text-blue-600 border-blue-200' : ''}`} onClick={() => {
                  if (isEditing) {
                    resetEditedScopeFromIncident();
                    setIsEditing(false);
                    return;
                  }
                  manualImpactedDepartmentsRef.current = new Set(editedDepartments.map(String));
                  setEditedExerciseClass(incident.exercise_classification || '');
                  setEditedSeverity(incident.severity || 'Medium');
                  syncEditedClassificationFromIncident();
                  setIsEditing(true);
                }}>
                  {isEditing ? 'EXIT EDIT MODE' : 'EDIT SCOPE'}
                </Button>
              )}
            </CardHeader>
            <CardContent className="p-0">
              {isEditing && correctionLockReason && (
                <div className="mx-8 mt-6 flex items-start gap-2 rounded-xl border border-amber-200 bg-amber-50 px-4 py-3 text-xs text-amber-900">
                  <AlertCircle className="mt-0.5 h-4 w-4 shrink-0" />
                  <span><strong>Classification and primary location are locked.</strong> {correctionLockReason}</span>
                </div>
              )}
              <div className="p-8 grid grid-cols-1 md:grid-cols-2 gap-x-16 gap-y-10">
                {/* Left: Metadata */}
                <div className="space-y-8">
                  <div>
                    <label className="text-[10px] font-black text-gray-300 uppercase tracking-widest block mb-2">Request Title</label>
                    {isEditing ? (
                      <input
                        className="w-full text-base font-bold text-gray-900 border-b-2 border-blue-400 focus:outline-none bg-blue-50/50 px-2 py-1 rounded-t"
                        value={editedTitle}
                        onChange={(e) => setEditedTitle(e.target.value)}
                      />
                    ) : (
                      <p className="text-xl font-black text-gray-900 tracking-tight leading-none">
                        {(incident.title || 'Untitled Operation').replace(/Reported by Anonymous/i, `Reported by ${incident.created_by_name || incident.reporter_name || 'System'}`)}
                      </p>
                    )}
                  </div>
                  <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                    <div>
                      <label className="text-[10px] font-black text-gray-300 uppercase tracking-widest block mb-2">Incident Type</label>
                      {isEditing && isAdmin ? (
                        <Select
                          value={editedTypeId}
                          disabled={!canEditCoreDefinition}
                          onValueChange={(value) => {
                            setEditedTypeId(value);
                            setEditedEventId('none');
                            setEditedTriggerId('none');
                            const selectedType = incidentTypes.find((entry) => String(entry.id) === String(value));
                            if (selectedType?.incident_type) {
                              setEditedTitle(buildRequestTitle(selectedType.incident_type, incident));
                            }
                          }}
                        >
                          <SelectTrigger className="h-9 text-xs">
                            <SelectValue placeholder="Select incident type" />
                          </SelectTrigger>
                          <SelectContent className="z-50 max-h-72 overflow-y-auto">
                            <div className="sticky top-0 z-10 bg-white border-b p-2">
                              <Input
                                value={typeSearch}
                                onChange={(e) => setTypeSearch(e.target.value)}
                                onKeyDown={(e) => e.stopPropagation()}
                                placeholder="Search incident type..."
                                className="h-8"
                              />
                            </div>
                            {filteredIncidentTypes.length > 0 ? filteredIncidentTypes.map((entry) => (
                              <SelectItem key={entry.id} value={entry.id}>
                                {entry.incident_type}
                              </SelectItem>
                            )) : (
                              <SelectItem value="no-incident-type-results" disabled>
                                No result found
                              </SelectItem>
                            )}
                          </SelectContent>
                        </Select>
                      ) : (
                        <Badge className="bg-slate-900 text-white border-none text-[9px] font-black px-3 py-0.5 rounded-full">
                          {incident.incident_type || 'Not specified'}
                        </Badge>
                      )}
                    </div>
                    <div>
                      <label className="text-[10px] font-black text-gray-300 uppercase tracking-widest block mb-2">Event</label>
                      {isEditing && isAdmin ? (
                        <Select
                          value={editedEventId || 'none'}
                          onValueChange={(value) => {
                            setEditedEventId(value);
                            setEditedTriggerId('none');
                          }}
                          disabled={!canEditCoreDefinition || !editedTypeId}
                        >
                          <SelectTrigger className="h-9 text-xs">
                            <SelectValue placeholder="Select event" />
                          </SelectTrigger>
                          <SelectContent className="z-50 max-h-72 overflow-y-auto">
                            <div className="sticky top-0 z-10 bg-white border-b p-2">
                              <Input
                                value={eventSearch}
                                onChange={(e) => setEventSearch(e.target.value)}
                                onKeyDown={(e) => e.stopPropagation()}
                                placeholder="Search event..."
                                className="h-8"
                              />
                            </div>
                            <SelectItem value="none">No specific event</SelectItem>
                            {filteredClassificationEvents.map((entry) => (
                              <SelectItem key={entry.id} value={entry.id}>
                                {entry.name}
                              </SelectItem>
                            ))}
                          </SelectContent>
                        </Select>
                      ) : (
                        incident.event ? (
                          <Badge variant="outline" className="text-[9px] font-bold border-slate-200">
                            {incident.event}
                          </Badge>
                        ) : (
                          <span className="text-xs text-gray-400 italic">No specific event</span>
                        )
                      )}
                    </div>
                    <div>
                      <label className="text-[10px] font-black text-gray-300 uppercase tracking-widest block mb-2">Trigger</label>
                      {isEditing && isAdmin ? (
                        <Select
                          value={editedTriggerId || 'none'}
                          onValueChange={setEditedTriggerId}
                          disabled={!canEditCoreDefinition || !editedTypeId || editedEventId === 'none'}
                        >
                          <SelectTrigger className="h-9 text-xs">
                            <SelectValue placeholder={editedEventId === 'none' ? 'Select event first' : 'Select trigger'} />
                          </SelectTrigger>
                          <SelectContent className="z-50 max-h-72 overflow-y-auto">
                            <div className="sticky top-0 z-10 bg-white border-b p-2">
                              <Input
                                value={triggerSearch}
                                onChange={(e) => setTriggerSearch(e.target.value)}
                                onKeyDown={(e) => e.stopPropagation()}
                                placeholder="Search trigger..."
                                className="h-8"
                              />
                            </div>
                            <SelectItem value="none">No specific trigger</SelectItem>
                            {filteredClassificationTriggers.map((entry) => (
                              <SelectItem key={entry.id} value={entry.id}>
                                {entry.name}
                              </SelectItem>
                            ))}
                          </SelectContent>
                        </Select>
                      ) : (
                        <div className="flex items-center gap-1.5 text-xs font-bold text-gray-700 italic">
                          <Zap className="w-3.5 h-3.5 text-orange-400" />
                          "{incident.trigger || 'Manual'}"
                        </div>
                      )}
                    </div>
                    {incident?.is_exercise && (
                      <div>
                        <label className="text-[10px] font-black text-gray-300 uppercase tracking-widest block mb-2">Severity</label>
                        {isEditing && isAdmin ? (
                          <Select value={editedSeverity || 'Medium'} onValueChange={setEditedSeverity}>
                            <SelectTrigger className="h-9 text-xs" data-testid="edit-exercise-severity">
                              <SelectValue placeholder="Select severity" />
                            </SelectTrigger>
                            <SelectContent className="z-50">
                              {['Low', 'Medium', 'High', 'Critical'].map((s) => (
                                <SelectItem key={s} value={s}>{s}</SelectItem>
                              ))}
                            </SelectContent>
                          </Select>
                        ) : (
                          (() => {
                            const sev = incident?.severity || 'Medium';
                            const sevColor = {
                              Critical: 'bg-red-600 text-white border-red-700',
                              High: 'bg-red-500 text-white border-red-600',
                              Medium: 'bg-orange-500 text-white border-orange-600',
                              Low: 'bg-yellow-400 text-yellow-900 border-yellow-500',
                            }[sev] || 'bg-orange-500 text-white border-orange-600';
                            return (
                              <Badge className={`${sevColor} border text-[9px] font-bold px-3 py-0.5 rounded-full`}>
                                {sev}
                              </Badge>
                            );
                          })()
                        )}
                      </div>
                    )}
                    {incident?.is_exercise && (
                      <div>
                        <label className="text-[10px] font-black text-gray-300 uppercase tracking-widest block mb-2">Exercise Classification</label>
                        {isEditing && isAdmin ? (
                          <Select value={editedExerciseClass || 'none'} onValueChange={(v) => setEditedExerciseClass(v === 'none' ? '' : v)}>
                            <SelectTrigger className="h-9 text-xs" data-testid="edit-exercise-classification">
                              <SelectValue placeholder="Select classification" />
                            </SelectTrigger>
                            <SelectContent className="z-50">
                              <SelectItem value="none">Not specified</SelectItem>
                              {['Tabletop', 'Partial', 'Full-scale', 'Field', 'Joint'].map((c) => (
                                <SelectItem key={c} value={c}>{c}</SelectItem>
                              ))}
                            </SelectContent>
                          </Select>
                        ) : (
                          incident.exercise_classification ? (
                            <Badge className="bg-emerald-100 text-emerald-800 border border-emerald-300 text-[9px] font-bold px-3 py-0.5 rounded-full">
                              {incident.exercise_classification}
                            </Badge>
                          ) : (
                            <span className="text-xs text-gray-400 italic">Not specified</span>
                          )
                        )}
                      </div>
                    )}
                  </div>
                  <div>
                    <label className="text-[10px] font-black text-gray-300 uppercase tracking-widest block mb-3">Location</label>
                    <div className="flex flex-wrap gap-2">
                      {isEditing ? (
                        <div className="w-full">
                          <LocationSelector
                            mode="single"
                            value={editedLocation[0] || ''}
                            onChange={(value) => handleEditedLocationChange(value ? [value] : [])}
                            placeholder="Select affected locations..."
                            className="border-blue-100 focus:border-blue-400"
                            disabled={!canEditCoreDefinition}
                          />
                        </div>
                      ) : (
                        isUnknownIncidentLocation(incident) ? (
                          <div className="flex items-center gap-1.5 px-3 py-1.5 bg-amber-50 rounded-xl text-xs font-bold text-amber-700 border border-amber-200 shadow-sm">
                            <MapPin className="w-3 h-3 text-amber-600" /> Unknown Location (Needs Mapping)
                          </div>
                        ) : incident.location_names?.length > 0 ? (
                          incident.location_names.map((loc, i) => (
                            <div key={i} className="flex items-center gap-1.5 px-3 py-1.5 bg-slate-50 rounded-xl text-xs font-bold text-slate-600 border border-slate-100 shadow-sm">
                              <MapPin className="w-3 h-3 text-red-500" /> {loc}
                            </div>
                          ))
                        ) : (
                          <span className="text-xs text-gray-400 italic">Site-wide Coverage</span>
                        )
                      )}
                    </div>
                    {isUnknownIncidentLocation(incident) && isAdmin && (
                      <div className="mt-4 p-4 bg-amber-50 border border-amber-200 rounded-xl">
                        <div className="flex items-start gap-3 mb-4">
                          <div className="p-2 bg-amber-100 rounded-lg">
                            <MapPin className="h-4 w-4 text-amber-600" />
                          </div>
                          <div className="flex-1">
                            <p className="text-sm font-bold text-amber-900 mb-1">Unknown Location (Needs Mapping)</p>
                            <p className="text-xs text-amber-700 leading-relaxed">
                              This exercise was submitted without a mapped location. Use the description and guided search to assign a precise zone.
                            </p>
                            {incident?.evidence && (
                              <div className="mt-4 p-3 bg-white border border-amber-200 rounded-xl shadow-sm border-l-4 border-l-amber-400">
                                <h4 className="text-[10px] font-bold text-amber-600 uppercase tracking-widest mb-1 flex items-center gap-1.5">
                                  <Brain className="h-3 w-3" />
                                  Reporter's Evidence / Landmarks
                                </h4>
                                <p className="text-sm text-slate-700 italic leading-relaxed">
                                  "{incident.evidence}"
                                </p>
                              </div>
                            )}
                          </div>
                        </div>
                        <Button
                          onClick={onOpenLocationMapping}
                          disabled={!onOpenLocationMapping || !canEditCoreDefinition}
                          className="w-full bg-amber-600 hover:bg-amber-700 text-white"
                        >
                          Link/Create &amp; Map Location
                        </Button>
                      </div>
                    )}
                  </div>
                </div>

                {/* Right: Departments & Description */}
                <div className="space-y-8">
                  <div>
                    <label className="text-[10px] font-black text-gray-300 uppercase tracking-widest block mb-3">Impacted/Notified Departments</label>
                    <div className="flex flex-wrap gap-2">
                      {isEditing ? (
                        <div className="w-full space-y-2">
                          <MultiSelectDropdown
                            className="[&>.mt-2]:hidden"
                            options={allDepartments?.map(d => ({ value: d.id, label: d.department_name })) || []}
                            selectedValues={editedDepartments}
                            onChange={handleEditedDepartmentsChange}
                            placeholder="Select departments..."
                            isSearchable={true}
                          />
                          {editedDepartments.length > 0 && (
                            <div className="flex flex-wrap gap-2">
                              {editedDepartments.map((deptId) => (
                                <span
                                  key={deptId}
                                  className="inline-flex items-center gap-1.5 px-2.5 py-1 bg-indigo-50 text-indigo-700 border border-indigo-100 rounded-md text-[10px] font-bold"
                                >
                                  {resolveDeptName(deptId)}
                                  {isAdmin && (
                                    <button
                                      type="button"
                                      onClick={() => handleRemoveDepartmentFromScope(deptId)}
                                      disabled={isUpdating}
                                      className="text-indigo-400 hover:text-red-600 transition-colors"
                                      title="Remove department"
                                    >
                                      <X className="h-3 w-3" />
                                    </button>
                                  )}
                                </span>
                              ))}
                            </div>
                          )}
                        </div>
                      ) : (
                        departments.length > 0 ? (
                          departments.map((deptId, i) => (
                            <Badge key={i} className="bg-indigo-50 text-indigo-700 border-indigo-100 font-black text-[9px] px-3 py-1 rounded-md">
                              {resolveDeptName(deptId)}
                            </Badge>
                          ))
                        ) : (
                          <span className="text-xs text-gray-400 italic">Universal Distribution</span>
                        )
                      )}
                    </div>
                  </div>
                  <div>
                    <label className="text-[10px] font-black text-gray-300 uppercase tracking-widest block mb-3">Context & Scope</label>
                    {isEditing ? (
                      <textarea
                        className="w-full text-xs text-gray-600 leading-relaxed bg-white p-4 rounded-xl border-2 border-blue-100 focus:border-blue-400 focus:outline-none min-h-[120px]"
                        value={editedDesc}
                        onChange={(e) => setEditedDesc(e.target.value)}
                      />
                    ) : (
                      <p className="text-sm text-gray-600 leading-relaxed bg-slate-50/30 p-5 rounded-2xl border border-slate-100 font-medium">
                        {incident.description}
                      </p>
                    )}
                    {isEditing && (
                      <div className="flex justify-end mt-4">
                        <Button size="sm" className="bg-blue-600 hover:bg-blue-700 text-white font-bold text-xs" onClick={handleUpdateDetails} disabled={isUpdating}>
                          {isUpdating ? 'SAVING...' : 'SAVE SCOPE UPDATES'}
                        </Button>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </CardContent>
          </Card>
          )}

          {/* 2. Secondary Data Grid */}
          <div className="grid grid-cols-1 gap-6">
            {/* Scheduling Windows */}
            {!scenarioMode && (
            <Card className="border-none shadow-sm bg-white overflow-hidden">
              <CardHeader className="py-3 px-6 border-b bg-slate-50/30">
                <CardTitle className="text-[10px] font-black text-gray-400 uppercase tracking-widest flex items-center gap-2 w-full">
                  <Calendar className="w-3.5 h-3.5 text-blue-500" /> Proposed Schedule
                  {isAdmin && !isEditingSchedule && (
                    <Button
                      variant="outline"
                      size="sm"
                      data-testid="schedule-edit-btn"
                      className="ml-auto h-6 text-[9px] font-bold border-gray-200 text-blue-600 hover:bg-blue-50"
                      onClick={startScheduleEdit}
                    >
                      <Pencil className="w-3 h-3 mr-1" /> Edit
                    </Button>
                  )}
                  {isEditingSchedule && (
                    <div className="ml-auto flex gap-1">
                      <Button
                        variant="ghost"
                        size="sm"
                        className="h-6 text-[9px] font-bold text-gray-500"
                        onClick={() => setIsEditingSchedule(false)}
                        disabled={isUpdating}
                      >
                        Cancel
                      </Button>
                      <Button
                        size="sm"
                        className="h-6 text-[9px] font-bold bg-blue-600 hover:bg-blue-700 text-white"
                        onClick={handleUpdateSchedule}
                        disabled={isUpdating || !!validatePlannedWindows(scheduleEditWindows)}
                      >
                        {isUpdating ? 'Saving...' : 'Save'}
                      </Button>
                    </div>
                  )}
                </CardTitle>
              </CardHeader>
              <CardContent className="p-6 space-y-3">
                {isEditingSchedule ? (
                  <div className="space-y-4">
                    {scheduleEditWindows.map((win, idx) => (
                      <div key={idx} className="p-4 bg-gray-50 rounded-xl border border-blue-100 space-y-3">
                        <div className="flex items-center justify-between">
                          <span className="text-[10px] font-black text-blue-600 uppercase tracking-widest">Window #{idx + 1}</span>
                          {scheduleEditWindows.length > 1 && (
                            <button
                              type="button"
                              className="text-red-500 hover:text-red-700 p-1"
                              onClick={() => setScheduleEditWindows(scheduleEditWindows.filter((_, i) => i !== idx))}
                            >
                              <X className="w-4 h-4" />
                            </button>
                          )}
                        </div>
                        <div className="grid grid-cols-2 gap-4">
                          <div>
                            <label className="text-[9px] font-bold text-gray-400 uppercase mb-1 block">Start Time</label>
                            <input
                              type="datetime-local"
                              className="w-full text-xs p-2 border rounded bg-white focus:outline-none focus:border-blue-400"
                              value={win.start || ''}
                              onChange={(e) => {
                                const newWins = [...scheduleEditWindows];
                                newWins[idx] = { ...newWins[idx], start: e.target.value };
                                setScheduleEditWindows(newWins);
                              }}
                            />
                            {isPlannedStartInPast(win.start) && (
                              <p className="text-xs text-red-500 mt-1">{PAST_PLANNED_TIME_ERROR}</p>
                            )}
                          </div>
                          <div>
                            <label className="text-[9px] font-bold text-gray-400 uppercase mb-1 block">End Time</label>
                            <input
                              type="datetime-local"
                              data-testid={`schedule-end-input-${idx}`}
                              disabled={!!win.end_open}
                              className="w-full text-xs p-2 border rounded bg-white focus:outline-none focus:border-blue-400 disabled:bg-gray-100 disabled:text-gray-400"
                              value={win.end || ''}
                              onChange={(e) => {
                                const newWins = [...scheduleEditWindows];
                                newWins[idx] = { ...newWins[idx], end: e.target.value };
                                setScheduleEditWindows(newWins);
                              }}
                            />
                            {!win.end_open && isPlannedEndBeforeOrEqualStart(win.start, win.end) && (
                              <p className="text-xs text-red-500 mt-1">{PLANNED_END_BEFORE_START_ERROR}</p>
                            )}
                            <label className="mt-1.5 flex items-center gap-1.5 text-[10px] font-bold text-gray-500 uppercase cursor-pointer">
                              <input
                                type="checkbox"
                                data-testid={`schedule-open-end-${idx}`}
                                checked={!!win.end_open}
                                onChange={(e) => {
                                  const newWins = [...scheduleEditWindows];
                                  newWins[idx] = {
                                    ...newWins[idx],
                                    end_open: e.target.checked,
                                    end: e.target.checked ? '' : newWins[idx].end,
                                  };
                                  setScheduleEditWindows(newWins);
                                }}
                                className="rounded border-gray-300 text-blue-600 focus:ring-blue-500"
                              />
                              Open end (close on completion)
                            </label>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                ) : (
                  windows.length > 0 ? (
                    windows.map((win, idx) => (
                      <div key={idx} className="p-4 bg-gray-50/50 rounded-xl border border-gray-100 grid grid-cols-3 items-center hover:bg-blue-50/30 transition-colors cursor-pointer group" onClick={() => setActiveWindowIndex(idx)}>
                        <div className="flex flex-col">
                          <p className="text-[9px] font-black text-gray-400 uppercase tracking-tighter">Start Window</p>
                          <p className="text-[13px] font-bold text-gray-900 leading-tight">{formatPlannedDateTime(win.start)}</p>
                        </div>
                        <div className="justify-self-center w-auto min-w-[3.5rem] h-10 px-3 rounded-full border border-emerald-200 flex items-center justify-center bg-emerald-50 group-hover:border-emerald-300 transition-all" data-testid={`schedule-duration-${idx}`}>
                          {(win.end_open || !win.end) ? (
                            <Infinity className="w-4 h-4 text-emerald-600" />
                          ) : (
                            <span className="text-[10px] font-bold text-emerald-700 whitespace-nowrap">{formatWindowDuration(win.start, win.end) || '—'}</span>
                          )}
                        </div>
                        <div className="flex flex-col text-right">
                          <p className="text-[9px] font-black text-gray-400 uppercase tracking-tighter">End Window</p>
                          <p className="text-[13px] font-bold text-gray-900 leading-tight">{(win.end_open || !win.end) ? 'Open' : formatPlannedDateTime(win.end)}</p>
                        </div>
                      </div>
                    ))
                  ) : (
                    <div className="text-center py-6 text-gray-300 italic text-xs">No scheduling data.</div>
                  )
                )}
              </CardContent>
            </Card>
            )}
          </div>

          {incident?.is_exercise && !hideTimeline && (
            <div className="mt-6">
              <ExerciseTimelinePreview incident={incident} />
            </div>
          )}
        </div>


      </div>
    </div>
  );
};

export default IncidentDetail;
